import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Subject, forkJoin, of } from 'rxjs';
import { catchError, filter, take, takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationTypeDialogComponent } from '../application-type-dialog/application-type-dialog.component';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { HttpService } from '@core/services/http.service';
import { DataGridVO, FIXED_EST_TZ } from '@app/shared/custom-component/data-grid/data-grid.model';
import { CommonService } from '@app/shared/services/common.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { LOCK_STATUS_CODES, QUEUE_CONSTANTS } from '@app/shared/constants/queue.constants';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@app/shared/custom-component/modal/modal.component';
import { modalButtonTitles, ModalConfig, modalContent, modalHeading, errorMessages } from '@app/shared/constants/modal.model';
import { LoaderService } from '@core/services/loader.service';
import { LocalService } from '@core/services/local.service';
import { AlertService } from '@core/services/alert.service';
import { AccordionGridSection, AccordionGridSectionManager, ColumnConfig } from '@app/shared/models/accordion-grid-section.model';
import { DataGridComponent } from '@app/shared/custom-component/data-grid/data-grid.component';
import { Application, Document as AppDocument, LicenseDetails, Profile, Transaction,LicenseKindData, PaymentBreakdown } from './application-dashboard.interface';
import { AppService } from '@app/@core/services/app.service';
import { QueueStatusFilterDirective } from '@app/shared/directives/queue-status-filter.directive';
import { DashboardAdmin } from '@app/shared/directives/queue-status-filter.constant';
import { resolveQueueApplicationStatusDisplay } from '@app/shared/utils/queue-application-status-display.util';
import { comparePaymentBreakdownRows } from '@app/shared/utils/payment-breakdown-sort.util';
import {
  formatPaymentBreakdownAmount,
  formatPaymentBreakdownPrice
} from '@app/shared/utils/payment-breakdown-format.util';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InAppMessageService } from '@app/pages/in-app-message/in-app-message.service';
import { ManageProfileService } from '@app/pages/manage-profile/manage-profile.service';
import { SurrenderService } from '@app/surrender/surrender.service';
import { DataStoreService } from '@pics-core/dynamic';
import moment from 'moment';
import { DecisionRolePageService } from '../decision-role-page/decision-role-page.service';

@Component({
  standalone: false,
  selector: 'app-application-dashboard',
  templateUrl: './application-dashboard.component.html',
  styleUrls: ['./application-dashboard.component.scss']
})
export class ApplicationDashboardComponent implements OnInit, OnDestroy {
  @ViewChild('pdfPreviewModal') pdfPreviewModal: any;
  customModal: NgbModalRef;
  private destroy$ = new Subject<void>();
  private dnqAvailabilityByAppId: { [appId: string]: boolean } = {};
  private dnqAvailabilityLoading = new Set<string>();
  private deficiencyAvailabilityByAppId: { [appId: string]: boolean } = {};
  private deficiencyAvailabilityLoading = false;
  createdDateFilterOptions: string[] = [];
  createdDateFilterDates: { [year: string]: string[] } = {};
  applicationData: any;
  applicationStatus: any[] = [];
  filteredapplicationData: any[] = [];
  applicationtypes: any[] = [];
  suffixData: any[] = [];
  dashboardHeaders: any[] = [];
  visibleColumns: { [key: string]: boolean } = {};
  allColumns: any[] = [];
  showColumnChooser = false;
  showDownloadDialog = false;
  rowDownloadDialogIndex: number | null = null;
  readonly disableAppIdColumn = 'application_id';
  showAppIdFilterDialog = false;
  appIdFilterOptions: string[] = [];
  appIdFilterSelected: string[] = [];
  appIdFilterAllSelected = false;
  licenseGridRows: any[] = [];

  appTypeFilterOptions: string[] = [];
  appTypeFilterSelected: string[] = [];
  appTypeFilterAllSelected = false;
  showAppStatusFilterDialog = false;
  appStatusFilterOptions: string[] = [];
  appStatusFilterSelected: string[] = [];
  appStatusFilterAllSelected = false;
  showAppTypeFilterDialog = false;
  selectedApplicationId: string | null = null;
  showDeleteModal: boolean = false;
  loginUserRoleId: number | null = null;
  showPdfPreviewModal = false;
pdfBlobUrl: SafeResourceUrl | null = null;
private pdfBlobObjectUrl: string | null = null;
sanitizedPdfUrl: SafeResourceUrl | null = null;
originalBlobUrl: string | null = null;

  showDraftModal: boolean = false;
  draftApplication: any = null;
  showDeficiencyModal = false;
  deficiencyModalApplication: any = null;

  searchFilters = {
    application_id: '',
    application_type: '',
    created_date: '',
    submitted_date: '',
    application_status: ''
  };
  lookupMessages: any;
  lookupToast: any;
  lookupGeneric: any;
  lookupPlaceholder: any;
  searchStates = {
    application_id: false,
    application_type: false,
    created_date: false,
    submitted_date: false,
    application_status: false
  };
  showCreatedDateFilterDialog = false;
  createdDateFilterSelected: string[] = [];
  createdDateFilterAllSelected = false;
  expandedCreatedYears: { [year: string]: boolean } = {};
  showSubmittedDateFilterDialog = false;
  submittedDateFilterOptions: string[] = [];
  submittedDateFilterDates: { [year: string]: string[] } = {};
  submittedDateFilterSelected: string[] = [];
  submittedDateFilterAllSelected = false;
  expandedSubmittedYears: { [year: string]: boolean } = {};
  createdDate: string = '';
  submittedDate: string = '';

  dashboardDataGridConfig: DataGridVO = DataGridVO.create({});
  isLoading: boolean = false;
  isGeneratingPDF: boolean = false;
  activeversionid : null;
  latestLicenseExpirydate: any;

  // My Dashboard Properties
  profile: Profile = {
    name: '',
    email: '',
    registered: '',
    lastLogin: '',
    bannerHeaderName: '',
  };

  license: LicenseDetails = {
    number: '',
    type: '',
    nameOnLicense: '',
    status: '',
    issueDate: '',
    expirationDate: '',
    application_id: '',
    id: '',
    extendable: false
  };

  applications: Application[] = [];
  documents: AppDocument[] = [];
  transactions: Transaction[] = [];
  paymentBreakdown: PaymentBreakdown[] = [];
  licenseRequirements: any[] = [];
  extendLicenseModal: NgbModalRef;
  isViewMode: boolean = false;
  isLicenseDataComplete: boolean = false;
  tabs = [];
  currentUserFullName: any;
  licensePathLookup: any[] = [];

  // Section manager for accordion grids
  sectionManager = new AccordionGridSectionManager();
  myDocumentsSection: AccordionGridSection;
  licenseRequirementsSection: AccordionGridSection;
  transactionHistorySection: AccordionGridSection;
  paymentBreakdownSection: AccordionGridSection;

  // ViewChild references to access data-grid components
  @ViewChild('myDocumentsGrid') myDocumentsGrid: DataGridComponent;
  @ViewChild('licenseRequirementsGrid') licenseRequirementsGrid: DataGridComponent;
  @ViewChild('transactionHistoryGrid') transactionHistoryGrid: DataGridComponent;
  @ViewChild('paymentBreakdownGrid') paymentBreakdownGrid: DataGridComponent;

  private purgeWindowDays: number | null = 30;
  unreadCountByApplicationId: Record<number, number> = {};
  licenseDataGridConfig: DataGridVO = DataGridVO.create({});
  licenseKindDataGridConfig: DataGridVO = DataGridVO.create({});
  paymentBreakdownDataGridConfig: DataGridVO = DataGridVO.create({});
  licenseKindGridRows: any[] = [];
  licenseKindVisibleColumns: { [key: string]: boolean } = {};
  licenseKindAllColumns: { key: string; label: string; disabled?: boolean }[] = [];
  licenseVisibleColumns: { [key: string]: boolean } = {};
  licenseAllColumns: { key: string; label: string; disabled?: boolean }[] = [];
  licenseProvisions: any[] = [];
  extensionDuration: any;
  hasLicenseProvisions: boolean = false;
  provisionStatusColorOverrides: Record<string, string> = {
    'active': 'status-badge-yellow',
    'Active': 'status-badge-green',
    'past due': 'status-badge-red'
  };
  selectedDraftApplicationType: string = '';
  boolHideExtend: boolean = false;
  boolEnableExtend: boolean | undefined = undefined;
  private preferredCdLicenseTypeForSession: string = '';

  private isResolveFlow: boolean = false;
  private isSurrenderFlow: boolean = false;
  private isAddEndroseFlow: boolean = false;
  private endroseflag: boolean = false;

  showLicenseColumnChooser = false;
  showLicenseKindColumnChooser = false;
  isEnableEndoresment: boolean = false;
  isFromLogin: boolean = false;

  constructor(
    private httpService: HttpService,
    private manageProfileService: ManageProfileService,
    private dialog: MatDialog,
    private router: Router,
    private myAppService: MyApplicationsService,
    private sessionStorage: LocalService,
    private elRef: ElementRef,
    private commonService: CommonService,
    private modalService: NgbModal,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private http: HttpClient,
    private appService: AppService,
    private sanitizer: DomSanitizer,
    private inAppMessageService: InAppMessageService,
    private cdr: ChangeDetectorRef,
    private surrenderService : SurrenderService,
    private dataStoreService: DataStoreService,
    private decisionService: DecisionRolePageService
  ) {
    this.applicationData = [];
    this.applicationtypes = [];
    this.applicationStatus = [];
    this.filteredapplicationData = [];
    this.appIdFilterOptions = [];
    this.appIdFilterSelected = [];
    this.appTypeFilterOptions = [];
    this.appTypeFilterSelected = [];
    this.initializeSections();
  }

  ngOnInit() {
    // Clear stale per-application flow session keys when (re)entering dashboard
    this.clearApplicationFlowSession();
    this.initializeLicenseGridConfig();
    this.initializeLicenseKindGridConfig();
    this.loadOtpValidationRules();
    this.loadDashboardHeaders();
    this.loadDashboardData();
    this.loadMetadata();
    this.subscribeToRouteParams();
    this.getSurrenderActivationId();
    if (history.state?.fromLogin) {
      this.isFromLogin = true;
    }
    }

  // Wipes session keys that belong to a single application open/create flow so a
  // previously-opened flow (e.g. RCR with license-path, resolve_base_application_type, etc.)
  // does not bleed into the next flow (e.g. Resolve / Surrender / Extend / Name Change).
  private clearApplicationFlowSession(): void {
    const keys = [
      'license-path',
      'license-application-type',
      'applicationType',
      'currApplicationType',
      'applicationStatus',
      'applicationmode',
      'cd_license_type',
      'resolve_base_application_type',
      'extend_base_application_type',
      'add_base_application_type',
      'surrender',
      'surrenderMode',
      'newSurrenderApplication',
      'showDeleteButton',
      'arl-provider-name',
      'license-requirement-due-date',
      'license-provision-due-date',
      'gridAction'
    ];
    keys.forEach(k => this.sessionStorage.removeItem(k));
  }

  /**
   * Checks if all required license fields have values
   * Returns true only if all fields are present and non-empty
   */
  private checkLicenseDataCompleteness(): boolean {
    const complete = !!(this.license.number &&
      this.license.type &&
      this.license.nameOnLicense &&
      this.license.status &&
      this.license.issueDate &&
      this.license.expirationDate);
    // (The lines below were unreachable in your original code. Keeping logic minimal.)
    return complete;
  }

  loadDashboardHeaders() {
    this.http.get<any>('assets/metadata/application-dashboard-headers.json.json')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (json) => {
          this.dashboardHeaders = json.applicationHeaders.map((header: any) => ({
            ...header,
            label: header.caption,
            caption: header.caption,
            allowSearch: header.allowSearch || { isSearchEnable: false, type: 'string' }
          }));
          this.visibleColumns = {};
          this.dashboardHeaders.forEach(header => {
            this.visibleColumns[header.dataField] = true;
          });
          this.allColumns = this.dashboardHeaders;
          this.isLoading = true;
          this.cdr.detectChanges();
          this.checkDeviceAndRedirect();
        },
        error: (_error) => {
          // optionally handle header load errors
          this.cdr.detectChanges();
        }
      });
  }

  private runLegacyUserLogic(): void {
    const modalRef = this.modalService.open(ModalComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true
    });

    modalRef.componentInstance.modalConfig = {
      heading: modalHeading.legacyUser,
      modalContent: modalContent.legacyUserGeneral,
      hasTemplate: true,
      buttons: [
        { text: 'Go to My Profile', code: 'Y', btnOutline: false }
      ],
      align: false,
      hideCloseIcon: false
    };

    modalRef.componentInstance.emitData.subscribe((result: any) => {
      if (result.confirmed) {
        this.goToProfile();
      }
    });
  }

  goToProfile(): void {
    this.router.navigate(['/pages/manage-profile']);
  }

  private async checkDeviceAndRedirect(): Promise<void> {
    this.isLoading = false;
  }

  private async loadDropdownData() {
    this.isLoading = true;
    const userId = this.sessionStorage.getItem('id');

    forkJoin([
      this.httpService.post(API_ENDPOINTS.applications, { userId: userId }),
      this.httpService.get(API_ENDPOINTS.APPLICATION_TYPES_LOOKUP),
      this.httpService.get(API_ENDPOINTS.APPLICATION_STATUS_LOOKUP),
      this.httpService.get(API_ENDPOINTS.LOOKUP_MESSAGES),
      this.httpService.get(API_ENDPOINTS.TOAST_MESSAGES),
      this.httpService.get(API_ENDPOINTS.GENERIC_MESSAGES),
      this.httpService.get(API_ENDPOINTS.PLACEHOLDER_MESSAGES),
      this.httpService.get(API_ENDPOINTS.SUFFIX)
    ])
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (item: any) => {
          const transformLookupArray = (arr: any[]): { [key: string]: string } => {
            const obj: { [key: string]: string } = {};
            if (Array.isArray(arr)) {
              arr.forEach(lookupItem => {
                if (lookupItem.key && lookupItem.value) {
                  obj[lookupItem.key] = lookupItem.value;
                }
              });
            }
            return obj;
          };

          this.storeLookupData({
            lookupMessages: item[3].data,
            lookupToast: item[4].data,
            lookupGeneric: item[5].data,
            lookupPlaceholder: item[6].data
          });

          this.lookupMessages = transformLookupArray(item[3].data);
          this.lookupToast = transformLookupArray(item[4].data);
          this.lookupGeneric = transformLookupArray(item[5].data);
          this.lookupPlaceholder = transformLookupArray(item[6].data);
          this.suffixData = item[7].data;
          this.dnqAvailabilityByAppId = {};
          this.dnqAvailabilityLoading.clear();
          this.deficiencyAvailabilityByAppId = {};
          this.deficiencyAvailabilityLoading = false;

          if (item && item[0] && item[0].data && Array.isArray(item[0].data.data)) {
            const existingApplications = Array.isArray(this.applicationData) ? this.applicationData : [];
            // this.applicationData = item[0].data.data.map((app: any) => {
              this.applicationData = (item[0].data.data|| existingApplications).map((app: any) => {
              const status = (app.application_status || '').toLowerCase();
              let expirationDate = '';
              let createdDateRaw = app.created_date;
              let created: Date | null = null;
              const existingEntry = this.findExistingApplication(existingApplications, app);

              if (createdDateRaw) {
                if (typeof createdDateRaw === 'string' && createdDateRaw.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                  const [month, day, year] = createdDateRaw.split('/');
                  created = new Date(`${year}-${month}-${day}`);
                } else {
                  created = new Date(createdDateRaw);
                }
              }
              const apptypecheck = app.application_type;
              if(apptypecheck === 'Regular - Initial' && status === 'approved'){
                this.endroseflag = true;
              }
              this.canAddEndorsement();

              if (status === 'in progress, not submitted') {
                if (created && !isNaN(created.getTime()) && this.purgeWindowDays !== null) {
                  const purgeDate = new Date(created.getTime());
                  purgeDate.setDate(purgeDate.getDate() + this.purgeWindowDays);
                  expirationDate = this.formatDate(purgeDate);
                } else {
                  expirationDate = '';
                }
              } else if (status === 'deficiency pending') {
                expirationDate = app.dtDeficiencyArchivalDate ? this.formatDate(new Date(app.dtDeficiencyArchivalDate)) : '';
              } else if (status === 'partially approved' || status === 'analyst denied') {
                expirationDate = app.dtDNQArchivalDate ? this.formatDate(new Date(app.dtDNQArchivalDate)) : '';
              } else {
                expirationDate = app.dtExpiryDate ? this.formatDate(new Date(app.dtExpiryDate)) : '';
              }

              const dnqCommunication =
                this.extractDnqCommunicationRaw(app) ??
                this.extractDnqCommunicationRaw(existingEntry);
              const dnqDueDate =
                app?.dnq_due_date ??
                app?.dnqDueDate ??
                app?.dtDNQDueDate ??
                existingEntry?.dnq_due_date ??
                existingEntry?.dnqDueDate ??
                null;
              const deficiencyDocument =
                this.extractDeficiencyDocumentRaw(app) ??
                this.extractDeficiencyDocumentRaw(existingEntry);
              const applicationKey = this.resolveApplicationKey(app) || this.resolveApplicationKey(existingEntry);
              if (applicationKey) {
                this.deficiencyAvailabilityByAppId[applicationKey] = this.hasDeficiencyDocumentValue({ deficiency_doc_url: deficiencyDocument });
              }

              return {
                ...(existingEntry || {}),
                ...app,
                submission_date: app.application_status?.toUpperCase() === 'IN PROGRESS, NOT SUBMITTED' ? '' : app.submission_date,
                expirationDate,
                dnq_communication: dnqCommunication,
                dnq_due_date: dnqDueDate,
                deficiency_doc_url: deficiencyDocument,
                hasCaseCommunication: Array.isArray(app.case_communications) ? app.case_communications.length > 0 :
                  (Array.isArray(app.commLogs) ? app.commLogs.length > 0 : false),
                license_path: app.license_path ?? existingEntry?.license_path ?? null,
                resolve_base_application_type: app.resolve_base_application_type ?? existingEntry?.resolve_base_application_type ?? null,
                extend_base_application_type: app.extend_base_application_type ?? existingEntry?.extend_base_application_type ?? null
              };
            });
            this.loadUnreadMessageCount();
          } else {
            this.applicationData = [];
            this.loadUnreadMessageCount();
          }
           const filterDirective = new QueueStatusFilterDirective();
        filterDirective.queueName = 'dashboardadmin';
        filterDirective.data = this.applicationData;
        // this.queueData = filterDirective.filteredData;

          this.filteredapplicationData = filterDirective.filteredData;
          this.prefetchDnqAvailability(this.filteredapplicationData);
          this.prefetchDeficiencyAvailability(this.filteredapplicationData);
          // this.filteredapplicationData = filterDirective.filteredData;
          this.dashboardDataGridConfig = DataGridVO.create({
            customHeaders: this.dashboardHeaders,
            visibleColumns: this.visibleColumns,
            data: this.filteredapplicationData,
            showNewDocumentIcon: true,
            showPaymentPendingIcon: true,
            role: 'my-app',
            activeTab: 'my-app'
          });

          this.appIdFilterOptions = this.getUniqueValues(this.applicationData, 'application_id');
          this.appTypeFilterOptions = this.getUniqueValues(
            this.applicationData,
            'application_type',
            (type) => this.getApplicationTypeDisplayValue(type)
          );

          this.applicationtypes = item[1].data;
          this.applicationStatus = item[2].data;
          this.isLoading = false;
          this.checkFirstTimeLoginAndShowModalOrLoadData();
        },
        error: error => {
          console.error('Error loading dropdown data:', error);
          this.applicationData = [];
          this.filteredapplicationData = [];
        }
      });
  }

  private checkFirstTimeLoginAndShowModalOrLoadData() {
    const userId = this.sessionStorage.getItem('id');
    if (!userId) return;

    this.httpService.get(`/registration/is-first-time-login?userId=${userId}`).subscribe({
      next: (response: any) => {
        if (response?.status === 'success' && response?.data?.success === true && response?.data?.firstTimeLogin === true) {
          const modalRef = this.modalService.open(ModalComponent, { centered: true, windowClass: 'dashboard-no-header-border', backdrop: 'static', keyboard: false });
          modalRef.componentInstance.modalConfig = this.getWelcomeModalConfig();

          modalRef.componentInstance.emitData.subscribe((data: any) => {
            if (data.buttonCode === 'startNewApplication') {
              this.setFirstTimeLoginFalse();
              this.openApplicationTypeDialog();
            } else if (data.buttonCode === 'maybeLater') {
              this.setFirstTimeLoginFalse();
            }
            modalRef.close();
          });
          modalRef.closed.subscribe(() => {
            this.setFirstTimeLoginFalse();
          });
        }
      },
      error: (error) => {
        console.error('Error fetching first time login status:', error);
      }
    });
  }

  private getWelcomeModalConfig(): ModalConfig {
    return {
      heading: 'Welcome!',
      modalContent: 'Welcome to the Nevada Online Portal for Application and Licensure.\nYour account is now active and ready to use.',
      hasDropdown: false,
      hasTemplate: true,
      align: false,
      buttons: [
        { text: 'Maybe Later', code: 'maybeLater', btnOutline: true },
        { text: 'Start New Application', code: 'startNewApplication', btnOutline: false }
      ]
    };
  }

  private setFirstTimeLoginFalse() {
    const userId = this.sessionStorage.getItem('id');
    if (!userId) return;
    this.httpService.post('/registration/set-first-time-login', { userId, isFirstTime: false }).subscribe({
      next: () => { },
      error: () => { }
    });
  }

  private openDeficiencyModalIfNeeded(): void {
    const firstApp = Array.isArray(this.applicationData) && this.applicationData.length > 0 ? this.applicationData[0] : null;
    if (this.isDeficiencyStatus(firstApp) && this.isFromLogin) {
      this.deficiencyModalApplication = firstApp;
      this.showDeficiencyModal = true;
      this.isFromLogin = false;
      window.history.replaceState(
        { ...history.state, fromLogin: false },
        ''
      );
    } else {
      this.showDeficiencyModal = false;
      this.deficiencyModalApplication = null;
    }
  }

  proceedWithDeficiencyApplication(): void {
    this.showDeficiencyModal = false;
    const selectedApp = this.deficiencyModalApplication || (Array.isArray(this.applicationData) ? this.applicationData[0] : null);
    this.deficiencyModalApplication = null;
    if (selectedApp) {
      this.onApplicationIdClick(selectedApp);
    }
  }

  cancelDeficiencyModal(): void {
    this.showDeficiencyModal = false;
    this.deficiencyModalApplication = null;
  }

  getApplicationTypeDisplayValue(key: string): string {
    if (!this.applicationtypes || !key) {
      return key || '';
    }
    const appType = this.applicationtypes.find(type => type.key === key);
    return appType ? appType.value : key;
  }

  private getSuffixByKey(suffixKey: any): string {
    if (!suffixKey || !this.suffixData) return '';
    const foundItem = this.suffixData.find(item => item.key === suffixKey);
    return foundItem ? foundItem.value : '';
  }
private getLicensePathLabel(licensePathKey: any): string {
    if (!licensePathKey) return '';
    const keyStr = String(licensePathKey);
    if (this.licensePathLookup?.length > 0) {
      const foundItem = this.licensePathLookup.find(item => String(item.key) === keyStr);
      if (foundItem) return foundItem.value;
    }
    return keyStr;
  }
  private toProperCase(text: string): string {
    if (!text) return '';
    return text.toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  }

  openApplicationTypeDialog() {
    if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    // Reset stale flow session before starting a new application (RCR/Add/Extend/Name Change)
    this.clearApplicationFlowSession();
    // const closedStatuses = ['approved', 'denied', 'in progress, not submitted', 'automatic approved'];
    // const submittedApp = this.applicationData.find(
    //   (app: any) => !closedStatuses.includes((app.application_status || '').toLowerCase())
    // );
    const closedCdStatuses = ['9', '11', '16', '41'];
    const closedStatuses = ['approved',
                            // 'denied',
                            'in progress, not submitted',
                            // 'automatic approved',
                            // 'intake pending + bg denied',
                            // 'deficiency pending + bg denied',
                            // 'analyst pending + bg denied',
                            // 'analyst denied + bg approved',
                            // 'analyst denied + bg denied',
                            // 'partially approved + bg approved',
                            // 'partially approved + bg denied',
                            'analyst approved + bg approved',
                            // 'analyst approved + bg denied',
                          ]
    const submittedApp = this.applicationData.find((app: any) => {
      console.log('[BLOCKING CHECK] Checking application:', app);
      console.log('[BLOCKING CHECK] bg_required:', app.bg_required, 'typeof:', typeof app.bg_required);
      console.log('[BLOCKING CHECK] application_status:', app.application_status);
      console.log('[BLOCKING CHECK] cd_application_status:', app.cd_application_status, 'typeof:', typeof app.cd_application_status);

      if (app.bg_required === true) {
        const statusLower = (app.application_status || '').toLowerCase();
        const isInClosedStatuses = closedStatuses.includes(statusLower);
        console.log('[BLOCKING CHECK] bg_required=true - Status lower:', statusLower);
        console.log('[BLOCKING CHECK] bg_required=true - Is in closed statuses:', isInClosedStatuses);
        console.log('[BLOCKING CHECK] bg_required=true - Will block (NOT closed):', !isInClosedStatuses);
        return !isInClosedStatuses;
      } else {
        const statusString = (app.cd_application_status || '').toString();
        let isInClosedCdStatuses = false;
        if(app.application_type.toLowerCase() === 'surrender') {
          isInClosedCdStatuses = ['9','21','16','40'].includes(statusString);
        }else{
          isInClosedCdStatuses = closedCdStatuses.includes(statusString);
        }
        console.log('[BLOCKING CHECK] bg_required=false - Status string:', statusString);
        console.log('[BLOCKING CHECK] bg_required=false - Is in closed cd statuses:', isInClosedCdStatuses);
        console.log('[BLOCKING CHECK] bg_required=false - Will block (NOT closed):', !isInClosedCdStatuses);
        return !isInClosedCdStatuses;
      }
    });
    if (submittedApp && !submittedApp?.is_archived) {
      this.openShowSubmittedModal();
      return;
    }

    const draftApp = this.applicationData.find(
      (app: any) => (app.application_status || '').toLowerCase() === 'in progress, not submitted'
    );
    if (draftApp) {
      this.draftApplication = draftApp;
       this.selectedDraftApplicationType = draftApp.application_type || draftApp.strAppType || draftApp.cd_application_type || '';
            this.showDraftModal = true;
      return;
    }

    let dialogRef;
    if (this.isLicenseDataComplete) {
      const allowedTypes = this.applicationtypes.filter(type => {
        return type.value && type.value.trim().toLowerCase() === 'name change';
      });
      dialogRef = this.dialog.open(ApplicationTypeDialogComponent, {
        panelClass: 'custom-dialog-panel',
        data: undefined
      });
      if (dialogRef.componentInstance) {
        dialogRef.componentInstance.applicationTypes = allowedTypes;
      }
    } else {
      dialogRef = this.dialog.open(ApplicationTypeDialogComponent, {
        panelClass: 'custom-dialog-panel',
        data: undefined
      });
    }
    dialogRef.afterClosed().subscribe(result => {
      // if (result) {
        // optionally handle result
       if (result?.action === 'surrender') {
        console.log('[MODAL ACTION] Surrender action triggered from modal');
        this.surrenderClick(true); // skipDraftCheck=true to avoid showing draft modal twice
        return;
      }
      if (result?.action === 'extend') {
        console.log('[MODAL ACTION] Extend action triggered from modal');
        this.onExtendLicense();
        return;
      }
      if (result?.action === 'add-endorsement') {
        console.log('[MODAL ACTION] Add Endorsement action triggered from modal');
        this.storeOldApplicationIdAndLoadEndorsement();
        return;
      }
      if (result?.action === 'resolve-provisions') {
        console.log('[MODAL ACTION] Resolve Provisions action triggered from modal');
        this.removeProvision(true); // skipDraftCheck=true to avoid showing draft modal twice
        return;
      }
    });
  }

  closeColumnChooser() {
    this.showColumnChooser = false;
  }

  toggleDownloadDialog() {
    this.showDownloadDialog = !this.showDownloadDialog;
  }

  closeDownloadDialog() {
    this.showDownloadDialog = false;
  }

  openRowDownloadDialog(index: number) {
    this.rowDownloadDialogIndex = (this.rowDownloadDialogIndex === index) ? null : index;
  }

  closeRowDownloadDialog() {
    this.rowDownloadDialogIndex = null;
  }

  downloadRowExcel(app: any) {
    import('xlsx').then(xlsx => {
      const wsData = [
        ['Application ID', 'Application Type', 'Created Date', 'Submitted Date', 'Application Status'],
        [
          app.application_id,
          this.getApplicationTypeDisplayValue(app.application_type),
          app.created_date,
          app.submission_date,
          app.application_status
        ]
      ];
      const ws = xlsx.utils.aoa_to_sheet(wsData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'Application');
      const wbout = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `application_${app.application_id}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  downloadRowPDF(app: any) {
    this.isGeneratingPDF = true;
    this.loaderService.show();

    const loaderInterval: number = window.setInterval(() => {
      if (this.isGeneratingPDF) {
        this.loaderService.show();
      } else {
        window.clearInterval(loaderInterval);
      }
    }, 100);

    setTimeout(() => {
      if (!app) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
      const applicationId = app.id || app.application_id;

      if (!applicationId) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
      this.commonService.PDFGenerate(applicationId);
    }, 100);

    this.isGeneratingPDF = false;
    this.loaderService.hide();
  }

  downloadPDF() {
    if (!this.license || !this.license.number) {
      this.alertService.error('License information not found. Please ensure license data is loaded.');
      return;
    }
    this.loaderService.show();
    this.downloadLicenseDecisionStyle();
  }

  viewApplication() {
    // Reset stale flow session before opening any application so previous values do not bleed in
    this.clearApplicationFlowSession();
    if (!this.license || !this.license.number) {
      this.alertService.error('License information not found. Please ensure license data is loaded.');
      return;
    }
    this.loaderService.show();
    this.runLicensePdfDecisionStyle('view');
  }

  onPrint() {
    if (!this.license || !this.license.number) {
      this.alertService.error('License information not found. Please ensure license data is loaded.');
      return;
    }
    this.loaderService.show();
    this.runLicensePdfDecisionStyle('print');
  }

  downloadDeficiencyNotes(app: any) {
    if (!this.isApplicantRole()) {
      return;
    }
    if (!this.shouldShowDeficiencyDownload(app)) {
      return;
    }
    this.loaderService.show();
    const appKey = app?.application_number || app?.application_id || app?.id;
    const fromData = this.findApplicationFor(app);
    const url = this.extractDeficiencyDocumentRaw(app) || this.extractDeficiencyDocumentRaw(fromData) || '';

    console.log('Deficiency notes download - App Key:', appKey);
    console.log('Deficiency notes download - URL from local data:', url);

    if (url && url.trim() !== '' && url !== '---') {
      const resolvedKey = this.resolveApplicationKey(app);
      if (resolvedKey) {
        this.deficiencyAvailabilityByAppId[resolvedKey] = true;
      }
      this.downloadDeficiencyFile(url, 'deficiency-notes');
      return;
    }

    const userId = this.sessionStorage.getItem('id');
    if (!userId) {
      console.error('Deficiency notes - User ID not found for application:', appKey);
      this.loaderService.hide();
      this.showNoRecordToast();
      return;
    }

    console.log('Deficiency notes - Fetching from API for app:', appKey);
    this.httpService.post(API_ENDPOINTS.applications, { userId })
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const items = response?.data?.data || [];
          const match = this.findExistingApplication(items, app);
          const apiUrl = this.extractDeficiencyDocumentRaw(match) || '';

          console.log('Deficiency notes - API response found match:', !!match);
          console.log('Deficiency notes - URL from API:', apiUrl);

          if (!apiUrl || apiUrl.trim() === '' || apiUrl === '---') {
            console.error('Deficiency notes URL not found or invalid for application:', appKey);
            this.loaderService.hide();
            this.showNoRecordToast();
            return;
          }
          const resolvedKey = this.resolveApplicationKey(app);
          if (resolvedKey) {
            this.deficiencyAvailabilityByAppId[resolvedKey] = true;
          }
          this.loaderService.hide();
          this.downloadDeficiencyFile(apiUrl, 'deficiency-notes');
        },
        error: (error) => {
          this.loaderService.hide();
          console.error('Failed to fetch deficiency notes URL from API:', error);
          this.showNoRecordToast();
        }
      });
  }

  downloadDnqNotes(app: any): void {
    if (!this.shouldShowDnqDownload(app)) {
      return;
    }
    const applicationId = app?.id || app?.application_id || app?.application_number;
    if (!applicationId) {
      this.alertService.error('Application ID not found.');
      return;
    }
    const apiUrl = `${this.httpService.url}/application-flow/dnq-pdf/${applicationId}`;
    this.http.get(apiUrl, { responseType: 'blob', observe: 'response' })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const contentType = response.headers?.get('content-type') || '';
          const blob = response.body;
          if (!blob) {
            this.alertService.error('DNQ PDF not found.');
            return;
          }
          if (contentType.includes('application/json')) {
            blob.text()
              .then(text => {
                const payload = text ? JSON.parse(text) : null;
                const message = payload?.message || 'DNQ PDF not found.';
                this.alertService.error(message);
              })
              .catch(() => {
                this.alertService.error('DNQ PDF not found.');
              });
            return;
          }
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `DNQ-${applicationId}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        },
        error: (error) => {
          if (error?.status === 404) {
            this.alertService.error('DNQ PDF not found.');
            return;
          }
          this.alertService.error('Failed to download DNQ PDF.');
        }
      });
  }

  private transformApiLicenseData(apiData: any): any {
    console.log('API DATA:', apiData);

    const licenseTypeLookup = this.getLookupMap('lookupLicenseTypes');
    console.log('LICENCE TYPE LOOKUP',licenseTypeLookup)
    const gradeLevelLookup = this.getLookupMap('lookupGradeLevel');
    const endorsementLookup = this.getLookupMap('lookupEndorsement');
    const licenseRequirementLookup = this.getLookupMap('lookupLicenseRequirementCategory');

    return {
      number: apiData.strLicenseNumber,
      nameOnLicense: `${apiData.strFirstName} ${apiData.strMiddleName || ''} ${apiData.strLastName}`.trim(),
      type: licenseTypeLookup[apiData.strCdLicenseType] || apiData.strCdLicenseType,
      kind: licenseTypeLookup[apiData.strCdLicenseKind] || apiData.strCdLicenseKind,
      gradeLevel: gradeLevelLookup[apiData.strCdGrade] || apiData.strCdGrade,
      originalEndorsementIssueDate: apiData.dtEndOriginalIssueDate,
      endorsements: endorsementLookup[apiData.strCdEndorsement] || apiData.strCdEndorsement,
      issueDate: apiData.dtIssueDate,
      expirationDate: apiData.dtExpiryDate,
      status: 'Active',
      provisions: apiData.dtProvisionDueDate ? [
        {
          description: endorsementLookup[apiData.strCdEndorsement] || apiData.strCdEndorsement || ' ',
          dueDate: apiData.dtProvisionDueDate,
          additionalText: apiData.dtadditionalText || ' ',
          provDescription: apiData.dtProvisionDescription || ' '
        }
      ] : [],
      renewalRequirements: apiData.strCdRequirement ? [
        {
          description: licenseRequirementLookup[apiData.strCdRequirement] || apiData.strCdRequirement,
          dueDate: apiData.dtRequirementDueDate,
          reqDescription: apiData.dtreqDesc || ' '
        }
      ] : []
    };
  }

   private transformApiLicensePdfData(apiData: any): any {
    const gradeLevelLookup = this.getLookupMap('lookupGradeLevel');

    const licenseRows = Array.isArray(apiData?.Obj_License)
      ? apiData.Obj_License
      : (apiData?.Obj_License ? [apiData.Obj_License] : []);
    const firstLicense = licenseRows[0] || {};

    const licenses = licenseRows.map((row: any) => ({
      type: row?.strLicenseType || '',
      kind: row?.strLicenseKind || '',
      gradeLevel: gradeLevelLookup[row?.strCdGrade] || row?.strCdGrade || '',
      originalEndorsementIssueDate: row?.dtEndIssueDate || row?.dtIssueDate,
      endorsements: row?.strEndorsement || '',
      issueDate: row?.dtIssueDate,
      expirationDate: row?.dtExpiryDate
    }));

    let provisionSource: any[] = [];
    // Build provisions from API response
    const apiProvisions = (Array.isArray(apiData?.li_License_Provision) && apiData.li_License_Provision.length)
      ? apiData.li_License_Provision
          .filter((prov: any) => {
            const isResolved = prov.mark_resolved_flag === true ||
                               prov.strStatus === 'Resolved' ||
                               prov.status === 'Resolved';
            return !isResolved;
          })
          .map((prov: any) => {
          const sourceValue = prov.strSource || prov.req_source;
          const formattedSource = Array.isArray(sourceValue) 
            ? sourceValue.join(', ') 
            : (sourceValue || ' ');
          return {
            provDescription: prov.strProvisionDetails || prov.provision_details || ' ',
            provKindOrEndorsement: formattedSource,
            additionalText: prov.additional_text || prov.strAdditionalText || ' ',
            dueDate: prov.dtDueDate || prov.due_date,
            type: (prov.strType || prov.req_type || '').toLowerCase()
          };
        })
      : [];

    // Build provisions from already-loaded dashboard data (this.licenseProvisions has all provisions)
    const dashboardProvisions = (this.licenseProvisions || [])
      .filter((prov: any) => {
        const isResolved = prov.mark_resolved_flag === true ||
                           prov.originalStatus === 'Resolved' ||
                           prov.status === 'Resolved';
        return !isResolved;
      })
      .map((prov: any) => ({
      provDescription: prov.provision_details || prov.requirement || ' ',
      provKindOrEndorsement: prov.source || ' ',
      additionalText: prov.additional_text || ' ',
      dueDate: prov.due_date,
      type: (prov.type || '').toLowerCase()
    }));

    // Merge both sources: start with API provisions (reversed), then add any missing from dashboard data at the end
    const reversedApiProvisions = [...apiProvisions].reverse();
    const existingKeys = new Set(
      apiProvisions.map((p: any) => `${(p.provDescription || '').trim().toLowerCase()}|${(p.provKindOrEndorsement || '').trim().toLowerCase()}`)
    );
    const missingFromDashboard: any[] = [];
    dashboardProvisions.forEach((dp: any) => {
      const key = `${(dp.provDescription || '').trim().toLowerCase()}|${(dp.provKindOrEndorsement || '').trim().toLowerCase()}`;
      if (!existingKeys.has(key)) {
        missingFromDashboard.push(dp);
        existingKeys.add(key);
      }
    });

    provisionSource = [...reversedApiProvisions, ...missingFromDashboard];

    // Remove suffix from name on license
    const rawName = firstLicense?.strNameOnLicense || this.license?.nameOnLicense || '';
    const nameWithoutSuffix = this.stripSuffixFromName(rawName);

    return {
      number: firstLicense?.strLicenseNumber || this.license?.number || '',
      nameOnLicense: nameWithoutSuffix,
      status: 'Active',
      licenses,
      provisions: provisionSource,
      renewalRequirements: apiData?.li_License_Requirement?.length ?
      [...apiData.li_License_Requirement]
        .filter((req: any) => {
          const isResolved = req.mark_resolved_flag === true ||
                             req.strStatus === 'Resolved' ||
                             req.status === 'Resolved';
          return !isResolved;
        })
        .reverse()
        .map((req : any)=>{
        const sourceValue = req.strSource || req.req_source;
        const formattedSource = Array.isArray(sourceValue) 
          ? sourceValue.join(', ') 
          : (sourceValue || ' ');
        return {
          requirement: req.strRequirement || req.requirement_details || ' ',
          dueDate: req.dtDueDate || req.due_date || ' ',
          reqDescription: req.req_description || ' ',
          category : req.strCategory || req.category || ' ',
          source: formattedSource
        };
      })
     : []
    };
  }

  private stripSuffixFromName(name: string): string {
    if (!name) return '';
    let result = name.trim();
    if (this.suffixData && this.suffixData.length > 0) {
      // Sort suffixes by length descending so longer suffixes (e.g. 'III') are matched before shorter ones (e.g. 'II', 'I')
      const sortedSuffixes = [...this.suffixData].sort((a, b) => (b.value || '').length - (a.value || '').length);
      for (const suffix of sortedSuffixes) {
        const suffixValue = (suffix.value || '').trim();
        if (!suffixValue) continue;
        // Match suffix as a whole word at the end (preceded by space or comma+space)
        const patterns = [' ' + suffixValue, ', ' + suffixValue, ',' + suffixValue];
        for (const pattern of patterns) {
          if (result.toLowerCase().endsWith(pattern.toLowerCase())) {
            result = result.substring(0, result.length - pattern.length).trim();
            return result;
          }
        }
      }
    }
    return result;
  }

  private getLookupMap(lookupKey: string): { [key: string]: string } {
    try {
      const lookup = localStorage.getItem(lookupKey);
      return lookup ? JSON.parse(lookup) : {};
    } catch (_error) {
      return {};
    }
  }

  private fetchLicenseDataAndGeneratePDF(mode: 'view' | 'download' | 'print'): void {
    const licenseNumber = this.license?.number;
    if (!licenseNumber) {
      this.loaderService.hide();
      this.alertService.error('License number not found');
      return;
    }

    this.httpService.post('/dashboard/license-for-print', { licenseNumber })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.success && response.data.data?.length > 0) {
            const apiData = response.data.data[0];
            const licenseData = this.transformApiLicenseData(apiData);
            this.generateLicensePDFByMode(licenseData, mode);
          } else {
            this.loaderService.hide();
            this.alertService.error('No license data found');
          }
        },
        error: (_error) => {
          this.loaderService.hide();
          this.alertService.error('Failed to fetch license data');
        }
      });
  }

  private buildLicensePdfHtml(licenseData: any): string {
    const fmt = (d: any) => d ? moment(d).format('MMM DD, YYYY') : '-';

    const licensesArr = Array.isArray(licenseData.licenses) && licenseData.licenses.length
      ? licenseData.licenses
      : [licenseData];

    const licenseRows = licensesArr.map((row: any) => `
    <tr>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${row.type || ''}${row.type && row.kind ? ' - ' : ''}${row.kind || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${fmt(row.originalEndorsementIssueDate)}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${row.endorsements || '-'}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${fmt(row.issueDate)}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${fmt(row.expirationDate)}</td>
    </tr>`).join('');

    const provisionRows = (licenseData.provisions || []).map((item: any) => `
    <tr>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${item.provDescription || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${item.provKindOrEndorsement || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; font-weight: bold; text-align: center;">${item.additionalText || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${fmt(item.dueDate)}</td>
    </tr>`).join('');

    const requirementRows = (licenseData.renewalRequirements || []).map((item: any) => `
    <tr>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${item.category || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${item.source || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${item.requirement || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: left;">${item.reqDescription || ''}</td>
      <td style="border: 1px solid #e9ecef; padding: 8px; text-align: center;">${fmt(item.dueDate)}</td>
    </tr>`).join('');

    return `
    <html>
      <head>
        <style>
          @page { size: A4; margin: 20mm; }
          * { -webkit-print-color-adjust: exact; print-color-adjust: exact; box-sizing: border-box; }
          body { font-family: "Montserrat", sans-serif; color: #333; line-height: 1.4; margin: 0; padding: 0; }
          .header { text-align: center; padding-bottom: 30px; }
          table { width: 100%; border-collapse: collapse; margin: 0; }
          th { background-color: #f8f9fa !important; border: 1px solid #e9ecef; padding: 8px; font-size: 13px;  color: #333; font-weight: 600;}
          td { border: 1px solid #e9ecef; padding: 8px; font-size: 11px; font-weight: 400; color: #333; }
          tr, thead, tbody { page-break-inside: avoid; break-inside: avoid; }
          thead { display: table-header-group; }
          .section-title { font-size: 16px; font-style: italic; color: #4a7ba7; font-weight: bolder; text-align: center; margin: 0; padding: 30px 0 15px 0; page-break-after: avoid; break-after: avoid; }
          .section-title + table { page-break-before: avoid; break-before: avoid; }
        </style>
      </head>
      <body>
        <div class="header">
          <h1 style="font-size: 30px; font-style: italic; color: #333; margin-bottom: 5px; font-weight: normal;">State of Nevada</h1>
          <h3 style="font-size: 20px; font-style: italic; color: #666; margin-bottom: 3px; font-weight: normal;">License for Educational Personnel</h3>
          <div>
            <p style="font-size: 16px; font-style: italic; color: #000; margin: 2px 0;">${licenseData.number || ''}</p>
            <p style="font-size: 16px; font-style: italic; margin: 2px 0;">This License Certifies that</p>
            <h2 style="font-size: 16px; font-style: italic; margin: 2px 0; font-weight: 800;">${licenseData.nameOnLicense || ''}</h2>
          </div>
          <p style="text-align: center; font-size: 16px; line-height: 1.6; margin: 20px 0 30px 0; font-weight: normal;">
            Has complied with the prescribed rules and regulations of the Commission on Professional Standards in Education and that the Superintendent of Public Instruction has granted this license which authorizes the holder to provide service in the schools of the State of Nevada in the following areas:
          </p>
        </div>

        <table>
          <thead>
            <tr>
              <th>License</th><th>Original Endorsement Issue Date</th>
              <th>Endorsements</th><th>License Issue Date</th><th>Expiration Date</th>
            </tr>
          </thead>
          <tbody>${licenseRows}</tbody>
        </table>

        ${(licenseData.provisions && licenseData.provisions.length > 0) ? `
        <div class="section-title">Provisions to be satisfied</div>
        <table>
          <thead>
            <tr><th>Provisions</th><th>License Kind/Endorsement</th><th>Additional Text</th><th>Required Due Date</th></tr>
          </thead>
          <tbody>${provisionRows}</tbody>
        </table>
        ` : ''}

        ${(licenseData.renewalRequirements && licenseData.renewalRequirements.length > 0) ? `
        <div class="section-title">License Requirements</div>
        <table>
          <thead>
            <tr><th>Category</th><th>Source</th><th colspan="2">License Requirement</th><th>Required Due Date</th></tr>
          </thead>
          <tbody>${requirementRows}</tbody>
        </table>
        ` : ''}
      </body>
    </html>`;
  }

  private generateLicense(mode: 'download' | 'print'): void {
    const userId = this.sessionStorage.getItem('id');
    if (!userId) {
      this.loaderService.hide();
      this.alertService.error('User ID not found');
      return;
    }

    this.httpService.post('/dashboard/license-pdf-download', { userId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.success && response.data.data?.length > 0) {
            const apiData = response.data.data[0];
            const licenseData = this.transformApiLicensePdfData(apiData);
            this.renderLicensePdfClientSide(licenseData, mode);
          } else {
            this.loaderService.hide();
            this.alertService.error('No license data found');
          }
        },
        error: (_error: any) => {
          this.loaderService.hide();
          this.alertService.error('Failed to fetch license data');
        }
      });
  }

  private renderLicensePdfClientSide(licenseData: any, mode: 'download' | 'print'): void {
    const fullHtml = this.buildLicensePdfHtml(licenseData);

    // Both modes render via jsPDF so the print output never shows the browser's
    // "about:blank" header or date/time footer that window.print() adds.

    // A4 at 96 DPI = 794px — matches exactly what the browser uses for print layout
    const A4_PX = 794;
    const iframe = document.createElement('iframe');
    iframe.style.cssText = `position:fixed;left:-99999px;top:0;width:${A4_PX}px;height:1px;border:0;visibility:hidden;`;
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc) {
      document.body.removeChild(iframe);
      this.loaderService.hide();
      console.error('License PDF: unable to access iframe document');
      return;
    }

    iframeDoc.open();
    iframeDoc.write(fullHtml);
    iframeDoc.close();

    const captureFromIframe = () => {
      const body = iframeDoc.body;
      iframe.style.height = body.scrollHeight + 'px';

      const SCALE = 2;
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidthMm = 210;
      const pageHeightMm = 297;
      const marginMm = 15;
      const contentWidthMm = pageWidthMm - 2 * marginMm;
      const contentHeightMm = pageHeightMm - 2 * marginMm;
      let currentYMm = marginMm;

      const renderHtml2Canvas = (el: HTMLElement) => html2canvas(el, {
        scale: SCALE,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        allowTaint: true,
        windowWidth: A4_PX
      });

      const canvasHeightMm = (canvas: HTMLCanvasElement) =>
        (canvas.height / canvas.width) * contentWidthMm;

      const addCanvasToPdf = (canvas: HTMLCanvasElement) => {
        const imgHeightMm = canvasHeightMm(canvas);
        if (currentYMm > marginMm && currentYMm + imgHeightMm > marginMm + contentHeightMm) {
          pdf.addPage();
          currentYMm = marginMm;
        }
        pdf.addImage(
          canvas.toDataURL('image/jpeg', 0.95),
          'JPEG',
          marginMm, currentYMm,
          contentWidthMm, imgHeightMm
        );
        currentYMm += imgHeightMm;
      };

      const renderBlock = async (el: HTMLElement) => {
        const canvas = await renderHtml2Canvas(el);
        addCanvasToPdf(canvas);
      };

      // Build a temporary off-screen wrapper inside the iframe so cloned
      // mini-tables inherit the same styles as the source.
      const tempWrapper = iframeDoc.createElement('div');
      tempWrapper.style.cssText = `position:absolute;left:-99999px;top:0;width:${body.clientWidth}px;`;
      body.appendChild(tempWrapper);

      const renderTableChunk = async (sourceTable: HTMLElement, rows: HTMLElement[]) => {
        if (rows.length === 0) return;
        const clone = sourceTable.cloneNode(false) as HTMLElement;
        const thead = sourceTable.querySelector('thead');
        if (thead) clone.appendChild(thead.cloneNode(true));
        const tbody = iframeDoc.createElement('tbody');
        rows.forEach(r => tbody.appendChild(r.cloneNode(true)));
        clone.appendChild(tbody);
        tempWrapper.innerHTML = '';
        tempWrapper.appendChild(clone);
        const canvas = await renderHtml2Canvas(clone);
        addCanvasToPdf(canvas);
      };

      // CSS-px (body) → PDF mm (since the body width is scaled to contentWidthMm in the PDF).
      const pxToMm = contentWidthMm / body.clientWidth;
      const elHeightMm = (el: HTMLElement) => el.getBoundingClientRect().height * pxToMm;

      const renderTable = async (table: HTMLElement, leadingHeightMm = 0) => {
        const thead = table.querySelector('thead') as HTMLElement | null;
        const trs = Array.from(table.querySelectorAll('tbody > tr')) as HTMLElement[];
        if (trs.length === 0) {
          await renderBlock(table);
          return;
        }

        const theadHeightMm = thead ? elHeightMm(thead) : 0;
        const firstRowHeightMm = elHeightMm(trs[0]);
        // Small fudge factor for border collapse / rounding
        const FUDGE = 1;

        // Keep the section title with at least the table header + first row.
        if (
          leadingHeightMm > 0 &&
          currentYMm > marginMm &&
          currentYMm + leadingHeightMm + theadHeightMm + firstRowHeightMm + FUDGE >
            marginMm + contentHeightMm
        ) {
          pdf.addPage();
          currentYMm = marginMm;
        }

        let chunk: HTMLElement[] = [];
        let chunkHeightMm = theadHeightMm;

        for (const tr of trs) {
          const trHeightMm = elHeightMm(tr) + FUDGE;
          const remaining = marginMm + contentHeightMm - currentYMm;
          const projected = chunkHeightMm + trHeightMm;

          if (projected > remaining && chunk.length > 0) {
            await renderTableChunk(table, chunk);
            pdf.addPage();
            currentYMm = marginMm;
            chunk = [];
            chunkHeightMm = theadHeightMm;
          }

          // Single row taller than a whole page: render it alone.
          if (theadHeightMm + trHeightMm > contentHeightMm && chunk.length === 0) {
            await renderTableChunk(table, [tr]);
            pdf.addPage();
            currentYMm = marginMm;
            continue;
          }

          chunk.push(tr);
          chunkHeightMm += trHeightMm;
        }

        if (chunk.length > 0) {
          await renderTableChunk(table, chunk);
        }
      };

      (async () => {
        let renderFailed = false;

        try {
          const children = (Array.from(body.children) as HTMLElement[])
            .filter(c => c !== tempWrapper);

          for (let i = 0; i < children.length; i++) {
            const child = children[i];
            const tag = child.tagName.toLowerCase();
            const next = children[i + 1];
            const nextIsTable = next && next.tagName.toLowerCase() === 'table';
            const isSectionTitle = child.classList.contains('section-title');

            if (tag === 'table') {
              await renderTable(child);
            } else if (isSectionTitle && nextIsTable) {
              // Render the title together with its following table so the
              // heading never gets orphaned at the bottom of a page.
              const titleHeightMm = elHeightMm(child);
              await renderBlock(child);
              await renderTable(next, titleHeightMm);
              i++; // consumed the table
            } else {
              await renderBlock(child);
            }
          }
        } catch (err) {
          renderFailed = true;
          console.error('License PDF render error:', err);
        }

        // Clean up DOM helpers before producing output so any popup/iframe
        // operations below run with a tidy state.
        if (tempWrapper.parentNode) tempWrapper.parentNode.removeChild(tempWrapper);
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);

        if (renderFailed) {
          this.loaderService.hide();
          return;
        }

        try {
          if (mode === 'print') {
            const blob = pdf.output('blob');
            const blobUrl = URL.createObjectURL(blob);

            // Use a hidden iframe (not window.open) so the browser's popup
            // blocker doesn't fire when print is triggered from an async flow.
            const printFrame = document.createElement('iframe');
            printFrame.style.cssText =
              'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
            printFrame.src = blobUrl;
            printFrame.onload = () => {
              setTimeout(() => {
                try {
                  printFrame.contentWindow?.focus();
                  printFrame.contentWindow?.print();
                } catch (e) {
                  console.error('Print invocation failed:', e);
                }
              }, 400);
            };
            document.body.appendChild(printFrame);

            // Tear the frame down after the user has had time to print.
            setTimeout(() => {
              if (printFrame.parentNode) printFrame.parentNode.removeChild(printFrame);
              URL.revokeObjectURL(blobUrl);
            }, 60_000);
          } else {
            pdf.save(`License_${licenseData.number || 'document'}.pdf`);
          }
        } catch (err) {
          console.error('License PDF output error:', err);
        } finally {
          this.loaderService.hide();
        }
      })();
    };

    // Use onload if available, fallback to timeout
    if (iframe.contentWindow) {
      iframe.contentWindow.onload = () => setTimeout(captureFromIframe, 300);
    }
    setTimeout(captureFromIframe, 600);
  }

   private downloadOnlyPDF(mode: 'download' ): void {
    const licenseNumber = this.license?.number;
    const userId = this.sessionStorage.getItem('id');
    if (!licenseNumber) {
      this.loaderService.hide();
      this.alertService.error('License number not found');
      return;
    }

    this.httpService.post('/dashboard/license-pdf-download', { userId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.success && response.data.data?.length > 0) {
            const apiData = response.data.data[0];
            const licenseData = this.transformApiLicensePdfData(apiData);
            this.generateLicensePDFByMode(licenseData, mode);
          } else {
            this.loaderService.hide();
            this.alertService.error('No license data found');
          }
        },
        error: (_error) => {
          this.loaderService.hide();
          this.alertService.error('Failed to fetch license data');
        }
      });
  }

  private generateLicensePDFByMode(licenseData: any, mode: 'view' | 'download' | 'print'): void {
    const modeMethodMap = {
      'download': () => this.commonService.generateLicensePDFForDownload(licenseData),
      'view': () => this.commonService.generateLicensePDFForView(licenseData),
      'print': () => this.commonService.generateLicensePDFForPrint(licenseData)
    };

    modeMethodMap[mode]()
      .then(() => {
        this.loaderService.hide();
      })
      .catch((_error: any) => {
        this.loaderService.hide();
        const modeText = mode === 'download' ? 'download' : mode === 'view' ? 'view' : 'print';
        this.alertService.error(`Failed to ${modeText} license PDF`);
      });
  }

  private downloadLicenseDecisionStyle(): void {
    this.runLicensePdfDecisionStyle('download');
  }

  private runLicensePdfDecisionStyle(mode: 'download' | 'view' | 'print'): void {
    const userId = this.sessionStorage.getItem('id');
    if (!userId) {
      this.loaderService.hide();
      this.alertService.error('User ID not found');
      return;
    }

    this.httpService.post('/dashboard/license-pdf-download', { userId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.success && response.data.data?.length > 0) {
            const apiData = response.data.data[0];
            const licenseData = this.transformApiLicensePdfData(apiData);
            const fullHtml = this.buildDecisionStyleLicensePdfHtml(licenseData);

            this.decisionService.generatePdf(fullHtml)
              .pipe(take(1), takeUntil(this.destroy$))
              .subscribe({
                next: (blob: Blob) => {
                  const safeName = (licenseData.nameOnLicense || licenseData.number || 'document')
                    .toString()
                    .replace(/[\\/:*?"<>|]/g, '_')
                    .trim();
                  const fileName = `License_${safeName}.pdf`;

                  if (mode === 'download') {
                    this.triggerLicenseFileDownload(blob, fileName);
                    this.loaderService.hide();
                  } else if (mode === 'print') {
                    this.printLicenseBlob(blob);
                    this.loaderService.hide();
                  } else {
                    this.showLicenseBlobInPreview(blob);
                    this.loaderService.hide();
                  }
                },
                error: (_err: any) => {
                  this.loaderService.hide();
                  const label = mode === 'download' ? 'download' : mode === 'print' ? 'print' : 'view';
                  this.alertService.error(`Failed to ${label} license PDF`);
                }
              });
          } else {
            this.loaderService.hide();
            this.alertService.error('No license data found');
          }
        },
        error: (_error: any) => {
          this.loaderService.hide();
          this.alertService.error('Failed to fetch license data');
        }
      });
  }

  private printLicenseBlob(blob: Blob): void {
    const blobUrl = URL.createObjectURL(blob);
    const printFrame = document.createElement('iframe');
    printFrame.style.cssText =
      'position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;';
    printFrame.src = blobUrl;
    printFrame.onload = () => {
      setTimeout(() => {
        try {
          printFrame.contentWindow?.focus();
          printFrame.contentWindow?.print();
        } catch (e) {
          console.error('Print invocation failed:', e);
        }
      }, 400);
    };
    document.body.appendChild(printFrame);

    setTimeout(() => {
      if (printFrame.parentNode) printFrame.parentNode.removeChild(printFrame);
      URL.revokeObjectURL(blobUrl);
    }, 60_000);
  }

  private showLicenseBlobInPreview(blob: Blob): void {
    if (this.originalBlobUrl) {
      URL.revokeObjectURL(this.originalBlobUrl);
    }
    this.originalBlobUrl = URL.createObjectURL(blob);
    this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.originalBlobUrl);
    this.modalService.open(this.pdfPreviewModal, { size: 'xl', centered: true });
  }

  private triggerLicenseFileDownload(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  private buildDecisionStyleLicensePdfHtml(licenseData: any): string {
    const fmt = (d: any) => d ? moment(d).format('MMM DD, YYYY') : '-';
    const esc = (v: any) => {
      if (v === null || v === undefined) return '';
      return String(v)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    };

    const licensesArr = Array.isArray(licenseData.licenses) && licenseData.licenses.length
      ? licenseData.licenses
      : [];

    const licenseRows = licensesArr.map((row: any) => {
      const type = esc(row.type || '');
      const kind = esc(row.kind || '');
      const label = type && kind ? `${type} - ${kind}` : `${type}${kind}`;
      return `
    <tr>
      <td>${label}</td>
      <td>${fmt(row.originalEndorsementIssueDate)}</td>
      <td>${esc(row.endorsements || '')}</td>
      <td>${fmt(row.issueDate)}</td>
      <td>${fmt(row.expirationDate)}</td>
    </tr>`;
    }).join('');

    const provisionRows = (licenseData.provisions || []).map((item: any) => `
    <tr>
      <td>${esc(item.provDescription || '')}</td>
      <td>${esc(item.provKindOrEndorsement || '')}</td>
      <td style="text-align: left;">${esc(item.additionalText || '')}</td>
      <td>${fmt(item.dueDate)}</td>
    </tr>`).join('');

    const requirementRows = (licenseData.renewalRequirements || []).map((item: any) => `
    <tr>
      <td>${esc(item.category || '')}</td>
      <td>${esc(item.source || '')}</td>
      <td>${esc(item.requirement || '')}</td>
      <td style="text-align: left;">${esc(item.reqDescription || '')}</td>
      <td>${fmt(item.dueDate)}</td>
    </tr>`).join('');

    return `
    <html>
      <head>
        <style>
         @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');
        body {
    margin: 0;
    padding: 20px 40px 30px;
    background: #FFFFFF;
    font-family: 'Montserrat', sans-serif;
    color: #101010;
}

          .header { text-align: center; }
table {
    width: 100%;
    margin: 0 auto 25px;
    border-collapse: collapse;
    table-layout: fixed;
    background: transparent;
}

thead tr {
    background: #f8f9fa !important;
}

th {
    background: #f8f9fa !important;
    border: 0.5px solid #e9ecef;
    padding: 10px 10px;
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #495057;
    vertical-align: middle;
    line-height: 16px;
}

td {
    border: 0.5px solid #e9ecef;
    padding: 16px 16px;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    color: #495057;
    vertical-align: middle;
    word-break: break-word;
    overflow-wrap: break-word;
    background: transparent;
    font-weight:500 !important;
}
          .section-title {
          text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #4a7ba7;
    margin: 0px 0 20px;}

    @media print {
    @page {
        margin-top: 10mm;
        margin-bottom: 14mm;
        margin-left: 3mm;
        margin-right: 3mm;
    }

    @page :first {
        margin-top: 5mm;
    }

    body {
        background: #ffffff;
        padding: 0 15px;
    }

    .container {
        width: 100%;
        padding: 15px 40px 20px;
        background: #ffffff;
    }

    table {
        page-break-inside: auto;
         border-top: 1px solid #d7d7d7;
         border-bottom: 1px solid #d7d7d7;

    }

      thead {
        display: table-header-group;
    }


    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    td,
    th {
        page-break-inside: avoid;
    }

        .section-block {
        page-break-inside: avoid;
    }

    .section-heading {
        page-break-after: avoid;
    }

    tbody tr:first-child td {
        page-break-before: avoid;
    }
}
        </style>
      </head>
      <body>
        <div class="header">
                          <div class="doc-logo-container">
       <img src="https://nevadadocs.blob.core.windows.net/customuserflow/edu-logo.svg" alt="Company Logo"  class="logo" />
        </div>
          <div>
            <p style="font-size: 13px; color: #000000; margin-bottom: 2px !important;">${esc(licenseData.number || '')}</p>
            <p style="font-size: 15px; font-style: italic; color: #000000; margin-bottom: 5px;">This License Certifies that</p>
            <h2 style="font-size: 13px; color: #000000; margin: 0 0 5px 0; font-weight:500;">${esc(licenseData.nameOnLicense || '')}</h2>
          </div>

          <p style="margin: 18px auto 18px; text-align: center; font-size: 13px; line-height: 22px; color: #333333;">
            Has complied with the prescribed rules and regulations of the Commission on Professional Standards in Education and that the Superintendent of Public Instruction has granted this license which authorizes the holder to provide service in the schools of the State of Nevada in the following areas:
          </p>
        </div>

        <table>
          <thead>
            <tr>
              <th>License</th><th>Original Issue Date</th>
              <th>Endorsements</th><th>Issue Date</th><th>Expiration Date</th>
            </tr>
          </thead>
          <tbody>${licenseRows}</tbody>
        </table>

        ${(licenseData.provisions && licenseData.provisions.length > 0) ? `
        <div class="section-block">
        <div class="section-title">Provisions to be satisfied</div>
        <table>
          <thead>
            <tr><th>Provisions</th>
            <th> License Kind/Endorsement</th>
            <th>Additional Text</th>
            <th>Required Due Date</th></tr>
          </thead>
          <tbody>${provisionRows}</tbody>
        </table>
        </div>
        ` : ''}
        ${(licenseData.renewalRequirements && licenseData.renewalRequirements.length > 0) ? `
        <div class="section-block">
        <div class="section-title">License Requirements</div>
        <table>
          <thead>
            <tr>
            <th> Category</th>
            <th> Source </th>
            <th colspan="2">License Requirement</th>
            <th>Required Due Date</th></tr>
          </thead>
          <tbody>${requirementRows}</tbody>
        </table>
        </div>
        ` : ''}
      </body>
    </html>
  `;
  }

  private isApplicantRole(): boolean {
    if (this.loginUserRoleId !== null) {
      return this.loginUserRoleId === 405;
    }

    const rawRole = this.sessionStorage.getItem('role_id');
    if (rawRole !== null && rawRole !== '') {
      const parsed = Number(rawRole);
      if (!Number.isNaN(parsed)) {
        this.loginUserRoleId = parsed;
        return parsed === 405;
      }
    }

    this.loginUserRoleId = this.getLoginRoleId();
    return this.loginUserRoleId === 405;
  }

  private getLoginRoleId(): number | null {
    const rawRole = this.sessionStorage.getItem('role_id');
    if (rawRole !== null && rawRole !== '') {
      const parsed = Number(rawRole);
      if (!Number.isNaN(parsed)) {
        return parsed;
      }
    }

    try {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
      const role =
        user?.role_id ||
        user?.roleId ||
        user?.role?.id ||
        user?.role?.role_id ||
        user?.user_role_id ||
        user?.userRoleId;
      if (role !== undefined && role !== null && role !== '') {
        const parsed = Number(role);
        return Number.isNaN(parsed) ? null : parsed;
      }
    } catch {
      return null;
    }

    return null;
  }

  private downloadDeficiencyFile(fileUrl: string, fallbackName: string): void {
    // Validate URL before attempting download
    if (!fileUrl || fileUrl.trim() === '' || fileUrl === '---') {
      console.error('Invalid deficiency notes URL:', fileUrl);
      this.loaderService.hide();
      this.alertService.error('Deficiency notes URL is invalid or not available.');
      return;
    }

    this.http.get(fileUrl, { responseType: 'blob', observe: 'response' })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const blob = response.body;
          if (!blob) {
            console.error('Deficiency notes download returned empty response.');
            this.loaderService.hide();
            this.alertService.error('Failed to retrieve deficiency notes. Please try again.');
            return;
          }
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `${fallbackName}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
          this.loaderService.hide();
        },
        error: (error) => {
          console.error('Failed to download deficiency notes:', error);
          this.loaderService.hide();
          if (error?.status === 404) {
            this.alertService.error('Deficiency notes file not found.');
          } else if (error?.status === 401 || error?.status === 403) {
            this.alertService.error('You do not have permission to download deficiency notes.');
          } else {
            this.alertService.error('Failed to download deficiency notes. Please try again.');
          }
        }
      });
  }

  private showNoRecordToast(): void {
    this.alertService.error('No record found');
  }

  private getApplicationIdentifiers(source: any): string[] {
    if (!source) {
      return [];
    }
    const values = [
      source?.id ??
      source?.application_id ??
      source?.application_number ??
      source?.strAppId ??
      source?.strApplicationId ??
      source?.strApplicationNumber ??
      source?.dnq_communication,
      ''
    ];
    const normalized = values
      .map((v: any) => String(v ?? '').trim())
      .filter((v: string) => v.length > 0);
    return Array.from(new Set(normalized));
  }

  private resolveApplicationKey(source: any): string {
    const identifiers = this.getApplicationIdentifiers(source);
    return identifiers.length > 0 ? identifiers[0] : '';
  }

  private findExistingApplication(existingApplications: any[], source: any): any | null {
    if (!Array.isArray(existingApplications) || existingApplications.length === 0) {
      return null;
    }
    const sourceIds = this.getApplicationIdentifiers(source);
    if (sourceIds.length === 0) {
      return null;
    }
    const found = existingApplications.find((entry: any) => {
      const entryIds = this.getApplicationIdentifiers(entry);
      return entryIds.some((entryId: string) => sourceIds.includes(entryId));
    });
    return found || null;
  }

  private extractDnqCommunicationRaw(source: any): any {
    if (!source) {
      return null;
    }

    const directValue =
      source?.dnq_communication ??
      source?.dnqCommunication ??
      source?.dnqcommunication ??
      source?.dnq_commuication ??
      source?.dnqCommuication ??
      source?.strDNQCommunication ??
      source?.strDnqCommunication ??
      source?.dnq_notes ??
      source?.dnqNotes ??
      source?.dnq_note ??
      source?.dnqNote;

    if (directValue !== null && directValue !== undefined) {
      return directValue;
    }

    const dynamicDnqField = Object.entries(source).find(([key]) => {
      const normalizedKey = String(key || '').toLowerCase();
      return normalizedKey.includes('dnq') && (
        normalizedKey.includes('communication') ||
        normalizedKey.includes('commuication') ||
        normalizedKey.includes('comm') ||
        normalizedKey.includes('note')
      );
    });

    return dynamicDnqField ? dynamicDnqField[1] : null;
  }

  private extractDnqDueDateRaw(source: any): any {
    if (!source) {
      return null;
    }

    const directValue =
      source?.dnq_due_date ??
      source?.dnqDueDate ??
      source?.dtDNQDueDate ??
      source?.dtDnqDueDate ??
      source?.dnq_due ??
      source?.dnqDue;

    if (directValue !== null && directValue !== undefined) {
      return directValue;
    }

    const dynamicDnqDateField = Object.entries(source).find(([key]) => {
      const normalizedKey = String(key || '').toLowerCase();
      return normalizedKey.includes('dnq') && (
        normalizedKey.includes('due') ||
        normalizedKey.includes('date')
      );
    });

    return dynamicDnqDateField ? dynamicDnqDateField[1] : null;
  }

  private extractEndorsementPathwayRaw(source: any): any {
    if (!source) {
      return null;
    }

    const directValue =
      source?.endorsement_pathway ??
      source?.endorsementPathway ??
      source?.cd_endorsement_pathway ??
      source?.cdEndorsementPathway ??
      source?.strEndorsementPathway ??
      source?.endo_pathway ??
      source?.endoPathway ??
      source?.pathway;

    if (directValue !== null && directValue !== undefined) {
      return directValue;
    }

    const dynamicPathwayField = Object.entries(source).find(([key]) => {
      const normalizedKey = String(key || '').toLowerCase();
      return normalizedKey.includes('pathway') && (
        normalizedKey.includes('endorsement') ||
        normalizedKey.includes('endo')
      );
    });

    if (dynamicPathwayField) {
      return dynamicPathwayField[1];
    }

    const nestedPathwayValue = Object.values(source).find((value: any) => {
      if (Array.isArray(value)) {
        return value.some((item: any) =>
          !!item &&
          typeof item === 'object' &&
          (
            item?.endorsement_pathway !== undefined ||
            item?.endorsementPathway !== undefined ||
            item?.cd_endorsement_pathway !== undefined ||
            item?.cdEndorsementPathway !== undefined ||
            item?.pathway !== undefined
          )
        );
      }

      return !!value &&
        typeof value === 'object' &&
        (
          value?.endorsement_pathway !== undefined ||
          value?.endorsementPathway !== undefined ||
          value?.cd_endorsement_pathway !== undefined ||
          value?.cdEndorsementPathway !== undefined ||
          value?.pathway !== undefined
        );
    });

    return nestedPathwayValue ?? null;
  }

  private extractDeficiencyDocumentRaw(source: any): any {
    if (!source) {
      return null;
    }

    const directValue =
      source?.deficiency_doc_url ??
      source?.deficiencyDocUrl ??
      source?.deficiencyDocURL ??
      source?.deficiency_doc ??
      source?.deficiency_notes ??
      source?.deficiencyNotes ??
      source?.deficiency_note ??
      source?.deficiencyNote ??
      source?.deficiency_comments ??
      source?.deficiencyComments;

    if (directValue !== null && directValue !== undefined) {
      return directValue;
    }

    const dynamicField = Object.entries(source).find(([key]) => {
      const normalizedKey = String(key || '').toLowerCase();
      return normalizedKey.includes('deficiency') && (
        normalizedKey.includes('doc') ||
        normalizedKey.includes('url') ||
        normalizedKey.includes('note') ||
        normalizedKey.includes('comment')
      );
    });

    return dynamicField ? dynamicField[1] : null;
  }

  private hasDnqCommunicationValue(source: any): boolean {
    const rawValue = this.extractDnqCommunicationRaw(source);
    if (rawValue === null || rawValue === undefined) {
      return false;
    }

    const asString = String(rawValue).trim();
    if (!asString || asString.toLowerCase() === 'null') {
      return false;
    }

    const textOnly = asString
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim();

    return textOnly.length > 0;
  }

  private hasDnqDueDateValue(source: any): boolean {
    const rawValue = this.extractDnqDueDateRaw(source);
    if (rawValue === null || rawValue === undefined) {
      return false;
    }

    const asString = String(rawValue).trim();
    if (!asString || asString.toLowerCase() === 'null') {
      return false;
    }

    return true;
  }

  private normalizePathwayValues(rawValue: any): string[] {
    if (rawValue === null || rawValue === undefined) {
      return [];
    }

    if (Array.isArray(rawValue)) {
      return rawValue.flatMap((value: any) => this.normalizePathwayValues(value));
    }

    if (typeof rawValue === 'object') {
      const directNestedValues = [
        rawValue?.endorsement_pathway,
        rawValue?.endorsementPathway,
        rawValue?.cd_endorsement_pathway,
        rawValue?.cdEndorsementPathway,
        rawValue?.strEndorsementPathway,
        rawValue?.endo_pathway,
        rawValue?.endoPathway,
        rawValue?.pathway
      ].filter((value: any) => value !== null && value !== undefined && value !== '');

      if (directNestedValues.length > 0) {
        return directNestedValues.flatMap((value: any) => this.normalizePathwayValues(value));
      }

      return Object.entries(rawValue)
        .filter(([key]) => String(key || '').toLowerCase().includes('pathway'))
        .flatMap(([, value]) => this.normalizePathwayValues(value));
    }

    const asString = String(rawValue).trim();
    if (!asString) {
      return [];
    }

    if (asString.startsWith('[') && asString.endsWith(']')) {
      try {
        const parsed = JSON.parse(asString);
        return this.normalizePathwayValues(parsed);
      } catch {
        // Fall through to delimiter-based parsing.
      }
    }

    return asString
      .split(/[|,;/]+/)
      .map((value: string) => value.trim())
      .filter((value: string) => value.length > 0);
  }

  private isDnqPathwayValue(pathway: any): boolean {
    if (pathway === null || pathway === undefined || pathway === '') {
      return false;
    }

    const normalized = String(pathway).trim().toLowerCase();
    if (!normalized) {
      return false;
    }

    return normalized === '7' || normalized.includes('dnq') || normalized === 'does not qualify';
  }

  private hasEndorsementPathwayDnq(source: any): boolean {
    const rawValue = this.extractEndorsementPathwayRaw(source);
    const pathwayValues = this.normalizePathwayValues(rawValue);
    if (pathwayValues.length === 0) {
      return false;
    }

    return pathwayValues.some((pathwayValue: string) => this.isDnqPathwayValue(pathwayValue));
  }

  private hasDeficiencyDocumentValue(source: any): boolean {
    const rawValue = this.extractDeficiencyDocumentRaw(source);
    if (rawValue === null || rawValue === undefined) {
      return false;
    }

    const asString = String(rawValue).trim();
    if (!asString || asString.toLowerCase() === 'null') {
      return false;
    }
    return true;
  }

  private ensureDnqAvailabilityCheck(source: any): void {
    const appId = this.resolveApplicationKey(source);
    if (!appId) {
      return;
    }

    if (Object.prototype.hasOwnProperty.call(this.dnqAvailabilityByAppId, appId)) {
      return;
    }

    if (this.dnqAvailabilityLoading.has(appId)) {
      return;
    }

    this.dnqAvailabilityLoading.add(appId);
    const apiUrl = `${this.httpService.url}/application-flow/dnq-pdf/${appId}`;

    this.http.get(apiUrl, { responseType: 'blob', observe: 'response' })
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const contentType = response.headers?.get('content-type') || '';
          const isPdf = !!response.body && !contentType.includes('application/json');
          this.dnqAvailabilityByAppId[appId] = isPdf;
          this.dnqAvailabilityLoading.delete(appId);
          this.filteredapplicationData = [...this.filteredapplicationData];
        },
        error: () => {
          this.dnqAvailabilityByAppId[appId] = false;
          this.dnqAvailabilityLoading.delete(appId);
        }
      });
  }

  private prefetchDnqAvailability(rows: any[]): void {
    if (!this.isApplicantRole() || !Array.isArray(rows)) {
      return;
    }

    rows.forEach((row: any) => {
      const appId = this.resolveApplicationKey(row);
      if (!appId) {
        return;
      }

      if (this.hasDnqCommunicationValue(row) || this.hasDnqDueDateValue(row)) {
        this.dnqAvailabilityByAppId[appId] = true;
        return;
      }

      this.ensureDnqAvailabilityCheck(row);
    });
  }

  private prefetchDeficiencyAvailability(rows: any[]): void {
    if (!this.isApplicantRole() || !Array.isArray(rows) || this.deficiencyAvailabilityLoading) {
      return;
    }

    const unresolvedRows = rows.filter((row: any) => {
      const key = this.resolveApplicationKey(row);
      if (!key) {
        return false;
      }
      if (this.hasDeficiencyDocumentValue(row)) {
        this.deficiencyAvailabilityByAppId[key] = true;
        return false;
      }
      if (Object.prototype.hasOwnProperty.call(this.deficiencyAvailabilityByAppId, key)) {
        return false;
      }
      return true;
    });

    if (unresolvedRows.length === 0) {
      return;
    }

    const userId = this.sessionStorage.getItem('id');
    if (!userId) {
      return;
    }

    this.deficiencyAvailabilityLoading = true;
    this.httpService.post(API_ENDPOINTS.applications, { userId })
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          const items = response?.data?.data || [];
          if (Array.isArray(items)) {
            items.forEach((item: any) => {
              const key = this.resolveApplicationKey(item);
              if (!key) {
                return;
              }
              this.deficiencyAvailabilityByAppId[key] = this.hasDeficiencyDocumentValue(item);
            });
          }
          this.filteredapplicationData = [...this.filteredapplicationData];
          this.deficiencyAvailabilityLoading = false;
        },
        error: () => {
          this.deficiencyAvailabilityLoading = false;
        }
      });
  }

  shouldShowDnqDownload(row: any): boolean {
    if (!row || !this.isApplicantRole()) {
      return false;
    }

    const matchedRow = this.findApplicationFor(row);
    const isDnqEligibleStatus = this.isDnqDownloadEligibleStatus(row) || this.isDnqDownloadEligibleStatus(matchedRow);
    if (!isDnqEligibleStatus) {
      return false;
    }

    const appId = this.resolveApplicationKey(row);
    if (this.hasDnqCommunicationValue(row) || this.hasDnqDueDateValue(row)) {
      if (appId) {
        this.dnqAvailabilityByAppId[appId] = true;
      }
      return true;
    }

    const matchedAppId = this.resolveApplicationKey(matchedRow || row);
    if (this.hasDnqCommunicationValue(matchedRow) || this.hasDnqDueDateValue(matchedRow)) {
      if (matchedAppId) {
        this.dnqAvailabilityByAppId[matchedAppId] = true;
      }
      return true;
    }

    if (matchedAppId && Object.prototype.hasOwnProperty.call(this.dnqAvailabilityByAppId, matchedAppId)) {
      return this.dnqAvailabilityByAppId[matchedAppId] === true;
    }

    this.ensureDnqAvailabilityCheck(matchedRow || row);
    return false;
  }

  shouldShowDeficiencyDownload(row: any): boolean {
    if (!row || !this.isApplicantRole()) {
      return false;
    }

    const matchedRow = this.findApplicationFor(row);
    const isDeficiencyRow = this.isDeficiencyStatus(row) || this.isDeficiencyStatus(matchedRow);
    if (!isDeficiencyRow) {
      return false;
    }

    const appId = this.resolveApplicationKey(row);
    if (this.hasDeficiencyDocumentValue(row)) {
      if (appId) {
        this.deficiencyAvailabilityByAppId[appId] = true;
      }
      return true;
    }

    const matchedAppId = this.resolveApplicationKey(matchedRow || row);
    if (this.hasDeficiencyDocumentValue(matchedRow)) {
      if (matchedAppId) {
        this.deficiencyAvailabilityByAppId[matchedAppId] = true;
      }
      return true;
    }

    // Check if we've already determined it's not available
    const checkedAppId = matchedAppId || appId;
    if (checkedAppId && Object.prototype.hasOwnProperty.call(this.deficiencyAvailabilityByAppId, checkedAppId)) {
      const isAvailable = this.deficiencyAvailabilityByAppId[checkedAppId];
      if (isAvailable === true) {
        return true;
      } else if (isAvailable === false) {
        return false;  // Already checked and confirmed not available
      }
    }

    // Trigger prefetch for applications not yet checked
    if (checkedAppId) {
      this.prefetchDeficiencyAvailability([matchedRow || row]);
    }

    // Show button for deficiency status applications (will attempt to fetch during download)
    return true;
  }

  private isDnqDownloadEligibleStatus(source: any): boolean {
    if (!source) {
      return false;
    }

    const rawStatus =
      source?.application_status ??
      source?.applicationStatus ??
      source?.status ??
      source?.strAppStatus;

    const normalized = String(rawStatus ?? '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
    if (!normalized) {
      return false;
    }

    return normalized.includes('analyst approved') || normalized.includes('partially approved');
  }

  private isDeficiencyStatus(source: any): boolean {
    if (!source) {
      return false;
    }

    const rawStatus =
      source?.application_status ??
      source?.applicationStatus ??
      source?.status ??
      source?.strAppStatus;

    const normalized = String(rawStatus ?? '').trim().toLowerCase();
    if (!normalized) {
      return false;
    }

    return normalized.includes('deficiency');
  }

  downloadExcel() {
    const columns = [
      { key: 'application_id', label: 'Application ID' },
      { key: 'application_type', label: 'Application Type' },
      { key: 'created_date', label: 'Created Date' },
      { key: 'submission_date', label: 'Submitted Date' },
      { key: 'application_status', label: 'Application Status' }
    ];
    const rows = this.filteredapplicationData || this.applicationData || [];
    this.commonService.exportToExcel(rows, columns, 'applications.xlsx');
  }


  private findApplicationFor(anyRow: any): any | null {
    if (!anyRow) return null;
    const found = this.findExistingApplication(this.applicationData, anyRow);
    return found || null;
  }

  onApplicationIdClick = (event: any): void => {
    if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    let selectedApp: any = null;

    // Support both row-object and id
    if (typeof event === 'object' && event !== null) {
      selectedApp = event;
    } else if (Array.isArray(this.applicationData)) {
      selectedApp = this.applicationData.find(app =>
        String(app.id).trim() === String(event).trim() ||
        String(app.application_id).trim() === String(event).trim()
      );
    } else if (this.applicationData && (String(this.applicationData?.id) === String(event))) {
      selectedApp = this.applicationData;
    }

    // If the clicked row is a document row, resolve app (existing logic)
    if (selectedApp && (selectedApp.document_id || selectedApp.documentId)) {
      const appMatch = Array.isArray(this.applicationData)
        ? this.applicationData.find((a: any) =>
            String(a.id) === String(selectedApp.applicationId) ||
            String(a.application_id) === String(selectedApp.application_id)
          )
        : null;

      if (appMatch) {
        selectedApp = { ...appMatch };
      } else {
        const docMatch = Array.isArray(this.documents)
          ? this.documents.find((d: any) =>
              String(d.documentId) === String(selectedApp.documentId) ||
              String(d.document_id) === String(selectedApp.document_id)
            )
          : null;

        if (docMatch && docMatch.submission_date) {
          const appFromDoc = Array.isArray(this.applicationData)
            ? this.applicationData.find((a: any) =>
                String(a.application_id) === String(docMatch.application_id) ||
                String(a.id) === String(docMatch.applicationId)
              )
            : null;

          if (appFromDoc) {
            selectedApp = { ...appFromDoc };
          } else {
            selectedApp = {
              id: docMatch.applicationId || selectedApp.applicationId || selectedApp.id,
              application_id: docMatch.application_id || selectedApp.application_id,
              submission_date: docMatch.submission_date || null,
              created_date: docMatch.created_date || null,
              application_status: docMatch.application_status || selectedApp.application_status,
              application_type: docMatch.application_type || selectedApp.application_type
            };
          }
        } else {
          const userId = this.sessionStorage.getItem('id');
          if (userId) {
            this.httpService.post(API_ENDPOINTS.applications, { userId })
              .pipe(take(1), takeUntil(this.destroy$))
              .subscribe({
                next: (response: any) => {
                  const items = response?.data?.data?.[0] || response?.data?.data || [];
                  const flatApps = items?.li_Application || items || [];
                  const found = Array.isArray(flatApps)
                    ? flatApps.find((a: any) =>
                        String(a.strAppId) === String(selectedApp.application_id) ||
                        String(a.strAppId) === String(selectedApp.applicationId))
                    : null;
                  if (found) {
                    const mapped = {
                      id: found.strAppId,
                      application_id: found.strAppId,
                      created_date: this.formatDate(new Date(found.dtDateCreated)),
                      submission_date: found.dtDateSubmitted ? this.formatDate(new Date(found.dtDateSubmitted)) : '',
                      application_status: found.strAppStatus,
                      application_type: found.strAppType
                    };
                    this.onApplicationIdClick(mapped as any);
                  } else {
                    console.warn('Could not resolve application for document; proceeding with document row');
                    this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));
                  }
                },
                error: (_err: any) => {
                  console.error('Fallback application fetch failed');
                  this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));
                }
              });
            return;
          }
        }
      }
    }

    if (selectedApp && (!selectedApp.application_status || !selectedApp.submission_date)) {
      const app = this.findApplicationFor(selectedApp);
      if (app) {
        // Merge keeping app’s truth for critical fields
        selectedApp = {
          ...selectedApp,
          id: app.id ?? selectedApp.id,
          application_id: app.application_id ?? selectedApp.application_id,
          application_type: selectedApp.application_type ?? app.application_type,
          created_date: app.created_date ?? selectedApp.created_date,
          submission_date: app.submission_date ?? selectedApp.submission_date ?? '',
          application_status: app.application_status ?? selectedApp.application_status
        };
      }
    }

    this.sessionStorage.setItem('applicationStatus', JSON.stringify(selectedApp?.application_status ?? null));

    if (selectedApp) {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
      const userId = user?.id || user?.user_id || user?.userId;

        const licenseApplicationType = selectedApp?.cd_application_type;
      const licensePath = selectedApp?.license_path ;

      console.log('[APP DASHBOARD] License data from API response:', {
        licenseApplicationType,
        licensePath
      });

      // Set license data in session storage
      if (licenseApplicationType) {
        this.sessionStorage.setItem('license-application-type', JSON.stringify(licenseApplicationType));
      }
      if (licensePath) {
        // Store license-path as plain string without JSON.stringify to avoid quote wrapping
        this.sessionStorage.setItem('license-path', licensePath.toString());
      }

       // making extension application as ReadOnly
    if(selectedApp?.application_type === "License Extension"){
      this.sessionStorage.setItem('applicationmode', JSON.stringify('view'));
    }

      if (!userId) {
        console.error('No valid user ID found in session storage');
        return;
      }
      const applicationId = selectedApp?.id || selectedApp?.application_id;

      this.myAppService
        .getPerson(userId, applicationId)
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe({
          next: (personResponse) => {
            const personData = personResponse.data[0];
            this.sessionStorage.setObj('personData', personData);
            this.sessionStorage.setItem('userIdForFetch',personData.user_id);
            this.sessionStorage.setItem('surrender', '');
            // suffix handling
            let suffixValue = '';
            if (personData.cd_suffix) {
              if (this.suffixData && this.suffixData.length > 0) {
                const foundItem = this.suffixData.find((item: any) => item.key === personData.cd_suffix);
                suffixValue = foundItem ? foundItem.value : '';
                personData.suffixValue = suffixValue; // Store suffix in personData for later use
                this.sessionStorage.setObj('personData', personData); // Update session storage with suffix
              } else {
                this.httpService.get(API_ENDPOINTS.SUFFIX).subscribe({
                  next: (response: any) => {
                    this.suffixData = response.data;
                    const foundItem = this.suffixData.find((item: any) => item.key === personData.cd_suffix);
                    suffixValue = foundItem ? foundItem.value : '';

                    const updatedEducatorName = personData.first_name && personData.last_name
                      ? `${personData.first_name} ${personData.last_name} `.trim()
                      : '';

                    const existingNavigationData = JSON.parse(this.sessionStorage.getObj('navigationData') || '{}');
                    if (existingNavigationData.bannerheader) {
                      existingNavigationData.bannerheader['Educator Name'] = updatedEducatorName;
                      this.sessionStorage.setObj('navigationData', existingNavigationData);
                    }
                  },
                  error: (error) => {
                    console.error('Error loading suffix data on demand:', error);
                  }
                });
              }
            }

            this.sessionStorage.setObj('personData', personData);
            const firstName = personData.legal_first_name || personData.first_name;
            const lastName = personData.legal_last_name || personData.last_name;
            const middleName = personData.middle_name;
            const educatorName =
              personData.first_name && personData.last_name
                ? `${personData.first_name} ${personData.middle_name} ${personData.last_name} ${suffixValue}`.trim()
                : '';
            // const bannerEducatorName= personData.first_name && personData.last_name
            //     ? `${personData.first_name} ${personData.last_name} `.trim()
            //     : '';
            const bannerEducatorName = firstName && lastName
                ? `${firstName} ${lastName} `.trim()
                : '';

            const isDraft = selectedApp.application_status &&
              selectedApp.application_status.toLowerCase() === 'in progress, not submitted';

            // FIX: Ensure we don't pass undefined dates
            const createdOrSubmitted = isDraft
              ? (selectedApp.created_date || '')
              : (selectedApp.submission_date || selectedApp.date_submitted || selectedApp.submitted_date || selectedApp.dateSubmitted || '');

            // Get License Path before creating banner header to maintain correct order
            const licensePathValue = this.sessionStorage.getItem('license-path');
            let licensePathLabel = '';
            if (licensePathValue && licensePathValue !== 'null') {
              licensePathLabel = this.getLicensePathLabel(licensePathValue);
            }
            const licensePathNotInclude = ['Resolve','Surrender','Name Change','License Extension']
            const bannerheader: any = {
              'Application ID': selectedApp.application_id,
              'Application Type': selectedApp.application_type,
              ...(licensePathLabel && !licensePathNotInclude.includes(selectedApp.application_type) &&
                { 'License Path': licensePathLabel }),
              'Educator Name': bannerEducatorName,
              [isDraft ? 'Created Date' : 'Submitted Date']: this.commonService.getFormatedDate(createdOrSubmitted)
            };
            // if (selectedApp.application_status) {
            //   bannerheader['Application Status'] = selectedApp.application_status;
            // }
            if (selectedApp.re_submitted_date && selectedApp.re_submitted_date !== '---') {
              bannerheader['Resubmitted Date'] = this.commonService.getFormatedDate(selectedApp.re_submitted_date);
            }

            if (this.license?.number && (licensePathValue !== '3' || selectedApp.application_type === 'Resolve')){
              bannerheader['License Number'] = this.license.number;
            }

            // Set cd_license_type in session storage
            const cdLicenseTypeForSession = this.preferredCdLicenseTypeForSession || this.license?.type;
            if (cdLicenseTypeForSession) {
              this.sessionStorage.setItem('cd_license_type', cdLicenseTypeForSession);
              console.log('[APP DASHBOARD] Stored cd_license_type in session:', cdLicenseTypeForSession);
            }

            if(selectedApp.application_type == 'Surrender'){
                this.sessionStorage.setItem('newSurrenderApplication', 'false');
                bannerheader['License Number'] = this.license.number;
               if(selectedApp.application_status == "In Progress, Not Submitted"){
                  this.sessionStorage.setItem('applicationStatus','In Progress,Not Submitted');
                  this.sessionStorage.setItem('surrender', 'createSurrender');
                this.sessionStorage.setItem('surrenderMode','edit');
                  this.sessionStorage.setItem('showDeleteButton','true');
               }else{
                  this.sessionStorage.setItem('applicationStatus',selectedApp.application_status);
                this.sessionStorage.setItem('surrenderMode','view');
               }
              }

            const inputFormatForAppData = { bannerheader };
           this.sessionStorage.setObj('navigationData', inputFormatForAppData);

            this.myAppService
              .getAppData(`personId=${personData.person_id}`)
              .pipe(take(1), takeUntil(this.destroy$))
              .subscribe({
                next: (appResponse) => {
                  const { activeversionid } = appResponse.data.data[0];
                  this.activeversionid = selectedApp.application_type == 'Surrender'? this.sessionStorage.getItem('surrenderActiveversionid') : activeversionid;
                  if (this.activeversionid) {
                    const numericAppId = selectedApp.dnqapplicationId || selectedApp.strApplication_id || selectedApp.id;
                    this.sessionStorage.setItem('youthID', JSON.stringify(numericAppId));
                    this.sessionStorage.setItem('youthNumber', JSON.stringify(selectedApp.application_id ?? selectedApp.id));
                    this.sessionStorage.setItem('applicationID', JSON.stringify(numericAppId));
                     this.sessionStorage.setItem('isFirstSave', 'false');
                     this.sessionStorage.setItem('applicationType', JSON.stringify(this.getApplicationTypeDisplayValue(selectedApp.application_type)));
                    this.sessionStorage.setItem('currApplicationType', JSON.stringify(this.getApplicationTypeDisplayValue(selectedApp.application_type)));
                    this.sessionStorage.setObj('backToHome', '/pages/my-app');
                    this.sessionStorage.setItem('backButtonText', 'Close');
                    this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/my-app' }));
                    this.fetchAndSetApplicationFee(licensePath);
                    this.sessionStorage.setItem('applicationType', JSON.stringify(selectedApp.application_type));
                    this.sessionStorage.setItem('currApplicationType', JSON.stringify(selectedApp.application_type));

                    const resolveBaseAppTypeKey = selectedApp?.resolve_base_application_type;
                    if (resolveBaseAppTypeKey && this.applicationtypes?.length > 0) {
                      const matchedType = this.applicationtypes.find(type => String(type.key) === String(resolveBaseAppTypeKey));
                      const resolveBaseAppTypeValue = matchedType ? matchedType.value : resolveBaseAppTypeKey;
                      this.sessionStorage.setItem('resolve_base_application_type', JSON.stringify(resolveBaseAppTypeValue));
                      console.log('[APP DASHBOARD] Stored resolve_base_application_type:', resolveBaseAppTypeValue);
                    }
                    const extendBaseAppTypeKey = selectedApp?.extend_base_application_type;
                    if (extendBaseAppTypeKey && this.applicationtypes?.length > 0) {
                      const matchedExtendType = this.applicationtypes.find(type => String(type.key) === String(extendBaseAppTypeKey));
                      const extendBaseAppTypeValue = matchedExtendType ? matchedExtendType.value : extendBaseAppTypeKey;
                      this.sessionStorage.setItem('extend_base_application_type', JSON.stringify(extendBaseAppTypeValue));
                      console.log('[APP DASHBOARD] Stored extend_base_application_type:', extendBaseAppTypeValue);
                    }
                    const addBaseAppTypeKey = selectedApp?.add_base_application_type;
                    if (addBaseAppTypeKey && this.applicationtypes?.length > 0) {
                      const matchedAddType = this.applicationtypes.find(type => String(type.key) === String(addBaseAppTypeKey));
                      const addBaseAppTypeValue = matchedAddType ? matchedAddType.value : addBaseAppTypeKey;
                      this.sessionStorage.setItem('add_base_application_type', JSON.stringify(addBaseAppTypeValue));
                      console.log('[APP DASHBOARD] Stored add_base_application_type:', addBaseAppTypeValue);
                    }
                    this.router.navigate([`/pages/dynamic-routing/tab/${this.activeversionid}`]);
                  } else {
                    console.error('No activeversionid found in app data');
                  }
                },
                error: (error) => {
                  console.error('Error getting app data:', error);
                }
              });
          },
          error: (error) => {
            console.error('Error getting person data:', error);
          }
        });
    } else {
      console.error('Application not found:', event);
    }
  }

  openDeleteModal(applicationNumber: string): void {
    const app = this.applicationData.find((a: any) => a.application_id === applicationNumber);
    this.selectedApplicationId = app ? app.id : null;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
    this.selectedApplicationId = null;
  }

  deleteApplication(onSuccess?: () => void): void {
    if (this.selectedApplicationId) {
      const userId = Number(this.sessionStorage.getItem('id'));
      this.httpService
        .post('/registration/delete-application', {
          applicationId: Number(this.selectedApplicationId),
          userId: userId
        })
        .subscribe({
          next: _response => {
            this.filteredapplicationData = this.filteredapplicationData.filter(
              (app: any) => app.application_id !== this.selectedApplicationId
            );
            this.closeDeleteModal();
            this.loadDashboardData();
            // Call the optional success callback
            if (onSuccess) {
              onSuccess();
            }
          },
          error: error => {
            console.error('Failed to delete application:', error);
            alert('Failed to delete the application. Please try again.');
          }
        });
    }
  }

  continueDraft() {
    if (this.draftApplication) {
      this.onApplicationIdClick(this.draftApplication);
    }
    this.showDraftModal = false;
    this.draftApplication = null;
    this.isResolveFlow = false;
    this.isAddEndroseFlow = false;
  }

  deleteAndStartNew() {
    const wasResolveFlow = this.isResolveFlow;
    const wasSurrenderFlow = this.isSurrenderFlow;
    const wasAddEndroseFlow = this.isAddEndroseFlow;
    this.showDraftModal = false;
    this.isResolveFlow = false;
    this.isSurrenderFlow = false;
    this.isAddEndroseFlow = false;

    if (this.draftApplication) {
      this.selectedApplicationId = this.draftApplication.id;
      this.draftApplication = null;
      this.selectedDraftApplicationType = '';

      // Delete and then handle the callback based on application type
      this.deleteApplication(() => {
        if (wasResolveFlow) {
          // For Resolve flow, create new Resolve after delete completes
          this.removeProvision(true);
        } else if (wasSurrenderFlow) {
          // For Surrender flow, create new Surrender after delete completes
          this.surrenderClick(true);
        } else if (wasAddEndroseFlow) {
          // For Surrender flow, create new Surrender after delete completes
          this.loadLicenseEndorsement(true);
        } else {
          // For other applications, open the application type dialog
          this.openApplicationTypeDialogAfterDelete();
        }
      });
    } else {
      this.draftApplication = null;
      this.selectedDraftApplicationType = '';
      if (wasResolveFlow) {
        this.removeProvision(true);
        } else if (wasSurrenderFlow) {
        this.surrenderClick();
      } else {
        this.openApplicationTypeDialogAfterDelete();
      }
    }
  }

  private openApplicationTypeDialogAfterDelete(): void {
    let dialogRef;
    if (this.isLicenseDataComplete) {
      const allowedTypes = this.applicationtypes.filter(type => {
        return type.value && type.value.trim().toLowerCase() === 'name change';
      });
      dialogRef = this.dialog.open(ApplicationTypeDialogComponent, {
        panelClass: 'custom-dialog-panel',
        data: undefined
      });
      if (dialogRef.componentInstance) {
        dialogRef.componentInstance.applicationTypes = allowedTypes;
      }
    } else {
      dialogRef = this.dialog.open(ApplicationTypeDialogComponent, {
        panelClass: 'custom-dialog-panel',
        data: undefined
      });
    }
    dialogRef.afterClosed().subscribe(_result => { });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    let clickedInside = false;
    const searchContainers = this.elRef.nativeElement.querySelectorAll('.search-container');
    searchContainers.forEach((container: HTMLElement) => {
      if (container.contains(event.target as Node)) {
        clickedInside = true;
      }
    });

    if (!clickedInside) {
      for (const key of Object.keys(this.searchStates)) {
        if (this.searchStates[key]) {
          this.searchStates[key] = false;
        }
      }
    }
  }

  openShowSubmittedModal(): void {
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md'
    };

    this.customModal = this.modalService.open(ModalComponent, options);

    const modalConfig: ModalConfig = {
      buttons: [
        { text: modalButtonTitles.ok, code: 'N', btnOutline: false }
      ],
      heading: modalHeading.applicationAlreadySubmitted,
      modalContent: modalContent.applicationAlreadySubmitted,
      hasTemplate: true,
      scrollable: true
    };

    this.customModal.componentInstance.modalConfig = modalConfig;
  }

  // =================== My Dashboard Methods ===================

  getUserId(): string | null {
    let userObj = this.commonService.getCurrentUserData();

    if (!userObj) {
      const userFromSession = this.sessionStorage.getItem('user');
      if (userFromSession) {
        userObj = JSON.parse(userFromSession);
      }
    }

    if (!userObj) {
      return null;
    }

    return userObj?.id || userObj?.user_id || userObj?.userId || null;
  }

  private getUserFullName(): string {
    const userObj = this.commonService.getCurrentUserData() ||
      JSON.parse(this.sessionStorage.getItem('user') || '{}');
    if (userObj?.firstname && userObj?.lastname) {
      return `${userObj.firstname} ${userObj.lastname}`;
    }
    return '';
  }

  loadDashboardData(): void {
    const userId = this.getUserId();

    if (!userId) {
      this.alertService.error('User information not found. Please login again.');
      return;
    }

    this.isLoading = true;
    this.loaderService.show();

    const payload = { userId };
    const appUserId = this.sessionStorage.getItem('id') || userId;

    forkJoin([
      this.httpService.post(API_ENDPOINTS.DASHBOARD_DATA, payload),
      this.httpService.get(API_ENDPOINTS.APPLICATION_TYPES_LOOKUP),
      this.httpService.get(API_ENDPOINTS.APPLICATION_STATUS_LOOKUP),
      this.httpService.get(API_ENDPOINTS.SUFFIX),
      this.httpService.get(API_ENDPOINTS.LOOKUP_GRADE_LEVEL),
      this.httpService.get(API_ENDPOINTS.LOOKUP_LICENSE_TYPES),
      this.httpService.get(API_ENDPOINTS.LOOKUP_ENDORSEMENT),
      this.httpService.get(API_ENDPOINTS.LOOKUP_LICENSE_REQUIREMENT_CATEGORY),
      this.httpService.get(API_ENDPOINTS.LOOKUP_LICENSE_PATH),
      this.httpService.get(API_ENDPOINTS.LOOKUP_MESSAGES),
      this.httpService.get(API_ENDPOINTS.TOAST_MESSAGES),
      this.httpService.get(API_ENDPOINTS.GENERIC_MESSAGES),
      this.httpService.get(API_ENDPOINTS.PLACEHOLDER_MESSAGES),
      this.httpService.post(API_ENDPOINTS.applications, { userId: appUserId }).pipe(
        catchError(_err => {
          return of({ data: { data: [] } });
        })
      )
    ])
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (responses: any[]) => {
          const response = responses[0];

          // Store lookup tables
          this.applicationtypes = responses[1].data;
          this.applicationStatus = responses[2].data;
          this.suffixData = responses[3].data;
          this.licensePathLookup = responses[8]?.data || [];

          const transformLookupArray = (arr: any[]): { [key: string]: string } => {
            const obj: { [key: string]: string } = {};
            if (Array.isArray(arr)) {
              arr.forEach((item: any) => {
                if (item.key && item.value) {
                  obj[item.key] = item.value;
                }
              });
            }
            return obj;
          };

          const gradeLeveMap = transformLookupArray(responses[4].data);
          const licenseTypeMap = transformLookupArray(responses[5].data);
          const endorsementMap = transformLookupArray(responses[6].data);
          const licenseRequirementMap = transformLookupArray(responses[7].data);

          localStorage.setItem('lookupGradeLevel', JSON.stringify(gradeLeveMap));
          localStorage.setItem('lookupLicenseTypes', JSON.stringify(licenseTypeMap));
          localStorage.setItem('lookupEndorsement', JSON.stringify(endorsementMap));
          localStorage.setItem('lookupLicenseRequirementCategory', JSON.stringify(licenseRequirementMap));

          this.storeLookupData({
            lookupMessages: responses[9].data,
            lookupToast: responses[10].data,
            lookupGeneric: responses[11].data,
            lookupPlaceholder: responses[12].data
          });
          this.lookupMessages = transformLookupArray(responses[9].data);
          this.lookupToast = transformLookupArray(responses[10].data);
          this.lookupGeneric = transformLookupArray(responses[11].data);
          this.lookupPlaceholder = transformLookupArray(responses[12].data);

          // Get detailed application data from the applications API
          const appsResponse = responses[13];

          // Support both response formats: { data: { data: [...] } } and { data: [...] }
          let detailedApps: any[] = [];
          if (Array.isArray(appsResponse?.data?.data)) {
            detailedApps = appsResponse.data.data;
          } else if (Array.isArray(appsResponse?.data)) {
            detailedApps = appsResponse.data;
          }

          // Accept response if it has the expected data structure - try multiple formats
          const dashboardData = response?.data?.data?.[0]
            || (response?.data?.li_Application ? response.data : null)
            || (response?.li_Application ? response : null);

          if (dashboardData && dashboardData.li_Application) {
            this.mapDashboardData(dashboardData, detailedApps);
          } else {
            this.alertService.error('Failed to load dashboard data.');
          }
        },
        error: (_error) => {
          this.alertService.error('Failed to load dashboard data. Please try again.');
          this.isLoading = false;
          this.loaderService.hide();
        },
        complete: () => {
          this.isLoading = false;
          this.loaderService.hide();
        }
      });
  }

private formatUtcTo12HourLocal(utcStr: string, timeZone: string): string {
  if (!utcStr) return '';

  let normalized = utcStr;
  if (!/Z$/.test(normalized) && !/\+\d{2}:?\d{2}$/.test(normalized)) {
    normalized += 'Z';
  }

  const date = new Date(normalized);

  const systemLocale =
    (typeof navigator !== 'undefined' && navigator.language)
      ? navigator.language
      : 'en-US';
  const datePart = new Intl.DateTimeFormat(systemLocale, {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);
  const timePart = new Intl.DateTimeFormat(systemLocale, {
    timeZone,
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  }).format(date);

  // Return without comma
  return `${datePart} ${timePart}`;
}



  private mapDashboardData(data: any, detailedApps: any[] = []): void {
    // Profile
    // Profile

const previousLoginUtc = data?.Obj_Profile?.dtPreviousLogin || '';
  const previousLoginEST = this.formatUtcTo12HourLocal(previousLoginUtc, FIXED_EST_TZ);

  this.profile = {
    name: data?.Obj_Profile?.strPersonName || '',
    email: data?.Obj_Profile?.strEmail || '',
    registered: data?.Obj_Profile?.dtDateCreated
      ? this.formatDate(new Date(data.Obj_Profile.dtDateCreated)) // "MM/DD/YYYY"
      : '',
    lastLogin: previousLoginEST, // "MM/DD/YYYY hh:mm AM/PM" in strict EST
    bannerHeaderName: data.Obj_Profile.strBannerHeaderName || ''
  };

  // Map Profile Data
    this.profile = {
      name: data.Obj_Profile.strPersonName || '',
      email: data.Obj_Profile.strEmail || '',
      registered: data.Obj_Profile.dtDateCreated
        ? new Date(data.Obj_Profile.dtDateCreated)
        : new Date(),
      lastLogin: previousLoginEST,
      bannerHeaderName: data.Obj_Profile.strBannerHeaderName || ''
    };

     // Map License Kind data from Obj_LicenseKind
    const licenseKindRows = Array.isArray(data?.Obj_LicenseKind)
      ? data.Obj_LicenseKind
      : (data?.Obj_LicenseKind ? [data.Obj_LicenseKind] : []);

    this.licenseKindGridRows = licenseKindRows.map((row: any) => ({
      licenseType: row?.strLicenseType || '---',
      licenseKind: row?.strLicenseKind || '---',
      endorsementGrade: row?.strEndorsement || '---',
      endorsementGradeArray: this.parseEndorsementGrades(row?.strEndorsement || ''),
      originalEffectiveDate: row?.dtOriginalEffectiveDate ? this.formatDate(new Date(row.dtOriginalEffectiveDate)) : '---',
      effectiveDate: row?.dtEffectiveDate ? this.formatDate(new Date(row.dtEffectiveDate)) : '---',
      expirationDate: row?.dtExpiryDate ? this.formatDate(new Date(row.dtExpiryDate)) : '---',
      licenseKindStatus: row?.strLicenseKindStatus || '---',
      extensionStatus: this.getExtensionEligibilityStatus(row?.dtExpiryDate),
      displayExtensionStatus: this.getDisplayEligibilityStatus(this.getExtensionEligibilityStatus(row?.dtExpiryDate))
    }));

    // License
    const licenseRows = Array.isArray(data?.Obj_License)
      ? data.Obj_License
      : (data?.Obj_License ? [data.Obj_License] : []);

    // Prefer extendable license row when present; otherwise use first row.
    const licenseData =
      licenseRows.find((row: any) => row?.boolIsExtend === true) ||
      licenseRows[0] ||
      {};

    // For add endrosement button visibility taking latest license expiry date:
    const licenseDatalatest = licenseRows
    .sort((a: any, b: any) => new Date(b.dtExpiryDate).getTime() - new Date(a.dtExpiryDate).getTime())[0] || {};

    this.latestLicenseExpirydate = licenseDatalatest.dtExpiryDate;

    // Prefer Standard/Professional license type for session storage when person has multiple licenses
    const preferredTypeRow = licenseRows.find((row: any) => {
      const t = String(row?.strLicenseType || '').trim().toLowerCase();
      return t === 'standard' || t === 'professional';
    });
    this.preferredCdLicenseTypeForSession = preferredTypeRow?.strLicenseType || licenseData?.strLicenseType || '';
    const endorsementValues = licenseRows
      .map((row: any) => String(row?.strEndorsement || row?.strCdEndorsement || '').trim())
      .filter((value: string) => !!value);
    const uniqueEndorsements = Array.from(new Set(endorsementValues));
    this.boolHideExtend = !!data?.boolHideExtend;
    this.boolEnableExtend = !!data?.boolEnableExtend;
this.licenseGridRows = licenseRows.map((row: any) => ({
      licenseType: row?.strLicenseType || '---',
      licenseKind: row?.strLicenseKind || row?.strCdLicenseKind || '---',
      endorsementGrade: row?.strEndorsement || row?.strCdEndorsement || '---',
      endorsementGradeArray: this.parseEndorsementGrades(row?.strEndorsement || ''),
      effectiveDate: row?.dtIssueDate ? this.formatDate(new Date(row.dtIssueDate)) : '---',
      originalEffectiveDate: row?.dtEndIssueDate ? this.formatDate(new Date(row.dtEndIssueDate)) : '---',
      endorsementPathway: row?.strEndorsementPathway || '---',
      expirationDate: row?.dtExpiryDate ? this.formatDate(new Date(row.dtExpiryDate)) : '---',
      endorsementStatus: row?.strEndoStatus || '---',
      extensionStatus: this.getExtensionEligibilityStatus(row?.dtExpiryDate),
      displayExtensionStatus: this.getDisplayEligibilityStatus(this.getExtensionEligibilityStatus(row?.dtExpiryDate)),
      application_id : row?.strApplicationId || ''
    }));

    //    this.licenseKindGridRows.forEach((kindRow: any) => {
    //   const matchingEndo = this.licenseGridRows.find((endoRow: any) =>
    //     endoRow.licenseType === kindRow.licenseType &&
    //     endoRow.licenseKind === kindRow.licenseKind &&
    //     endoRow.endorsementGrade === kindRow.endorsementGrade
    //   );
    //   if (matchingEndo && matchingEndo.endorsementStatus === 'Inactive') {
    //     kindRow.licenseKindStatus = 'Inactive';
    //     kindRow.extensionStatus = 'Ineligible';
    //     kindRow.displayExtensionStatus = this.getDisplayEligibilityStatus('Ineligible');
    //   }
    // });

    // this.licenseGridRows.forEach((endoRow: any) => {
    //   const matchingKind = this.licenseKindGridRows.find((kindRow: any) =>
    //     kindRow.licenseType === endoRow.licenseType &&
    //     kindRow.licenseKind === endoRow.licenseKind &&
    //     kindRow.endorsementGrade === endoRow.endorsementGrade
    //   );
    //   if (matchingKind && matchingKind.licenseKindStatus === 'Inactive') {
    //     endoRow.endorsementStatus = 'Inactive';
    //     endoRow.extensionStatus = 'Ineligible';
    //     endoRow.displayExtensionStatus = this.getDisplayEligibilityStatus('Ineligible');
    //   }
    // });

    const licenseStatusAfterCorrelation = this.calculateLicenseStatus(this.licenseGridRows, this.licenseKindGridRows);
    const parsedLicenseFee = Number(licenseData?.strLicenseExpirationFee);

    this.license = {
      number: licenseData?.strLicenseNumber || '',
      type: licenseData?.strLicenseType || '',
      cd_endo_status: licenseData?.cd_endo_status || '---',
      strEndoStatus: licenseData?.strEndoStatus || '---',
      strLicenseKind: licenseData?.strLicenseKind || licenseData?.strCdLicenseKind || '---',
      nameOnLicense: licenseData?.strNameOnLicense || '',
      //   status: licenseRows.every((row: any) =>
      //   (row?.strEndoStatus || '').toLowerCase() === 'inactive'
      // ) ? 'Inactive' : 'Active',
      status: licenseStatusAfterCorrelation,
      issueDate: licenseData?.dtIssueDate ? this.formatDate(new Date(licenseData.dtIssueDate)) : '',
      expirationDate: licenseData?.dtExpiryDate ? this.formatDate(new Date(licenseData.dtExpiryDate)) : '',
      application_id: licenseData?.strApplicationId || data.li_Application?.find((item)=> (item?.strAppStatus === 'Approved'))?.strAppId || '',
      id :  licenseData?.strApplicationId || '',
      applicationNumber: licenseData?.strApplicationId || '',
      licenseFee: Number.isFinite(parsedLicenseFee) ? parsedLicenseFee : undefined,
      extendable: !!licenseData?.boolIsExtend,
      extensionDuration: (licenseData?.intLicenseExtensionDuration as any) || '',
      strEndorsement: uniqueEndorsements.length > 0
        ? uniqueEndorsements.join(', ')
        : (licenseData?.strEndorsement || licenseData?.strCdEndorsement || '---'),

    };
    this.refreshLicenseGridData();
    this.refreshLicenseKindGridData();

    // Store license expiry date in session storage
    if (this.license.expirationDate) {
      this.sessionStorage.setItem('licenseExpiryDate', this.license.expirationDate);
    }
    if (this.license.issueDate) {
      this.sessionStorage.setItem('licenseIssueDate', this.license.issueDate);
    }
    // Store oldapplicationID using numeric application_id resolved from detailedApps.
    // this.license.application_id holds the application_number string (e.g. "A26-006901"),
    // so we look it up in detailedApps to get the actual integer id.
    const licenseAppNumber = this.license.application_id;
    const licenseDetailedApp = detailedApps.find((d: any) =>
      String(d.application_id || '').trim() === String(licenseAppNumber || '').trim()
    );
    const numericOldAppId = licenseDetailedApp?.id ?? licenseAppNumber;
    if (numericOldAppId) {
      this.sessionStorage.setItem('oldapplicationID', String(numericOldAppId));
    }
    // Completeness
    this.isLicenseDataComplete = this.checkLicenseDataCompleteness();
    this.dnqAvailabilityByAppId = {};
    this.dnqAvailabilityLoading.clear();
    this.deficiencyAvailabilityByAppId = {};
    this.deficiencyAvailabilityLoading = false;

    // Applications
    const existingApplications = Array.isArray(this.applicationData) ? this.applicationData : [];
    this.endroseflag = false;
    const statusLookupReverse: { [displayName: string]: string } = {};
    if (Array.isArray(this.applicationStatus)) {
      this.applicationStatus.forEach((s: any) => {
        if (s.key && s.value) {
          statusLookupReverse[s.value] = s.key;
        }
      });
    }

    this.applicationData = this.mapArrayData(data.li_Application, (app: any) => {
      const rawDateSubmitted = app.dtDateSubmitted;
      const hasDateSubmitted = rawDateSubmitted !== undefined && rawDateSubmitted !== null && rawDateSubmitted !== '';
      const formattedSubmission = hasDateSubmitted ? this.formatDate(new Date(rawDateSubmitted)) : '';
      const existingEntry = this.findExistingApplication(existingApplications, app);

      // Find the matching detailed app from API_ENDPOINTS.applications response
      const detailedApp = Array.isArray(detailedApps)
        ? detailedApps.find((d: any) =>
            String(d.application_id || '').trim() === String(app.strAppId || '').trim()
          )
        : null;

      const dnqCommunication =
        this.extractDnqCommunicationRaw(detailedApp) ??
        this.extractDnqCommunicationRaw(app) ??
        this.extractDnqCommunicationRaw(existingEntry);
      const dnqDueDate =
        detailedApp?.dnq_due_date ??
        detailedApp?.dnqDueDate ??
        app?.dnq_due_date ??
        app?.dnqDueDate ??
        app?.dtDNQDueDate ??
        existingEntry?.dnq_due_date ??
        existingEntry?.dnqDueDate ??
        null;
      const deficiencyDocument =
        this.extractDeficiencyDocumentRaw(detailedApp) ??
        this.extractDeficiencyDocumentRaw(app) ??
        this.extractDeficiencyDocumentRaw(existingEntry);
      const applicationKey = this.resolveApplicationKey(app) || this.resolveApplicationKey(existingEntry);
      if (applicationKey) {
        this.deficiencyAvailabilityByAppId[applicationKey] = this.hasDeficiencyDocumentValue({ deficiency_doc_url: deficiencyDocument });
      }

      // Use numeric id from detailed app data; fall back to strAppId
      const numericId = detailedApp?.id ?? detailedApp?.application_id ?? app.strAppId;

      const mergedCdStatus = detailedApp?.cd_application_status || app.cd_application_status || statusLookupReverse[app.strAppStatus] || '';
      const mergedBgRequired = detailedApp?.bg_required ?? app?.bg_required ?? existingEntry?.bg_required ?? false;
      const mergedBgStatusRaw =
        detailedApp?.background_check_status ??
        app?.background_check_status ??
        existingEntry?.background_check_status ??
        '-';
      const normalizedBgStatus = (() => {
        const normalized = String(mergedBgStatusRaw || '').trim().toLowerCase();
        if (!normalized || normalized === 'null' || normalized === '---') {
          return '-';
        }
        if (normalized === 'approved' || normalized === 'clear') {
          return 'Clear';
        }
        if (normalized === 'denied') {
          return 'Denied';
        }
        if (normalized === 'pending') {
          return 'Pending';
        }
        return String(mergedBgStatusRaw).trim();
      })();

      const derivedStatus = resolveQueueApplicationStatusDisplay(
        {
          application_status: String(mergedCdStatus || '').trim(),
          background_check_status: normalizedBgStatus,
          application_type: String(app.strAppType || detailedApp?.application_type || existingEntry?.application_type || '').trim(),
          bg_required: mergedBgRequired === true
        },
        DashboardAdmin,
        'dashboardadmin'
      );

      const mergedStatus = derivedStatus || detailedApp?.application_status || app.strAppStatus;

      // Name Change and License Extension display 'Analyst Approved' as 'Approved'
      const appTypeForStatus = String(
        app.strAppType || detailedApp?.application_type || existingEntry?.application_type || ''
      ).trim().toLowerCase();
      const finalStatus =
        (['name change', 'license extension'].includes(appTypeForStatus) &&
          String(mergedStatus || '').trim().toLowerCase() === 'analyst approved')
          ? 'Approved'
          : mergedStatus;

      let expirationDate = '';
      let createdDateRaw = app?.dtDateCreated ?? app?.created_date ?? detailedApp?.created_date;
      let created: Date | null = null;
      if (createdDateRaw) {
        if (typeof createdDateRaw === 'string' && createdDateRaw.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
          const [month, day, year] = createdDateRaw.split('/');
          created = new Date(`${year}-${month}-${day}`);
        } else {
          created = new Date(createdDateRaw);
        }
      }

      const normalizedStatus = (mergedStatus || '').toLowerCase();
      if ((app?.strAppType || '').toLowerCase() === 'regular - initial' && normalizedStatus.includes('approved')) {
        this.endroseflag = true;
      }

      if (normalizedStatus === 'in progress, not submitted') {
        if (created && !isNaN(created.getTime()) && this.purgeWindowDays !== null) {
          const purgeDate = new Date(created.getTime());
          purgeDate.setDate(purgeDate.getDate() + this.purgeWindowDays);
          expirationDate = this.formatDate(purgeDate);
        } else {
          expirationDate = '';
        }
      } else if (normalizedStatus.includes('deficiency')) {
        const deficiencyArchiveDate = app?.dtDeficiencyArchivalDate ?? detailedApp?.dtDeficiencyArchivalDate;
        expirationDate = deficiencyArchiveDate ? this.formatDate(new Date(deficiencyArchiveDate)) : '';
      } else if (normalizedStatus.includes('partially approved') || normalizedStatus.includes('analyst denied')) {
        const dnqArchiveDate = app?.dtDNQArchivalDate ?? detailedApp?.dtDNQArchivalDate;
        expirationDate = dnqArchiveDate ? this.formatDate(new Date(dnqArchiveDate)) : '';
      } else {
        const expiryDate = app?.dtExpiryDate ?? detailedApp?.dtExpiryDate;
        expirationDate = expiryDate ? this.formatDate(new Date(expiryDate)) : '';
      }

      const hasCaseCommunication =
        (Array.isArray(detailedApp?.case_communications) && detailedApp.case_communications.length > 0) ||
        (Array.isArray(app?.case_communications) && app.case_communications.length > 0) ||
        (Array.isArray(app?.commLogs) && app.commLogs.length > 0);

      const mappedApp = {
        ...(existingEntry || {}),
        ...(detailedApp || {}),
        ...app,
        id: numericId,
        application_id: app.strAppId,
        application_type: app.strAppType,
        created_date: this.formatDate(new Date(app.dtDateCreated)),
        submission_date: mergedStatus?.toUpperCase() === 'IN PROGRESS, NOT SUBMITTED' ? '' : formattedSubmission,
        application_status: finalStatus,
        cd_application_status: mergedCdStatus,
        bg_required: mergedBgRequired,
        background_check_status: normalizedBgStatus,
        dnq_communication: dnqCommunication,
        dnq_due_date: dnqDueDate,
        deficiency_doc_url: deficiencyDocument,
        expirationDate,
        hasCaseCommunication,
        dnqapplicationId: numericId,
        license_path: detailedApp?.license_path ?? app.license_path ?? existingEntry?.license_path ?? null,
        resolve_base_application_type: detailedApp?.resolve_base_application_type ?? app.resolve_base_application_type ?? existingEntry?.resolve_base_application_type ?? null,
        extend_base_application_type: detailedApp?.extend_base_application_type ?? app.extend_base_application_type ?? existingEntry?.extend_base_application_type ?? null,
        cd_application_type: detailedApp?.cd_application_type ?? existingEntry?.cd_application_type ?? null,
        is_archived: detailedApp?.is_archived ?? existingEntry?.is_archived ?? false,
        veteran_status_payment_required:
          app.veteran_status_payment_required ??
          detailedApp?.veteran_status_payment_required ??
          existingEntry?.veteran_status_payment_required ??
          null,
        additional_endorsements:
          app.additional_endorsements ??
          detailedApp?.additional_endorsements ??
          existingEntry?.additional_endorsements ??
          null,
        payment_pending: (() => {
          // Check if status is one of the required values
          const validStatus = ['19', '21', '40'].includes(mergedCdStatus?.toString() || '');
          // Check if any payment flag is true
          const hasPaymentFlag = !!(
            app.veteran_status_payment_required ??
            detailedApp?.veteran_status_payment_required ??
            existingEntry?.veteran_status_payment_required
          ) || !!(
            app.additional_endorsements ??
            detailedApp?.additional_endorsements ??
            existingEntry?.additional_endorsements
          );
          // payment_pending is true only when BOTH conditions are met
          return validStatus && hasPaymentFlag;
        })()
      };
      return mappedApp;
    });

    // Check if the most recent previous application (before current, excluding Name Changes)
    // was a License Extension — mirrors the SP get_payment_fee_breakdown logic exactly.
    // Sort ALL apps (including draft/in-progress) so the current draft stays at [0].
    // slice(1) skips [0] (the current app), then find the first non-NameChange submitted app.
    // This ensures a draft "In Progress, Not Submitted" app is correctly treated as current
    // and not removed before slice(1) — which would cause the License Extension to be skipped.
    const allAppsSorted = (Array.isArray(this.applicationData) ? this.applicationData : [])
      .sort((a: any, b: any) => {
        const dateA = new Date(a.created_date).getTime() || 0;
        const dateB = new Date(b.created_date).getTime() || 0;
        return dateB - dateA;
      });
    const lastBeforeCurrent = allAppsSorted
      .slice(1) // skip [0] (the current/most-recent application, draft or otherwise)
      .find((app: any) =>
        (app.application_status || '').toLowerCase() !== 'in progress, not submitted' &&
        !(['5', 'name change'].includes(String(app.application_type || '').toLowerCase()))
      );
    const hasApprovedExtension = !!(lastBeforeCurrent &&
      this.isLicenseExtension(lastBeforeCurrent.application_type));
    this.sessionStorage.setItem('has_approved_extension', JSON.stringify(hasApprovedExtension));

    this.loadUnreadMessageCount();
    this.canAddEndorsement();
    this.filteredapplicationData = this.applicationData;
    this.prefetchDnqAvailability(this.filteredapplicationData);
    this.prefetchDeficiencyAvailability(this.filteredapplicationData);

    // Backward compatibility array
    this.applications = this.mapArrayData(data.li_Application, (app: any) => ({
      id: app.strAppId,
      type: app.strAppType,
      dateCreated: new Date(app.dtDateCreated),
      dateSubmitted: new Date(app.dtDateSubmitted),
      status: app.strAppStatus,
      dnq_communication : app.dnq_communication
    }));

    // Documents (with submission_date from related app)
    this.documents = this.mapArrayData(data.li_Documents, (doc: any) => {
      const relatedApp = data.li_Application?.find((a: any) =>
        String(a.strAppId) === String(doc.strApplicationId) ||
        String(a.strAppId) === String(doc.strApplicationNumber)
      );
      const submission_date = relatedApp && relatedApp.dtDateSubmitted ? this.formatDate(new Date(relatedApp.dtDateSubmitted)) : null;
      return {
        id: doc.strApplicationId,
        application_id: doc.strApplicationNumber,
        applicationId: doc.strApplicationId,
        document_id: doc.strDocumentId,
        documentId: doc.strDocumentId,
        category: doc.strCategory,
        type: doc.strType,
        document_type: doc.strType,
        file_name: doc.strFileName,
        fileName: doc.strFileName,
        document_status: doc.strStatus,
        status: doc.strStatus,
        uploaded_by: doc.strUploadedBy,
        uploadedBy: doc.strUploadedBy,
        application_status: doc.strApplicationStatus,
        application_type: doc.strApplicationType,
        due_date: this.formatDate(new Date(doc.dtUploadedDate)),
        uploadDate: new Date(doc.dtUploadedDate),
        submission_date
      };
    });

    // License Requirements
    const mappedRequirements = this.mapArrayData(data.li_License_Requirement, (req: any) => {
      let sourceValue = req.strSource;
      let formattedSource = '---';
      
      if (Array.isArray(sourceValue)) {
        formattedSource = sourceValue.join(', ');
      } else if (typeof sourceValue === 'string' && sourceValue) {
        formattedSource = sourceValue.replace(/,(?!\s)/g, ', ');
      }
      
      return {
        id: req.strRequirement || '---',
        // category: req.strCategory || '---',
        category: this.toProperCase(req.strType || '---'),
        requirement: req.strRequirement || '---',
        // type: this.toProperCase(req.strType || '---'),
        type: req.strCategory || '---',
        source: formattedSource,
        due_date: req.dtDueDate ? this.formatDate(new Date(req.dtDueDate)) : '---',
        resolve_date: req.dtResolvedDate ? this.formatDate(new Date(req.dtResolvedDate)) : '---',
        status: req.strStatus || '---',
        originalStatus: req.strStatus || '',
        extensionStatus: req.strStatus?.toLowerCase() === 'resolved' ? 'Ineligible' : this.getExtensionEligibilityStatus(req.dtDueDate),
        displayExtensionStatus: this.getDisplayEligibilityStatus(req.strStatus?.toLowerCase() === 'resolved' ? 'Ineligible' : this.getExtensionEligibilityStatus(req.dtDueDate)),
        rowType: 'requirement',
        mark_resolved_flag: req.mark_resolved_flag ?? null
      };
    });

    // License Provisions — mapped to same shape and merged into the requirements table
    const mappedProvisions = this.mapArrayData(data.li_License_Provision, (prov: any) => {
      let sourceValue = prov.strSource;
      let formattedSource = '---';
      
      if (Array.isArray(sourceValue)) {
        formattedSource = sourceValue.join(', ');
      } else if (typeof sourceValue === 'string' && sourceValue) {
        formattedSource = sourceValue.replace(/,(?!\s)/g, ', ');
      }
      
      return {
        id: prov.strProvision || '---',
        // category: 'Provision',
        category: this.toProperCase(prov.strType || '---'),
        requirement: prov.strProvisionDetails || prov.strProvision || '---',
        // type: this.toProperCase(prov.strType || '---'),
        type: 'Provision',
        source: formattedSource,
        due_date: prov.dtDueDate ? this.formatDate(new Date(prov.dtDueDate)) : '---',
        resolve_date: prov.dtProvResolvedDate ? this.formatDate(new Date(prov.dtProvResolvedDate)) : '---',
        status: prov.strStatus || '---',
        originalStatus: prov.strStatus || '',
        extensionStatus: prov.strStatus?.toLowerCase() === 'resolved' ? 'Ineligible' : this.getExtensionEligibilityStatus(prov.dtDueDate),
        displayExtensionStatus: this.getDisplayEligibilityStatus(prov.strStatus?.toLowerCase() === 'resolved' ? 'Ineligible' : this.getExtensionEligibilityStatus(prov.dtDueDate)),
        rowType: 'provision',
        provision_details: prov.strProvisionDetails || '---',
        mark_resolved_flag: prov.mark_resolved_flag ?? null
      };
    });

    // Combined array — requirements first, then provisions
    this.licenseRequirements = [...mappedRequirements, ...mappedProvisions];

    // Keep licenseProvisions separately for any downstream business logic
    this.licenseProvisions = mappedProvisions;

    // Set hasLicenseProvisions flag based on li_License_Provision data
    this.hasLicenseProvisions = Array.isArray(data.li_License_Provision) && data.li_License_Provision.length > 0;

    // Update Resolve button visibility based on license provisions availability
    this.updateResolveButtonVisibility();

    if (Array.isArray(this.licenseRequirements) && this.licenseRequirements.length > 0) {
      const dueDates = this.licenseRequirements.map(req => req.due_date).filter(date => date);
      console.log('[APP DASHBOARD MAP] License requirement due dates:', dueDates);

      if (dueDates.length > 0) {
        this.sessionStorage.setItem('license-requirement-due-date', JSON.stringify(dueDates));
        console.log('[APP DASHBOARD MAP] Stored license-requirement-due-date in session storage:', dueDates);
      }
      this.sessionStorage.setItem('license-requirements-data', JSON.stringify(this.licenseRequirements));
    } else {
      console.log('[APP DASHBOARD MAP] No license requirements found');
    }

     // License Provisions
    const licenseProvisions = this.mapArrayData(data.li_License_Provision, (prov: any) => ({
      id: prov.strProvision || '',
      provision_details: prov.strProvisionDetails || '',
      due_date: prov.dtDueDate ? this.formatDate(new Date(prov.dtDueDate)) : '',
      status: prov.strStatus || ''
    }));

    // Store license provisions data in session storage for dynamic question logic
    if (Array.isArray(licenseProvisions) && licenseProvisions.length > 0) {
      const dueDates = licenseProvisions.map(prov => prov.due_date).filter(date => date);
      console.log('[APP DASHBOARD MAP] License provision due dates:', dueDates);

      if (dueDates.length > 0) {
        this.sessionStorage.setItem('license-provision-due-date', JSON.stringify(dueDates));
        console.log('[APP DASHBOARD MAP] Stored license-provision-due-date in session storage:', dueDates);
      }

      // Store full provisions data for business logic processing
      this.sessionStorage.setItem('license-provisions-data', JSON.stringify(licenseProvisions));
      console.log('[APP DASHBOARD MAP] Stored license-provisions-data in session storage:', licenseProvisions);
    } else {
      console.log('[APP DASHBOARD MAP] No license provisions found');
    }

    // Transactions
    this.transactions = this.mapArrayData(data.li_Transaction, (transaction: any) => {
      // FIX: join with related application to carry status and submitted date
      const relatedApp = data.li_Application?.find((a: any) =>
        String(a.strAppId) === String(transaction.strApplicationId) ||
        String(a.strAppId) === String(transaction.strApplicationNumber)
      );

      const submission_date = relatedApp && relatedApp.dtDateSubmitted
        ? this.formatDate(new Date(relatedApp.dtDateSubmitted))
        : '';

      const application_status = relatedApp?.strAppStatus || '';
      const formatDateLong = (date: Date) => {
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    };

      return {
        id: transaction.strApplicationId,
        personId: transaction.strPersonId,
        transactionType: transaction.strTransactionType,
        transactionStatus: (() => {
          const status = this.toProperCase(transaction.strTransactionStatus);
          return status === 'Declined' ? 'Denied' : status;
        })(),
        paymentTransactionId: transaction.strTransactionId || transaction.strPaymentTransactionId,
        payment_id: transaction.strPaymentId,  // Database primary key for payment_breakdown lookup
        paymentId: transaction.strPaymentId,   // CamelCase version
        applicantName: transaction.strApplicantName,
        invoiceNumber: transaction.strInvoiceNumber,
        receiptDate:formatDateLong(new Date()),
        amount: '$' + transaction.strAmount,
        transactionDate: this.formatDate(new Date(transaction.dtTransactionDate)),
        transaction_Date: new Date(transaction.dtTransactionDate),
        application_id: transaction.strApplicationNumber,
        application_type: transaction.strApplicationType,
        receiptTransactionDate: transaction.dtReceiptTransactionDate,
        // FIX: provide these so clicks from grid #3 have complete data
        submission_date,
        application_status
      } as any;
    });

    // Payment Breakdown
    this.paymentBreakdown = this.mapArrayData(data.li_payment_breakdown, (payment: any) => {

      const relatedApp = data.li_Application?.find((a: any) =>
        String(a.strAppId) === String(payment.strapplicationId) ||
        String(a.strAppId) === String(payment.strApplicationNumber)
      );
      return {
        id: payment.strapplicationId,
        application_id: payment.strapplicationNumber,
        invoiceNumber: payment.strInvoiceNumber,
        revenueCode: payment.cd_revenue_code,
        revenueCodeDesc: payment.revenue_code_desc || '---',
        feeCategoryKey: payment.strCdRevenueCodeKey ?? payment.cd_revenue_code_key ?? '',
        paymentHistoryId:
          payment.strPaymentHistoryId ??
          payment.strPaymentTransactionDetailId ??
          payment.payment_history_id ??
          '',
        rawTransactionDate: payment.strInvoiceDate || '',
       transactionDateTime: (() => {
          const rawDate = payment.strInvoiceDate;
          if (!rawDate) return '';
          const date = new Date(rawDate);
          if (isNaN(date.getTime())) return String(rawDate);
          return new Intl.DateTimeFormat('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          }).format(date);
        })(),
        receiptNumber: payment.strReceiptNumber || '---',
        quantity: payment.strQuantity,
        price: formatPaymentBreakdownPrice(payment),
        paymentAmount: formatPaymentBreakdownAmount(payment),
        paymentMethod: payment.strPaymentMethod?.toLowerCase() === 'card' ? 'CARD' : 'NA',
        comments: payment.strPaymentComment || ''
      } as any;
    });

    // Ensure headers exist
    if (!this.dashboardHeaders || this.dashboardHeaders.length === 0) {
      this.dashboardHeaders = [
        { dataField: 'application_id', caption: 'Application ID', label: 'Application ID', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
        { dataField: 'application_type', caption: 'Application Type', label: 'Application Type', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
        { dataField: 'created_date', caption: 'Date Created', label: 'Date Created', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'date' } },
        { dataField: 'submission_date', caption: 'Date Submitted', label: 'Date Submitted', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'date' } },
        { dataField: 'application_status', caption: 'Application Status', label: 'Application Status', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'string' } },
        { dataField: 'expirationDate', caption: 'Expiration Date', label: 'Expiration Date', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'date' } },
        { dataField: 're_submitted_date', caption: 'Resubmitted Date', label: 'Resubmitted Date', allowFiltering: true, allowSearch: { isSearchEnable: true, type: 'date' } }
      ];
      this.visibleColumns = {};
      this.dashboardHeaders.forEach(header => {
        this.visibleColumns[header.dataField] = true;
      });
      this.allColumns = this.dashboardHeaders;
    }

    // Update main grid
    this.dashboardDataGridConfig = DataGridVO.create({
      customHeaders: this.dashboardHeaders,
      visibleColumns: this.visibleColumns,
      data: this.filteredapplicationData,
      showNewDocumentIcon: true,
      showPaymentPendingIcon: true,
      role: 'my-app',
      activeTab: 'my-app'
    });

    // Filters
    this.appIdFilterOptions = this.getUniqueValues(this.applicationData, 'application_id');
    this.appTypeFilterOptions = this.getUniqueValues(
      this.applicationData,
      'application_type',
      (type) => this.getApplicationTypeDisplayValue(type)
    );

    // Load accordion section data
    this.loadDocumentsData();

    // Preserve previous startup behavior without invoking loadDropdownData.
    this.checkFirstTimeLoginAndShowModalOrLoadData();

    this.openDeficiencyModalIfNeeded();

    // Ensure change detection runs after all data is mapped
    this.cdr.detectChanges();
  }

  /**
   * Format date to MM/DD/YYYY format
   */
  private formatDate(date: Date | null): string {
    if (!date) return '';
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  private getUniqueValues<T>(data: T[], field: keyof T, transform?: (value: any) => any): any[] {
    return Array.from(new Set(data.map(item => transform ? transform((item as any)[field]) : (item as any)[field])));
  }

  private storeLookupData(lookups: { [key: string]: any }): void {
    Object.entries(lookups).forEach(([key, value]) => {
      localStorage.setItem(key, JSON.stringify(value));
    });
  }

  private mapArrayData<T, R>(data: T[], mapper: (item: T, index?: number) => R): R[] {
    return data?.map(mapper) || [];
  }

  private loadSectionHeaders(
    sectionKey: string,
    sectionTitle: string,
    jsonPath: string,
    showExport: boolean = true,
    showColumnChooser: boolean = true,
    customButtons: any[] = []
  ): void {
    this.commonService
      .getHeaderData(sectionKey, jsonPath)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (headers: any) => {
          if (Array.isArray(headers)) {
            const columns: ColumnConfig[] = headers.map((h: any) => ({
              key: h.dataField,
              width: h.width,
              minWidth: h.minWidth,
              label: h.caption || h.dataField,
              disabled: h.dataField === 'application_id'
            }));

            const section = this.sectionManager.createSection(
              sectionKey,
              sectionTitle,
              columns,
              [],
              '',
              showExport,
              showColumnChooser,
              customButtons
            );

            if (sectionKey === 'myDocuments') this.myDocumentsSection = section;
            else if (sectionKey === 'licenseRequirements') this.licenseRequirementsSection = section;
            else if (sectionKey === 'transactionHistory') this.transactionHistorySection = section;
            else if (sectionKey === 'paymentBreakdown') {
              this.paymentBreakdownSection = section;
              // Disable actions column for Payment Breakdown section
              if (this.paymentBreakdownSection.dataGridConfig) {
                this.paymentBreakdownSection.dataGridConfig = this.paymentBreakdownSection.dataGridConfig.updateConfig({
                  showActionsColumn: false
                });
              }
            }
          }
        }
      });
  }

  private initializeSections(): void {
    // Load My Documents section
    this.loadSectionHeaders(
      'myDocuments',
      'My Documents',
      '../assets/metadata/my-documents-header.json'
    );

    // Load License Requirements section with custom buttons
    const removeProvisionButton = [
    {
      type: 'button' as const,
      id: 'license_requirements_button_remove',
      title: 'Resolve',
      buttonText: 'Resolve',
      buttonClass: 'btn btn-primary btncommon py-2',
      visible: false,
      action: () => this.removeProvision()
    }
    ];

    this.loadSectionHeaders(
      'licenseRequirements',
      'License Provisions/Requirements',
      '../assets/metadata/license-requirements-header.json',
      false,
      false,
      removeProvisionButton
    );

    // Load Transaction History section
    this.loadSectionHeaders(
      'transactionHistory',
      'Transaction History',
      '../assets/metadata/transaction-history-header.json'
    );

    // Load Payment Breakdown section
    this.loadSectionHeaders(
      'paymentBreakdown',
      'Payment Breakdown',
      '../assets/metadata/payment-breakdown-header.json'
    );
  }
  addProvision() {
    if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    throw new Error('Method not implemented.');
  }

  /**
   * Updates the visibility of the Resolve button based on license provisions availability
   */
  private updateResolveButtonVisibility(): void {
    if (this.licenseRequirementsSection?.gridActions) {
      const resolveButtonIndex = this.licenseRequirementsSection.gridActions.findIndex(
        (action: any) => action.id === 'license_requirements_button_remove'
      );
      if (resolveButtonIndex !== -1) {
        this.licenseRequirementsSection.gridActions[resolveButtonIndex].visible = this.hasLicenseProvisions;
      }
    }
  }

  private loadMetadata(): void {
    this.commonService
      .getMetaData(QUEUE_CONSTANTS.METADATA_TYPE)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.tabs = res.tabs;
      });
  }

  private subscribeToRouteParams(): void {
    // Store the last URL to detect actual navigation to this component
    let lastUrl: string | null = null;

    // Listen to paramMap changes
    this.activatedRoute.paramMap
      .pipe(takeUntil(this.destroy$))
      .subscribe(_params => {
        this.loadDocumentsData();
      });

    // Listen to NavigationEnd events to reload data when navigating back to this route
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        const currentUrl = event.urlAfterRedirects || event.url;
        const isDashboardRoute = currentUrl.includes('/my-app') || currentUrl.includes('/license-dashboard');

        // Check if we came from a different route (not null = not first load, and was not on dashboard)
        const wasOnDifferentRoute = lastUrl !== null &&
          !lastUrl.includes('/my-app') &&
          !lastUrl.includes('/license-dashboard');

        // Update last URL for next comparison
        lastUrl = currentUrl;

        // If we navigated TO the dashboard FROM a different route, refresh all data
        if (isDashboardRoute && wasOnDifferentRoute) {
          this.refreshDashboard();
        }
      });
  }

  /**
   * Refresh dashboard data - used when navigating back to this page
   */
  private refreshDashboard(): void {
    // Reset all data arrays to ensure clean state
    this.applicationData = [];
    this.filteredapplicationData = [];
    this.applications = [];
    this.documents = [];
    this.transactions = [];
    this.licenseRequirements = [];
    this.licenseProvisions = [];
        this.licenseGridRows = [];
    // Reset filter states
    this.appIdFilterOptions = [];
    this.appIdFilterSelected = [];
    this.appTypeFilterOptions = [];
    this.appTypeFilterSelected = [];
    this.appStatusFilterOptions = [];
    this.appStatusFilterSelected = [];

    // Reset license data
    this.license = {
      number: '',
      type: '',
      nameOnLicense: '',
      status: '',
      issueDate: '',
      expirationDate: '',
      application_id: '',
      id: '',
      extendable: false
    };

    // Reinitialize sections to ensure clean grid state
    this.sectionManager = new AccordionGridSectionManager();
    this.initializeSections();

    // Reset loading state and reload data
    this.isLoading = true;
    this.initializeLicenseGridConfig();
    this.initializeLicenseKindGridConfig();
    this.loadDashboardHeaders();
    this.loadDashboardData();
    this.cdr.detectChanges();
  }

  loadDocumentsData(): void {
    // My Documents
    if (Array.isArray(this.documents) && this.documents.length > 0) {
      const documentsData = this.documents.map(doc => ({
        id: doc.id,
        application_id: doc.application_id,
        applicationId: doc.applicationId,
        document_id: doc.documentId,
        category: doc.category,
        type: doc.type,
        document_type: doc.type,
        file_name: doc.fileName,
        document_status: doc.status,
        due_date: doc.due_date,
        uploaded_by: doc.uploadedBy,
        submission_date: doc.submission_date,
        application_status: doc.application_status,
        application_type: doc.application_type
      }));
      this.sectionManager.updateSectionData('myDocuments', documentsData);
    } else {
      this.sectionManager.updateSectionData('myDocuments', []);
    }

    // License Requirements
    if (Array.isArray(this.licenseRequirements) && this.licenseRequirements.length > 0) {
      const licenseReqData = this.licenseRequirements.map(req => ({
        id: req.id,
        category: req.category,
        requirement: req.requirement,
        type: req.type,
        source: req.source,
        due_date: req.due_date,
        resolve_date: req.resolve_date,
        application_status: req.status,
        extensionStatus: req.extensionStatus,
        displayExtensionStatus: req.displayExtensionStatus
      }));

      // Sort: Resolved rows should appear last
      const sortedData = licenseReqData.sort((a, b) => {
        const aResolved = a.application_status?.toLowerCase() === 'resolved';
        const bResolved = b.application_status?.toLowerCase() === 'resolved';
        if (aResolved && !bResolved) return 1;
        if (!aResolved && bResolved) return -1;
        return 0;
      });

      this.sectionManager.updateSectionData('licenseRequirements', sortedData);
    } else {
      this.sectionManager.updateSectionData('licenseRequirements', []);
    }

    // Transaction History — display date-only; sort by raw timestamptz DESC then payment id DESC
    if (Array.isArray(this.transactions) && this.transactions.length > 0) {
      const transactionData = this.transactions.map(transaction => ({
        id: transaction.id,
        personId: transaction.personId,
        transactionType: transaction.transactionType,
        transactionStatus: transaction.transactionStatus,
        paymentTransactionId: transaction.paymentTransactionId,
        payment_id: (transaction as any).payment_id,  // Database primary key
        paymentId: (transaction as any).paymentId,    // CamelCase version
        applicantName: transaction.applicantName,
        invoiceNumber: transaction.invoiceNumber,
        receiptDate: transaction.receiptDate,
        amount: transaction.amount,
        transactionDate: transaction.transactionDate,
        transaction_Date: (transaction as any).transaction_Date,
        application_id: transaction.application_id,
        application_type: transaction.application_type,
        receiptTransactionDate: transaction.receiptTransactionDate,
        // FIX: pass through enriched fields to clicks from grid #3
        application_status: (transaction as any).application_status,
        submission_date: (transaction as any).submission_date,
      }));
      const toTime = (v: unknown): number => {
        if (v == null || v === '') return 0;
        const t = new Date(v as string | Date).getTime();
        return Number.isFinite(t) ? t : 0;
      };
      const toId = (v: unknown): number => {
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
      };
      transactionData.sort((a, b) => {
        const dateDiff = toTime(b.transaction_Date) - toTime(a.transaction_Date);
        if (dateDiff !== 0) return dateDiff;
        return toId(b.payment_id ?? b.paymentId) - toId(a.payment_id ?? a.paymentId);
      });
      this.sectionManager.updateSectionData('transactionHistory', transactionData);
    } else {
      this.sectionManager.updateSectionData('transactionHistory', []);
    }

    // Payment Breakdown
    if (Array.isArray(this.paymentBreakdown) && this.paymentBreakdown.length > 0) {
      const paymentBreakdownData = this.paymentBreakdown.map(payment => ({
        id: payment.id,
        application_id: payment.application_id,
        invoiceNumber: payment.invoiceNumber,
        revenueCode: payment.revenueCode,
        revenueCodeDesc: payment.revenueCodeDesc,
        transactionDateTime: payment.transactionDateTime,
        receiptNumber: payment.receiptNumber,
        quantity: payment.quantity,
        price: payment.price,
        paymentAmount: payment.paymentAmount,
        paymentMethod: payment.paymentMethod,
        comments: payment.comments,
        feeCategoryKey: payment.feeCategoryKey,
        paymentHistoryId: payment.paymentHistoryId,
        rawTransactionDate: payment.rawTransactionDate
      }));
      const sortedPaymentData = paymentBreakdownData.sort((a, b) =>
        comparePaymentBreakdownRows(
          {
            transactionDate: a.rawTransactionDate || a.transactionDateTime,
            cdRevenueCode: a.feeCategoryKey,
            paymentHistoryId: a.paymentHistoryId
          },
          {
            transactionDate: b.rawTransactionDate || b.transactionDateTime,
            cdRevenueCode: b.feeCategoryKey,
            paymentHistoryId: b.paymentHistoryId
          }
        )
      );
      this.sectionManager.updateSectionData('paymentBreakdown', sortedPaymentData);
    } else {
      this.sectionManager.updateSectionData('paymentBreakdown', []);
    }

    // Ensure change detection runs after section data is updated
    this.cdr.detectChanges();
  }

  navigateToMessageInbox(): void {
    this.router.navigate(['/pages/message-center']);
    this.appService.addValue('currentPage', 'Message Center');
    const currentMenu = JSON.parse(this.sessionStorage.getItem('CURRENTMENU') || '{}');
    currentMenu.name = 'Message Center';
    this.sessionStorage.setItem('CURRENTMENU', JSON.stringify(currentMenu));
  }
  private getCurrentUserIdForMessages(): number | null {
    try {
      const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
      const id = user?.id ?? user?.userId ?? user?.user_id ?? this.sessionStorage.getItem('id');
      if (id == null) return null;
      const num = typeof id === 'number' ? id : parseInt(String(id), 10);
      return isNaN(num) ? null : num;
    } catch {
      return null;
    }
  }
  loadUnreadMessageCount(): void {
    const userId = this.getCurrentUserIdForMessages();
    if (userId == null) return;

    const entityIds: number[] = [];
    if (this.license?.application_id) {
      const lid = parseInt(String(this.license.application_id), 10);
      if (!isNaN(lid)) entityIds.push(lid);
    }
    if (Array.isArray(this.applicationData)) {
      this.applicationData.forEach((app: any) => {
        const id = parseInt(String(app.id), 10);
        if (!isNaN(id) && !entityIds.includes(id)) entityIds.push(id);
      });
    }
    if (entityIds.length === 0) {
      this.unreadCountByApplicationId = {};
      this.cdr.detectChanges();
      return;
    }

    this.inAppMessageService
      .getUnreadCountsForMultipleEntities(entityIds, userId)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const body = res?.body !== undefined ? res.body : res;
          const data = Array.isArray(body?.data?.data)
            ? body.data.data
            : Array.isArray(body?.data)
              ? body.data
              : Array.isArray(body)
                ? body
                : [];
          const byId: Record<number, number> = {};
          data.forEach((row: any) => {
            const entityId = Number(row?.message_entity_id);
            if (!isNaN(entityId)) {
              byId[entityId] = Number(row?.count) || 0;
            }
          });
          this.unreadCountByApplicationId = byId;
          setTimeout(() => this.cdr.detectChanges(), 0);
        },
        error: () => {
          this.unreadCountByApplicationId = {};
          setTimeout(() => this.cdr.detectChanges(), 0);
        }
      });
  }

  getUnreadCountForApplication(appId: number | string | null | undefined): number {
    if (appId == null) return 0;
    const id = typeof appId === 'number' ? appId : parseInt(String(appId), 10);
    return isNaN(id) ? 0 : (this.unreadCountByApplicationId[id] ?? 0);
  }

  //  Navigate to in-app messaging for the given application row.
  openInAppMessaging(rowData: any): void {
    const id = rowData?.id;
    if (id == null || id === '') {
      return;
    }
    this.router.navigate(['/pages/in-app-message', id]);
  }

  downloadDocument(data: any): void {
    if (!data || !data.application_id || !data.document_id) {
      this.alertService.error('Document information is missing');
      return;
    }

    this.loaderService.show();

    const payload = {
      applicationId: data.applicationId,
      documentId: data.document_id,
      documentType: data.document_type || data.type
    };

    this.httpService
      .post(API_ENDPOINTS.DOCUMENT_DOWNLOAD, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.status === 'success' && response?.data?.data?.p_document_blob?.strfileHash) {
            const fileUrl = response.data.data.p_document_blob.strfileHash;
            fetch(fileUrl)
              .then(res => res.blob())
              .then(blob => {
                const fileName = data.file_name || `document_${data.document_id}`;
                FileSaver.saveAs(blob, fileName);
                this.alertService.success('Document downloaded successfully');
              })
              .catch(_error => {
                this.alertService.error('Failed to download document file');
              })
              .finally(() => {
                this.loaderService.hide();
              });
          } else {
            this.alertService.error('Failed to download document');
            this.loaderService.hide();
          }
        },
        error: (_error) => {
          this.alertService.error('Failed to download document. Please try again.');
          this.loaderService.hide();
        }
      });
  }

  viewDocument(data: any): void {
    if (!data || !data.application_id || !data.document_id) {
      this.alertService.error('Document information is missing');
      return;
    }

    this.loaderService.show();

    const loaderInterval = window.setInterval(() => {
      this.loaderService.show();
    }, 100);

    const payload = {
      applicationId: data.applicationId,
      documentId: data.document_id,
      documentType: data.document_type || data.type
    };

    this.httpService
      .post(API_ENDPOINTS.DOCUMENT_DOWNLOAD, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.status === 'success' && response?.data?.data?.p_document_blob?.strfileHash) {
            const fileUrl = response.data.data.p_document_blob.strfileHash;

            fetch(fileUrl)
              .then(res => res.blob())
              .then(_blob => {
                this.alertService.success('Document open successfully');
                window.open(fileUrl, '_blank');
              })
              .catch(_error => {
                this.alertService.error('Failed to view document file');
              })
              .finally(() => {
                window.clearInterval(loaderInterval);
                this.loaderService.hide();
              });
          } else {
            this.alertService.error('Failed to view document');
            window.clearInterval(loaderInterval);
            this.loaderService.hide();
          }
        },
        error: (_error) => {
          this.alertService.error('Failed to view document. Please try again.');
          window.clearInterval(loaderInterval);
          this.loaderService.hide();
        }
      });
  }

  onMyDocumentsExport(): void {
    this.downloadExcelForSection('myDocuments');
  }
  onMyDocumentsColumnChooserToggle(): void {
    this.sectionManager.toggleColumnChooser('myDocuments');
  }
  onMyDocumentsColumnToggle(event: { key: string; col: ColumnConfig }): void {
    this.sectionManager.toggleColumnVisibility('myDocuments', event.key);
  }
  onMyDocumentsColumnChooserClose(): void {
    this.sectionManager.closeColumnChooser('myDocuments');
  }

  onLicenseRequirementsExport(): void {
    this.downloadExcelForSection('licenseRequirements');
  }
  onLicenseRequirementsColumnChooserToggle(): void {
    this.sectionManager.toggleColumnChooser('licenseRequirements');
  }
  onLicenseRequirementsColumnToggle(event: { key: string; col: ColumnConfig }): void {
    this.sectionManager.toggleColumnVisibility('licenseRequirements', event.key);
  }
  onLicenseRequirementsColumnChooserClose(): void {
    this.sectionManager.closeColumnChooser('licenseRequirements');
  }

  onTransactionHistoryExport(): void {
    this.downloadExcelForSection('transactionHistory');
  }
  onTransactionHistoryColumnChooserToggle(): void {
    this.sectionManager.toggleColumnChooser('transactionHistory');
  }
  onTransactionHistoryColumnToggle(event: { key: string; col: ColumnConfig }): void {
    this.sectionManager.toggleColumnVisibility('transactionHistory', event.key);
  }
  onTransactionHistoryColumnChooserClose(): void {
    this.sectionManager.closeColumnChooser('transactionHistory');
  }

  onPaymentBreakdownExport(): void {
    this.downloadExcelForSection('paymentBreakdown');
  }
  onPaymentBreakdownColumnChooserToggle(): void {
    this.sectionManager.toggleColumnChooser('paymentBreakdown');
  }
  onPaymentBreakdownColumnToggle(event: { key: string; col: ColumnConfig }): void {
    this.sectionManager.toggleColumnVisibility('paymentBreakdown', event.key);
  }
  onPaymentBreakdownColumnChooserClose(): void {
    this.sectionManager.closeColumnChooser('paymentBreakdown');
  }

  downloadExcelForSection(sectionId: string): void {
    const section = this.sectionManager.getSection(sectionId);
    if (!section) return;

    let dataGridComponent: DataGridComponent | null = null;
    if (sectionId === 'myDocuments') {
      dataGridComponent = this.myDocumentsGrid;
    } else if (sectionId === 'licenseRequirements') {
      dataGridComponent = this.licenseRequirementsGrid;
    } else if (sectionId === 'transactionHistory') {
      dataGridComponent = this.transactionHistoryGrid;
    }

    let rows: any[] = [];
    if (dataGridComponent) {
      rows = dataGridComponent.getFilteredDataFromGrid();
    } else {
      rows = Array.isArray(section.data) ? section.data : [];
    }

    const columns = section.allColumns.filter(col => section.visibleColumns[col.key]);

    if (columns.length === 0) {
      return;
    }

    if (rows.length === 0) {
      return;
    }

    const header = columns.map(col => col.label);
    const data = rows.map(row => {
      return columns.map(col => {
        const v = (row as any)[col.key] ?? (row as any)[col.key.toLowerCase()] ?? '';
        if (v instanceof Date) {
          return this.formatDate(v);
        }
        return typeof v === 'object' ? JSON.stringify(v) : String(v);
      });
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');

    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

    data.forEach(r => {
      worksheet.addRow(r);
    });

    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });

    worksheet.columns.forEach(col => {
      (col as any).width = 30;
    });

    workbook.xlsx.writeBuffer().then(buffer => {
      const fileName = `application-dashboard-${section.title.replace(/\s+/g, '_')}.xlsx`;
      FileSaver.saveAs(
        new Blob([buffer]),
        fileName
      );
    });
  }

 onExtendLicense(): void {
    if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    const newExpirationDate = this.license.extensionDuration as any;
    const fallbackFee = Number(this.license?.licenseFee);
    const defaultFee = Number.isFinite(fallbackFee) ? fallbackFee : 0;

    this.httpService.get('/domain/lookup?requestType=FEE_CATEGORY')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
          const renewalExtensionRow = data.find((item: any) => {
            const key = String(item?.key ?? '').trim();
            const value = String(item?.value ?? '').trim().toLowerCase();
            return key === '4' && value === 'renewal_extension';
          }) || data.find((item: any) => String(item?.key ?? '').trim() === '4');

          const feeFromLookup = this.extractFeeFromOptionalData(renewalExtensionRow?.optionaldata);
          this.showExtendLicenseModal(newExpirationDate, Number.isFinite(feeFromLookup as number) ? (feeFromLookup as number) : defaultFee);
        },
        error: () => {
          this.showExtendLicenseModal(newExpirationDate, defaultFee);
        }
      });
  }

  private extractFeeFromOptionalData(optionalData: any): number | undefined {
    try {
      const parsed = typeof optionalData === 'string' ? JSON.parse(optionalData) : optionalData;
      const fee = Number(parsed?.fee);
      return Number.isFinite(fee) ? fee : undefined;
    } catch {
      return undefined;
    }
  }

  private showExtendLicenseModal(newExpirationDate: string, licenseFee: number): void {
    const options: NgbModalOptions = {
      backdrop: 'static',
      centered: true,
      size: 'md'
    };

    this.extendLicenseModal = this.modalService.open(ModalComponent, options);

    const userData = this.commonService.getCurrentUserData();
    const firstName = userData?.firstname || '';
    const lastName = userData?.lastname || '';
    const userFullName = `${firstName} ${lastName}`.trim();

    const isIneligible = (value: any): boolean => String(value ?? '').trim().toLowerCase() === 'ineligible';

    const ineligibleRows = Array.isArray(this.licenseRequirements)
      ? this.licenseRequirements.filter((row: any) => isIneligible(row?.status) || isIneligible(row?.extensionStatus))
      : [];

    const hasIneligibleProvisions = ineligibleRows.some((row: any) => {
      const category = String(row?.category ?? '').trim().toLowerCase();
      const rowType = String(row?.rowType ?? '').trim().toLowerCase();
      return category.includes('provision') || rowType === 'provision';
    });

    const hasIneligibleLicenseRequirements = ineligibleRows.some((row: any) => {
      const category = String(row?.category ?? '').trim().toLowerCase();
      const rowType = String(row?.rowType ?? '').trim().toLowerCase();
      if (rowType === 'requirement') {
        return true;
      }
      if (!category) {
        return false;
      }
      return category.includes('license requirement') || category.includes('requirement');
    });

    const rawEndorsements = (Array.isArray((this.license as any)?.endorsements)
      ? (this.license as any).endorsements
      : [
        (this.license as any)?.endorsements,
        (this.license as any)?.strEndorsement
      ])
      .flatMap((value: any) => {
        if (value === null || value === undefined) {
          return [];
        }
        if (typeof value === 'string') {
          return value
            .split(/[|,;/]+/)
            .map((v: string) => v.trim())
            .filter((v: string) => v && v !== '---');
        }
        return [value];
      });

    const licenseDetailRows = Array.isArray(this.licenseGridRows) ? this.licenseGridRows : [];
    const endorsementLicenseRows = licenseDetailRows.filter((row: any) => {
      const endorsement = String(row?.endorsementGrade ?? '').trim();
      return !!endorsement && endorsement !== '---';
    });

    const hasAnyEndorsement = rawEndorsements.length > 0 || endorsementLicenseRows.length > 0;
    const endorsementStatus =
      (this.license as any)?.cd_endo_status ??
      (this.license as any)?.strEndoStatus ??
      (this.license as any)?.extensionStatus ??
      (this.license as any)?.strEndorsementStatus;
    const licenseDetailExtensionStatus = this.getExtensionEligibilityStatus(this.license?.expirationDate);
    const endorsementStatusIneligible = isIneligible(endorsementStatus);
    const licenseDetailIneligible = isIneligible(licenseDetailExtensionStatus);

    const hasAnyIneligibleEndorsementRow = endorsementLicenseRows.some((row: any) =>
      isIneligible(row?.endorsementStatus) || isIneligible(row?.extensionStatus)
    );

    const hasAnyEligibleEndorsementRow = endorsementLicenseRows.some((row: any) => {
      const endorsementStatusValue = String(row?.endorsementStatus ?? '').trim().toLowerCase();
      const extensionStatusValue = String(row?.extensionStatus ?? '').trim().toLowerCase();
      return endorsementStatusValue === 'eligible' || extensionStatusValue === 'eligible';
    });

    const oneEndorsementIneligible = hasAnyEndorsement && (
      endorsementStatusIneligible ||
      licenseDetailIneligible ||
      hasAnyIneligibleEndorsementRow ||
      rawEndorsements.some((entry: any) => {
        if (entry && typeof entry === 'object') {
          return (
            isIneligible(entry?.status) ||
            isIneligible(entry?.cd_endo_status) ||
            isIneligible(entry?.endorsementStatus) ||
            isIneligible(entry?.strEndorsementStatus) ||
            isIneligible(entry?.extensionStatus)
          );
        }
        return isIneligible(entry);
      })
    );

    const hasAnyExplicitEligibleEndorsement = rawEndorsements.some((entry: any) => {
      if (entry && typeof entry === 'object') {
        return (
          String(entry?.status ?? '').trim().toLowerCase() === 'eligible' ||
          String(entry?.cd_endo_status ?? '').trim().toLowerCase() === 'eligible' ||
          String(entry?.endorsementStatus ?? '').trim().toLowerCase() === 'eligible' ||
          String(entry?.strEndorsementStatus ?? '').trim().toLowerCase() === 'eligible' ||
          String(entry?.extensionStatus ?? '').trim().toLowerCase() === 'eligible'
        );
      }
      return false;
    }) || hasAnyEligibleEndorsementRow;

    const allEntriesMarkedIneligible = endorsementLicenseRows.length > 0
      ? endorsementLicenseRows.every((row: any) =>
        isIneligible(row?.endorsementStatus) || isIneligible(row?.extensionStatus)
      )
      : (rawEndorsements.length === 1
        ? oneEndorsementIneligible
        : rawEndorsements.every((entry: any) => {
          if (entry && typeof entry === 'object') {
            return (
              isIneligible(entry?.status) ||
              isIneligible(entry?.cd_endo_status) ||
              isIneligible(entry?.endorsementStatus) ||
              isIneligible(entry?.strEndorsementStatus) ||
              isIneligible(entry?.extensionStatus)
            );
          }
          return isIneligible(entry);
        }));

    const statusImpliesAllIneligible =
      (endorsementStatusIneligible || licenseDetailIneligible) && !hasAnyExplicitEligibleEndorsement;

    const allEndorsementsIneligible = hasAnyEndorsement && (statusImpliesAllIneligible || allEntriesMarkedIneligible);

    const licenseKinds = allEndorsementsIneligible ? 'License Kinds' : '';
    const endorsements = hasAnyEndorsement && (oneEndorsementIneligible || allEndorsementsIneligible) ? 'Endorsements' : '';
    const provisions = hasIneligibleProvisions ? 'Provisions' : '';
    const licenseRequirements = hasIneligibleLicenseRequirements ? 'License Requirements' : '';

    const modalConfig: ModalConfig = {
      buttons: [
        { text: modalButtonTitles.cancel, code: 'N', btnOutline: true },
        { text: modalButtonTitles.extend, code: 'Y', btnOutline: false }
      ],
      heading: modalHeading.extendLicense,
      modalContent: modalContent.licenseContent(
        newExpirationDate,
        licenseFee,
        licenseKinds,
        endorsements,
        provisions,
        licenseRequirements
      ),
      hasTemplate: true,
      scrollable: false,
      modalContentClass: 'info-box',
      modalInputArray: [
        {
          label: 'Signature <span class="text-danger">*</span>',
          fieldName: 'strFullName',
          value: '',
          type: 'text',
          placeholder: 'Enter First and Last Name',
          tooltip: 'First and last name only. Do not include middle name or suffix.',
          content: 'Please sign using the approved name on record even if you have changed your name.'
        }
      ]
    };

    this.extendLicenseModal.componentInstance.modalConfig = modalConfig;
    this.extendLicenseModal.componentInstance.userFullName = userFullName;
    this.extendLicenseModal.componentInstance.lookupMessages = this.lookupGeneric;

    this.extendLicenseModal.result.then(
      (result) => {
        if (result && result.code === 'Y') {
          this.handleExtendLicenseSubmit(result.data);
        }
      },
      () => {
        // dismissed
      }
    );
  }

  private handleExtendLicenseSubmit(data: any): void {
    const signature = data?.strFullName?.trim();

    if (!signature) {
      this.alertService.error('Signature is required');
      return;
    }

    this.loaderService.show();
    this.validateLicenseDateWithDB(() => {
      const extensionDays = Number((this.license as any).extensionDuration);
      const currentExpiry = this.license.expirationDate;
      const computedExpiryDate = (currentExpiry && extensionDays > 0)
        ? moment(currentExpiry, 'MM/DD/YYYY').add(extensionDays, 'days').format('MM/DD/YYYY')
        : currentExpiry;

      // Gather due dates from license requirements and provisions session storage
      const requirementDueDates: string[] = JSON.parse(this.sessionStorage.getItem('license-requirement-due-date') || '[]');
      const provisionDueDates: string[] = JSON.parse(this.sessionStorage.getItem('license-provision-due-date') || '[]');
      const allDueDates = [...requirementDueDates, ...provisionDueDates]
        .filter((d: string) => !!d && d !== '---')
        .map((d: string) => moment(d, 'MM/DD/YYYY'))
        .filter((m: any) => m.isValid())
        .sort((a: any, b: any) => a.valueOf() - b.valueOf());
      const earliestDueDate = allDueDates.length > 0 ? allDueDates[0].format('MM/DD/YYYY') : computedExpiryDate;

      const licenseExtensionStatus = this.getExtensionEligibilityStatus(this.license.expirationDate);
      const isExpiryEligible = licenseExtensionStatus === 'Eligible';

      const dueDateExtensionStatus = earliestDueDate ? this.getExtensionEligibilityStatus(earliestDueDate) : 'Ineligible';
      const isDueDateEligible = dueDateExtensionStatus === 'Eligible';

      const payload: any = {
        licenseNumber: this.license.number,
        userId: this.getUserId(),
        applicationNumber: (this.license as any).applicationNumber,
        signature: signature,
      };

      this.httpService.patch(API_ENDPOINTS.EXTEND_LICENSE, payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response: any) => {
            this.loaderService.hide();
            if (response?.data?.success) {
              const newExtensionApp = response?.data?.data;
              if (newExtensionApp) {
                const extendBaseAppTypeKey = newExtensionApp.extend_base_application_type;
                if (extendBaseAppTypeKey && this.applicationtypes?.length > 0) {
                  const matchedExtendType = this.applicationtypes.find(type => String(type.key) === String(extendBaseAppTypeKey));
                  const extendBaseAppTypeValue = matchedExtendType ? matchedExtendType.value : extendBaseAppTypeKey;
                  this.sessionStorage.setItem('extend_base_application_type', JSON.stringify(extendBaseAppTypeValue));
                  console.log('[EXTEND LICENSE] Stored extend_base_application_type:', extendBaseAppTypeValue);
                }
                const extLicensePath = newExtensionApp.license_path;
                if (extLicensePath !== undefined && extLicensePath !== null && String(extLicensePath) !== '') {
                  this.sessionStorage.setItem('license-path', extLicensePath.toString());
                  console.log('[EXTEND LICENSE] Stored license-path:', extLicensePath);
                }
              }
              this.alertService.success(this.lookupToast?.['T0053'] || 'License extended', true);
              this.loadDashboardData();
            } else {
              this.alertService.error(response?.data?.message || 'Failed to extend license');
            }
          },
          (_error) => {
            this.loaderService.hide();
            this.alertService.error('An error occurred while extending the license');
          }
        );
    });
  }

  tempLockQueue(_rowData: any): void {
    // Implement temp lock logic if needed
  }

  onAssignSuccess(): void {
    this.loadDashboardData();
  }

  onAssign(record: any, assign: boolean, selectedStaffMemberId?: any, personsByRole?: any): void {
    if (!record || !record.application_id) {
      return;
    }

    const userId = this.getUserId();
    if (!userId) {
      return;
    }

    const assignToUserId = selectedStaffMemberId || userId;

    let assignedToFullName = '';
    if (selectedStaffMemberId && personsByRole) {
      const selectedPerson = personsByRole.find(
        (person: any) => (person.id || person.user_id || person.userId || person.person_id) === selectedStaffMemberId
      );
      if (selectedPerson) {
        assignedToFullName = selectedPerson.full_name;
      }
    }

    const payload = {
      applicationNumber: record.id,
      userId: assign ? assignToUserId : null,
      lockStatus: assign ? LOCK_STATUS_CODES.LOCKED : LOCK_STATUS_CODES.UNLOCKED
    };

    this.httpService
      .post(API_ENDPOINTS.TEMP_LOCK_QUEUE_APPLICATION, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (_response: any) => {
          if (assign === true) {
            record.lockstatus = LOCK_STATUS_CODES.LOCKED;
            record.locked_by_user_id = assignToUserId;
            record.locked_by = assignedToFullName || assignToUserId;
          } else {
            record.lockstatus = LOCK_STATUS_CODES.UNLOCKED;
            record.locked_by_user_id = null;
          }
          this.onAssignSuccess();
        },
        error: _error => {
          if (assign === true) {
            this.alertService.error(errorMessages.assignMsg);
          } else {
            this.alertService.error(errorMessages.unassignMsg);
          }
        }
      });
  }

 removeProvision(skipDraftCheck: boolean = false): void {
  if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    // Reset stale flow session before starting Resolve application
    this.clearApplicationFlowSession();
    if (!skipDraftCheck) {
      // Check for existing submitted (non-closed) application (same logic as Start New Application)
      const closedCdStatuses = ['9', '11', '16', '41'];
      const closedStatuses = ['approved',
                              'denied',
                              'in progress, not submitted',
                              'automatic approved',
                              'intake pending + bg denied',
                              'deficiency pending + bg denied',
                              'analyst pending + bg denied',
                              'analyst denied + bg approved',
                              'analyst denied + bg denied',
                              'partially approved + bg approved',
                              'partially approved + bg denied',
                              'analyst approved + bg approved',
                              'analyst approved + bg denied',
                              'analyst approved'
                            ];
      const submittedApp = this.applicationData.find((app: any) => {
        if (app.bg_required === true) {
          const statusLower = (app.application_status || '').toLowerCase();
          return !closedStatuses.includes(statusLower);
        } else {
          const statusString = (app.cd_application_status || '').toString();
          return !closedCdStatuses.includes(statusString);
        }
      });

      if (submittedApp && !submittedApp?.is_archived) {
        this.openShowSubmittedModal();
        return;
      }

      // Check for existing draft application (same logic as Start New Application)
      const draftApp = this.applicationData.find(
        (app: any) => (app.application_status || '').toLowerCase() === 'in progress, not submitted'
      );

      if (draftApp) {
        this.isResolveFlow = true;
        this.selectedDraftApplicationType = draftApp.application_type || '';
        this.draftApplication = draftApp;
        this.showDraftModal = true;
        return;
      }
    }

    this.loaderService.show();
    const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
    const userId = user?.id;

    if (!userId) {
      this.loaderService.hide();
      this.alertService.error('User information not found. Please login again.');
      return;
    }

    this.myAppService.getPerson(userId).subscribe({
      next: (personResponse) => {
        const personData = personResponse.data[0];
        if (!personData) {
          this.loaderService.hide();
          this.alertService.error('Person data not found. Please try again.');
          return;
        }

        this.sessionStorage.setObj('personData', personData);

        this.myAppService.setupResolveApplication(userId).subscribe({
          next: (response) => {
             if (!response?.data?.success) {
              this.loaderService.hide();
              this.alertService.error(response?.data?.message || 'Failed to create Resolve application.');
              return;
            }

            const newApplication = response.data.data;
            const newApplicationId = newApplication.application_id;
            console.log('[RESOLVE] Application created successfully via SP:', newApplicationId);

            const appTypeValue = 'Resolve';
            this.sessionStorage.setItem('applicationType', JSON.stringify(appTypeValue));
            this.sessionStorage.setItem('youthID', JSON.stringify(newApplicationId));
            this.sessionStorage.setItem('youthNumber', JSON.stringify(newApplication.application_number));
            this.sessionStorage.setItem('applicationID', JSON.stringify(newApplicationId));
            this.sessionStorage.setItem('gridAction', null);
            this.dataStoreService.setData('gridAction', '');
            this.sessionStorage.setItem('currApplicationType', JSON.stringify(appTypeValue));
            this.sessionStorage.setItem('applicationStatus', JSON.stringify('In Progress, Not Submitted'));

            const licensePath = newApplication.license_path;
            if (licensePath !== undefined && licensePath !== null && String(licensePath) !== '') {
              this.sessionStorage.setItem('license-path', String(licensePath));
              console.log('[RESOLVE] Stored license-path in session:', licensePath);
            }

            const resolveBaseAppTypeKey = newApplication.resolve_base_application_type;
            if (resolveBaseAppTypeKey && this.applicationtypes?.length > 0) {
              const matchedType = this.applicationtypes.find(type => String(type.key) === String(resolveBaseAppTypeKey));
              const resolveBaseAppTypeValue = matchedType ? matchedType.value : resolveBaseAppTypeKey;
              this.sessionStorage.setItem('resolve_base_application_type', JSON.stringify(resolveBaseAppTypeValue));
              console.log('[RESOLVE] Stored resolve_base_application_type:', resolveBaseAppTypeValue);
            }

            const suffixValue = this.getSuffixByKey(personData.cd_suffix);
            const educatorName = `${this.toProperCase(personData.first_name || '')} ${this.toProperCase(personData.middle_name || '')} ${this.toProperCase(personData.last_name || '')} ${suffixValue}`.trim();
            const bannerEducatorName = `${this.toProperCase(personData.first_name || '')} ${this.toProperCase(personData.last_name || '')}`.trim();

            const bannerheader: any = {
              'Application ID': newApplication.application_number,
              'Application Type': appTypeValue,
              'Educator Name': bannerEducatorName,
              'Created Date': this.getFormattedDate(newApplication.created_date)
            };

            // Do not include License Path in banner for Resolve applications

            if (this.license?.number) {
              bannerheader['License Number'] = this.license.number;
            }

            // Set cd_license_type in session storage
            const cdLicenseTypeForSession = this.preferredCdLicenseTypeForSession || this.license?.type;
            if (cdLicenseTypeForSession) {
              this.sessionStorage.setItem('cd_license_type', cdLicenseTypeForSession);
              console.log('[RESOLVE] Stored cd_license_type in session:', cdLicenseTypeForSession);
            }

            const inputFormatForAppData = {
              bannerheader: bannerheader
            };

            this.sessionStorage.setObj('navigationData', inputFormatForAppData);
            this.sessionStorage.setObj('backToHome', '/pages/my-app');
            this.sessionStorage.setItem('backButtonText', 'Close');
            this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/my-app' }));
            this.sessionStorage.setItem('isFirstSave', 'false');
            this.fetchAndSetApplicationFee(licensePath || '3');

            this.loaderService.hide();
            const activeversionid = newApplication.activeversionid;
            this.router.navigate([`/pages/dynamic-routing/tab/${activeversionid}`]);
          },
          error: (error) => {
            this.loaderService.hide();
            console.error('[RESOLVE] Error creating Resolve application:', error);
            this.alertService.error('Failed to create Resolve application. Please try again.');
          }
        });
      },
      error: (error) => {
        this.loaderService.hide();
        console.error('[RESOLVE] Error getting person data:', error);
        this.alertService.error('Failed to get person data. Please try again.');
      }
    });
  }
 private findKeyByValue(dataArray: any[], targetValue: string): any {
    const foundItem = dataArray.find(item => item.value === targetValue);
    return foundItem ? foundItem.key : null;
  }
private fetchAndSetApplicationFee(licensePath: string): void {
    this.httpService.get('/domain/lookup?requestType=FEE_CATEGORY').pipe(take(1)).subscribe({
      next: (res: any) => {
        const data = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
        const feeKeyMap: Record<string, string> = { '1': '2', '2': '7', '3': '1', '4': '8' };
        const feeKey = feeKeyMap[licensePath] || '1';
        const feeRow = data.find((item: any) => String(item.key) === feeKey);
        if (feeRow) {
          const opt = typeof feeRow.optionaldata === 'string' ? JSON.parse(feeRow.optionaldata) : feeRow.optionaldata;
          const baseFee = Number(opt?.fee) || 0;
          this.sessionStorage.setItem('applicationTotalFee', JSON.stringify(baseFee));
          this.sessionStorage.setItem('applicationFee', JSON.stringify(baseFee));
        }
        const bgCheckRow = data.find((item: any) => String(item.key) === '6');
        if (bgCheckRow) {
          const bgOpt = typeof bgCheckRow.optionaldata === 'string' ? JSON.parse(bgCheckRow.optionaldata) : bgCheckRow.optionaldata;
          this.sessionStorage.setItem('backgroundCheckFee', JSON.stringify(Number(bgOpt?.fee) || 0));
        }
        const hasApprovedExtension = JSON.parse(this.sessionStorage.getItem('has_approved_extension') || 'false');
        if (licensePath === '1' && hasApprovedExtension) {
          const extRow = data.find((item: any) => String(item.key) === '4');
          if (extRow) {
            const extOpt = typeof extRow.optionaldata === 'string' ? JSON.parse(extRow.optionaldata) : extRow.optionaldata;
            this.sessionStorage.setItem('extensionFee', JSON.stringify(Number(extOpt?.fee) || 0));
          }
        }
      }
    });
  }
  private getFormattedDate(created_date: any): string {
    const currDate = new Date(created_date);
    const month = (currDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currDate.getDate().toString().padStart(2, '0');
    const year = currDate.getFullYear();
    return `${month}/${day}/${year}`;
  }
  // viewCaseCommunicationPDF(row: any): void {
  //   if (!row?.id) {
  //     this.alertService.error('Application ID is missing.');
  //     return;
  //   }
  //   this.loaderService.show();
  //   const applicationId = row.id;
  //   this.myAppService
  //     .getCommunicationData(applicationId)
  //     .subscribe({
  //       next: (response: any) => {
  //         const data = response?.data || [];
  //         const container = document.createElement('div');
  //         container.style.position = 'absolute';
  //         container.style.left = '-99999px';
  //         container.style.top = '0';
  //         container.style.width = '900px';
  //         container.innerHTML = this.generateCaseCommunicationHtml(data);
  //         document.body.appendChild(container);
  //         setTimeout(() => {
  //           this.loaderService.show();
  //           html2canvas(container, { scale: 2, useCORS: true, backgroundColor: '#fff' }).then(canvas => {
  //             const imgData = canvas.toDataURL('image/jpeg', 1.0);
  //             const pdf = new jsPDF('p', 'mm', 'a4');
  //             const pageWidth = 210;
  //             const imgProps = pdf.getImageProperties(imgData);
  //             const pdfWidth = pageWidth;
  //             const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //             pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
  //             const blob = pdf.output('blob');
  //             const blobUrl = URL.createObjectURL(blob);
  //             window.open(blobUrl, '_blank');
  //             document.body.removeChild(container);
  //           });
  //           this.loaderService.hide();
  //         }, 0);
  //         this.loaderService.hide();
  //       },
  //       error: (_err) => {
  //         this.loaderService.hide();
  //         this.alertService.error('Failed to fetch case communication data.');
  //       }
  //     });
  // }
//   viewCaseCommunicationPDF(row: any): void {
//   if (!row?.id) {
//     this.alertService.error('Application ID not found.');
//     return;
//   }
//   this.loaderService.show();
//   const applicationId = row.id;

//   // Call the API to get the PDF blob
//   this.http.get(`${this.httpService.url}/registration/case-communication/pdf/${applicationId}`, { responseType: 'blob' })
//     .pipe(take(1))
//     .subscribe({
//       next: (response: Blob) => {
//         this.loaderService.hide();
//         // Create a blob URL for the PDF
//         this.pdfBlobObjectUrl = window.URL.createObjectURL(response);
//         this.pdfBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(response));
//         this.showPdfPreviewModal = true;
//       },
//       error: (_err) => {
//         this.loaderService.hide();
//         this.alertService.error('Failed to load PDF.');
//       }
//     });
// }

// // Add a method to close the modal and revoke the blob URL
// closePdfPreview(): void {
//  if (this.pdfBlobObjectUrl) {
//   window.URL.revokeObjectURL(this.pdfBlobObjectUrl);
//   this.pdfBlobObjectUrl = null;
// }
// this.pdfBlobUrl = null;
// this.showPdfPreviewModal = false;
// }

viewCaseCommunicationPDF(row: any): void {
  if (!row?.id) {
    this.alertService.error('Application ID is missing.');
    return;
  }
  this.loaderService.show();
  const applicationId = row.id;
  this.http.get(`${this.httpService.url}/registration/case-communication/pdf/${applicationId}`, { responseType: 'blob' })
    .subscribe({
      next: (response: Blob) => {
        if (this.originalBlobUrl) {
          URL.revokeObjectURL(this.originalBlobUrl);
        }
        this.originalBlobUrl = URL.createObjectURL(response);
        this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.originalBlobUrl);
        this.loaderService.hide();
        this.modalService.open(this.pdfPreviewModal, { size: 'xl', centered: true });
      },
      error: () => {
        this.loaderService.hide();
        this.alertService.error('Failed to fetch PDF.');
      }
    });
}

closePdfPreview(): void {
  if (this.originalBlobUrl) {
    URL.revokeObjectURL(this.originalBlobUrl);
    this.originalBlobUrl = null;
    this.sanitizedPdfUrl = null;
  }
  this.modalService.dismissAll();
}

  private generateCaseCommunicationHtml(commLogs: any[]): string {
    let html = `<div style='font-family:sans-serif;padding:24px;'><h2>Case Communication</h2><table border='1' cellpadding='8' cellspacing='0' style='border-collapse:collapse;width:100%;font-size:13px;'><thead><tr><th style="background:#E6F3FD;padding-left:10px;">Application ID</th><th style="background:#E6F3FD;padding-left:10px;">Date</th><th style="background:#E6F3FD;padding-left:10px;">Text</th><th style="background:#E6F3FD;padding-left:10px;">Created By</th></tr></thead><tbody>`;

    if (!commLogs || !commLogs.length) {
      html += `<tr><td style="padding-left:10px;">&nbsp;</td><td style="padding-left:10px;">&nbsp;</td><td style="padding-left:10px;padding-top:8px;">&nbsp;</td><td style="padding-left:10px;">&nbsp;</td></tr>`;
    } else {
      for (const log of commLogs) {
        html += `<tr><td style="padding-left:10px;">${log.application_id || ''}</td><td style="padding-left:10px;">${log.created_date || ''}</td><td style="padding-left:10px;padding-top:10px !important;">${log.communication_text || ''}</td><td style="padding-left:10px;">${log.created_by_name || ''}</td></tr>`;
      }
    }

    html += '</tbody></table></div>';
    return html;
  }

  private initializeLicenseGridConfig(): void {
    const stringSearch = { isSearchEnable: true, type: 'string' };
    const dateSearch = { isSearchEnable: true, type: 'date' };
    const dateType = 'date';

    const fallbackLicenseHeaders = [
      { dataField: 'licenseType', caption: 'License Type', label: 'License Type', allowSearch: stringSearch },
      { dataField: 'licenseKind', caption: 'License Kind', label: 'License Kind', allowSearch: stringSearch },
      { dataField: 'endorsementGrade', caption: 'Endorsement - Grade', label: 'Endorsement - Grade', allowSearch: stringSearch },
      { dataField: 'endorsementPathway', caption: 'Endorsement Pathway', label: 'Endorsement Pathway', allowSearch: stringSearch },
      { dataField: 'originalEffectiveDate', caption: 'Original Effective Date', label: 'Original Effective Date', allowSearch: dateSearch, dataType: dateType },
      { dataField: 'effectiveDate', caption: 'Effective Date', label: 'Effective Date', allowSearch: dateSearch, dataType: dateType },
      { dataField: 'expirationDate', caption: 'Expiration Date', label: 'Expiration Date', allowSearch: dateSearch, dataType: dateType },
      { dataField: 'endorsementStatus', caption: 'Endorsement Status', label: 'Endorsement Status', allowSearch: stringSearch },
      { dataField: 'extensionStatus', caption: 'Extension Status', label: 'Extension Status', allowSearch: stringSearch }
    ];

    const applyLicenseGridHeaders = (licenseHeaders: any[]): void => {
      this.licenseAllColumns = licenseHeaders.map((header: any) => ({
        key: header.dataField,
        label: header.label
      }));

      this.licenseVisibleColumns = {};
      this.licenseAllColumns.forEach(column => {
        this.licenseVisibleColumns[column.key] = true;
      });

      this.licenseDataGridConfig = DataGridVO.create({
        customHeaders: licenseHeaders,
        visibleColumns: this.licenseVisibleColumns,
        data: [],
        showActionsColumn: false,
        showQueueActions: false,
        showSearchRow: true,
        showFiltering: true,
        showPaging: true,
        customPageSize: 5,
        customPageSizes: [5, 10, 15],
        customNoDataText: 'No records'
      });

      this.refreshLicenseGridData();
    };

    applyLicenseGridHeaders(fallbackLicenseHeaders);

    this.http.get<any>('assets/metadata/application-dashboard-headers.json.json')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (json) => {
          const metadataHeaders = Array.isArray(json?.licenseHeaders) ? json.licenseHeaders : [];
          if (!metadataHeaders.length) {
            return;
          }

          const normalizedHeaders = metadataHeaders.map((header: any) => ({
            ...header,
            label: header.label || header.caption || header.dataField,
            caption: header.caption || header.label || header.dataField,
            allowSearch: header.allowSearch || { isSearchEnable: true, type: 'string' }
          }));

          applyLicenseGridHeaders(normalizedHeaders);
          this.cdr.detectChanges();
        },
        error: () => {
          // Keep fallback headers when metadata load fails.
        }
      });
  }

  private initializeLicenseKindGridConfig(): void {
    const stringSearch = { isSearchEnable: true, type: 'string' };
    const dateSearch = { isSearchEnable: true, type: 'date' };
    const dateType = 'date';

    const fallbackLicenseKindHeaders = [
      { dataField: 'licenseType', caption: 'License Type', label: 'License Type', allowSearch: stringSearch },
      { dataField: 'licenseKind', caption: 'License Kind', label: 'License Kind', allowSearch: stringSearch },
      { dataField: 'endorsementGrade', caption: 'Endorsement - Grade', label: 'Endorsement - Grade', allowSearch: stringSearch },
      { dataField: 'originalEffectiveDate', caption: 'Original Effective Date', label: 'Original Effective Date', allowSearch: dateSearch, dataType: dateType },
      { dataField: 'effectiveDate', caption: 'Effective Date', label: 'Effective Date', allowSearch: dateSearch, dataType: dateType },
      { dataField: 'expirationDate', caption: 'Expiration Date', label: 'Expiration Date', allowSearch: dateSearch, dataType: dateType },
      { dataField: 'licenseKindStatus', caption: 'License Kind Status', label: 'License Kind Status', allowSearch: stringSearch },
      { dataField: 'extensionStatus', caption: 'Extension Status', label: 'Extension Status', allowSearch: stringSearch }
    ];

    const applyLicenseGridHeaders = (licenseKindHeaders: any[]): void => {
      this.licenseKindAllColumns = licenseKindHeaders.map((header: any) => ({
        key: header.dataField,
        label: header.label
      }));

      this.licenseKindVisibleColumns = {};
      this.licenseKindAllColumns.forEach(column => {
        this.licenseKindVisibleColumns[column.key] = true;
      });

      this.licenseKindDataGridConfig = DataGridVO.create({
        customHeaders: licenseKindHeaders,
        visibleColumns: this.licenseKindVisibleColumns,
        data: [],
        showActionsColumn: false,
        showQueueActions: false,
        showSearchRow: true,
        showFiltering: true,
        showPaging: true,
        customPageSize: 5,
        customPageSizes: [5, 10, 15],
        customNoDataText: 'No records'
      });

      this.refreshLicenseKindGridData();
    };

    applyLicenseGridHeaders(fallbackLicenseKindHeaders);

    this.http.get<any>('assets/metadata/application-dashboard-headers.json.json')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (json) => {
          const metadataHeaders = Array.isArray(json?.licenseKindHeaders) ? json.licenseKindHeaders : [];
          if (!metadataHeaders.length) {
            return;
          }

          const normalizedHeaders = metadataHeaders.map((header: any) => ({
            ...header,
            label: header.label || header.caption || header.dataField,
            caption: header.caption || header.label || header.dataField,
            allowSearch: header.allowSearch || { isSearchEnable: true, type: 'string' }
          }));

          applyLicenseGridHeaders(normalizedHeaders);
          this.cdr.detectChanges();
        },
        error: () => {
          // Keep fallback headers when metadata load fails.
        }
      });
  }

  private refreshLicenseKindGridData(): void {
    // Use the already-mapped licenseKindGridRows from mapDashboardData()
    const kindRows = Array.isArray(this.licenseKindGridRows) && this.licenseKindGridRows.length > 0
      ? this.licenseKindGridRows
      : [];

    this.licenseKindDataGridConfig = this.licenseKindDataGridConfig.updateConfig({
      data: kindRows,
      visibleColumns: { ...this.licenseKindVisibleColumns },
      _changeKey: Date.now()
    });
  }

  private refreshLicenseGridData(): void {
    const sampleRow = {
      licenseType: this.license.type || '---',
      licenseKind: this.license.strLicenseKind || '---',
      endorsementGrade: (this.license as any).strEndorsement || (Array.isArray((this.license as any).endorsements)
        ? (this.license as any).endorsements[0] || '---'
        : ((this.license as any).endorsements || '---')),
      effectiveDate: this.license.issueDate || '---',
      expirationDate: this.license.expirationDate || '---',
      endorsementStatus: this.license.strEndoStatus || '---',
      extensionStatus: this.getExtensionEligibilityStatus(this.license.expirationDate) || '---'
    };
 const sampleRows = Array.isArray(this.licenseGridRows) && this.licenseGridRows.length > 0
      ? this.licenseGridRows
      : [sampleRow];
    this.licenseDataGridConfig = this.licenseDataGridConfig.updateConfig({
      data: sampleRows,
      visibleColumns: { ...this.licenseVisibleColumns },
      _changeKey: Date.now()
    });
  }
get shouldShowExtendButton(): boolean {
    return !this.boolHideExtend;
  }

  private hasAnyEligibleExtensionStatus(): boolean {
    const normalizeStatus = (value: any): string => String(value ?? '').trim().toLowerCase();

    // Check license detail rows
    if (Array.isArray(this.licenseGridRows)) {
      for (const row of this.licenseGridRows) {
        if (normalizeStatus(row?.extensionStatus) === 'eligible') {
          return true;
        }
      }
    }

    // Check license requirements (includes both requirements and provisions)
    if (Array.isArray(this.licenseRequirements)) {
      for (const row of this.licenseRequirements) {
        if (normalizeStatus(row?.extensionStatus) === 'eligible' || normalizeStatus(row?.status) === 'eligible') {
          return true;
        }
      }
    }

    // Check license provisions separately
    if (Array.isArray(this.licenseProvisions)) {
      for (const row of this.licenseProvisions) {
        if (normalizeStatus(row?.extensionStatus) === 'eligible' || normalizeStatus(row?.status) === 'eligible') {
          return true;
        }
      }
    }

    if (normalizeStatus(this.getExtensionEligibilityStatus(this.license?.expirationDate)) === 'eligible') {
      return true;
    }

    return false;
  }

  private hasAnyRelevantExtensionStatus(): boolean {
    const normalizeStatus = (value: any): string => String(value ?? '').trim().toLowerCase();

    // Check license detail rows
    if (Array.isArray(this.licenseGridRows)) {
      for (const row of this.licenseGridRows) {
        const status = normalizeStatus(row?.extensionStatus);
        if (status === 'eligible' || status === 'ineligible') {
          return true;
        }
      }
    }

    // Check license requirements (includes both requirements and provisions)
    if (Array.isArray(this.licenseRequirements)) {
      for (const row of this.licenseRequirements) {
        const extStatus = normalizeStatus(row?.extensionStatus);
        if (extStatus === 'eligible' || extStatus === 'ineligible') {
          return true;
        }
        const rowStatus = normalizeStatus(row?.status);
        if (rowStatus === 'eligible' || rowStatus === 'ineligible') {
          return true;
        }
      }
    }

    // Check license provisions separately
    if (Array.isArray(this.licenseProvisions)) {
      for (const row of this.licenseProvisions) {
        const extStatus = normalizeStatus(row?.extensionStatus);
        if (extStatus === 'eligible' || extStatus === 'ineligible') {
          return true;
        }
        const rowStatus = normalizeStatus(row?.status);
        if (rowStatus === 'eligible' || rowStatus === 'ineligible') {
          return true;
        }
      }
    }

    const licenseStatus = normalizeStatus(this.getExtensionEligibilityStatus(this.license?.expirationDate));
    if (licenseStatus === 'eligible' || licenseStatus === 'ineligible') {
      return true;
    }

    return false;
  }

  private isLicenseExpired(expirationDate: string | Date | null | undefined): boolean {
    if (!expirationDate) {
      return false;
    }

    let parsedDate: Date;
    if (expirationDate instanceof Date) {
      parsedDate = new Date(expirationDate);
    } else {
      const raw = String(expirationDate).trim();
      if (!raw) {
        return false;
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
        const [month, day, year] = raw.split('/').map(Number);
        parsedDate = new Date(year, month - 1, day);
      } else {
        parsedDate = new Date(raw);
      }
    }

    if (Number.isNaN(parsedDate.getTime())) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    parsedDate.setHours(0, 0, 0, 0);

    return parsedDate.getTime() < today.getTime();
  }

  private isDateWithinExtensionWindow(dateValue: string | Date | null | undefined, windowDays: number): boolean {
    if (!dateValue) {
      return false;
    }

    let parsedDate: Date;
    if (dateValue instanceof Date) {
      parsedDate = new Date(dateValue);
    } else {
      const raw = String(dateValue).trim();
      if (!raw) {
        return false;
      }
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
        const [month, day, year] = raw.split('/').map(Number);
        parsedDate = new Date(year, month - 1, day);
      } else {
        parsedDate = new Date(raw);
      }
    }

    if (Number.isNaN(parsedDate.getTime())) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    parsedDate.setHours(0, 0, 0, 0);

    const diffMs = parsedDate.getTime() - today.getTime();
    const daysUntil = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return daysUntil >= 0 && daysUntil <= windowDays;
  }

  private getExtensionEligibilityStatus(expirationDate: string | Date | null | undefined, windowDays?: number): 'Eligible' | 'Ineligible' {
    if (!expirationDate) {
      return 'Ineligible';
    }

    const resolvedWindowDays = this.getResolvedExtensionWindowDays(windowDays);
    if (resolvedWindowDays <= 0) {
      return 'Ineligible';
    }

    let parsedDate: Date;
    if (expirationDate instanceof Date) {
      parsedDate = new Date(expirationDate);
    } else {
      const raw = String(expirationDate).trim();
      if (!raw) {
        return 'Ineligible';
      }

      if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
        const [month, day, year] = raw.split('/').map(Number);
        parsedDate = new Date(year, month - 1, day);
      } else {
        parsedDate = new Date(raw);
      }
    }

    if (Number.isNaN(parsedDate.getTime())) {
      return 'Ineligible';
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    parsedDate.setHours(0, 0, 0, 0);

    const diffMs = parsedDate.getTime() - today.getTime();
    const daysUntilExpiration = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    return daysUntilExpiration >= 0 && daysUntilExpiration <= resolvedWindowDays ? 'Eligible' : 'Ineligible';
  }

  private getResolvedExtensionWindowDays(windowDays?: number): number {
    const explicitWindow = Number(windowDays);
    if (Number.isFinite(explicitWindow) && explicitWindow > 0) {
      return explicitWindow;
    }
    console.log(this.extensionDuration, 'extensionDuration')
    const configuredWindow = Number(this.extensionDuration ?? this.license?.extensionDuration);
    if (Number.isFinite(configuredWindow) && configuredWindow > 0) {
      return configuredWindow;
    }

    return 0;
  }
  private loadOtpValidationRules() {
    // Fetch maximum OTP attempts
    this.manageProfileService.getBusinessRuleByKey('Licensing', 'license_extension_duration')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.extensionDuration = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching maximum OTP attempts rule:', error);
        }
      });


  }

  toggleLicenseColumnChooser(): void {
    this.showLicenseColumnChooser = !this.showLicenseColumnChooser;
  }

  closeLicenseColumnChooser(): void {
    this.showLicenseColumnChooser = false;
  }

  toggleLicenseColumn(columnKey: string): void {
    this.licenseVisibleColumns[columnKey] = !this.licenseVisibleColumns[columnKey];
    this.licenseDataGridConfig = this.licenseDataGridConfig.updateConfig({
      visibleColumns: { ...this.licenseVisibleColumns },
      _changeKey: Date.now()
    });
  }
  getSurrenderActivationId() {
    this.surrenderService.getSurrenderActivationId().pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (response) => {
        if (response && response.status === 'success') {
          this.sessionStorage.setItem('surrenderActiveversionid', JSON.stringify(response.data?.data[0]?.activeversionid));
        }
      },
      error: (error) => {
        console.error('Error getting surrender activation id:', error);
      }
    });
  }
  surrenderClick(skipDraftCheck: boolean = false){
    if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    // Reset stale flow session before starting Surrender application
    this.clearApplicationFlowSession();
    const closedCdStatuses = ['9', '11', '16', '41'];
    const closedStatuses = ['approved',
                            'denied',
                            'in progress, not submitted',
                            'automatic approved',
                            'intake pending + bg denied',
                            'deficiency pending + bg denied',
                            'analyst pending + bg denied',
                            'analyst denied + bg approved',
                            'analyst denied + bg denied',
                            'partially approved + bg approved',
                            'partially approved + bg denied',
                            'analyst approved + bg approved',
                            'analyst approved + bg denied',
                          ];
    const submittedApp = this.applicationData.find((app: any) => {
      if (app.bg_required === true) {
        const statusLower = (app.application_status || '').toLowerCase();
        const isInClosedStatuses = closedStatuses.includes(statusLower);
        return !isInClosedStatuses;
      } else {
        const statusString = (app.cd_application_status || '').toString();
        let isInClosedCdStatuses = false;
        if(app.application_type.toLowerCase() === 'surrender') {
          isInClosedCdStatuses = ['9','21','16','40'].includes(statusString);
        }else{
          isInClosedCdStatuses = closedCdStatuses.includes(statusString);
        }
         return !isInClosedCdStatuses;
      }
    });
    if (submittedApp && !submittedApp?.is_archived) {
      this.openShowSubmittedModal();
      return;
    }
     const draftApp = !skipDraftCheck ? this.applicationData.find(
      (app: any) => (app.application_status || '').toLowerCase() === 'in progress, not submitted'
    ) : null;
    if (draftApp) {
      this.draftApplication = draftApp;
      this.selectedDraftApplicationType = draftApp.application_type || draftApp.strAppType || draftApp.cd_application_type || '';
      this.isSurrenderFlow = true;
      console.log('[Draft Application - Surrender] Found draft app with type:', this.selectedDraftApplicationType, 'Full app object:', {
        application_type: draftApp.application_type,
        strAppType: draftApp.strAppType,
        cd_application_type: draftApp.cd_application_type,
        selectedType: this.selectedDraftApplicationType
      });
      this.showDraftModal = true;
      return;
    }

      this.sessionStorage.setItem('surrender', 'createSurrender');
      this.sessionStorage.setItem('surrenderMode','edit');
      const payload = {
        user_id : this.getUserId(),
        old_id : this.licenseGridRows[0].application_id,
      }
      this.surrenderService.createSurrenderApplication(payload).pipe(take(1),takeUntil(this.destroy$)).subscribe({
        next:(res:any)=>{
          this.sessionStorage.setItem('newSurrenderApplication', 'true');
          this.sessionStorage.setItem('applicationStatus','In Progress,Not Submitted');
          this.sessionStorage.setItem('showDeleteButton','true');
          this.sessionStorage.setObj('backToHome', '/pages/my-app');
          this.sessionStorage.setItem('backButtonText', 'Close');
      this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/my-app' }));
      this.sessionStorage.setItem('applicationID',JSON.stringify(res.data.data[0].p_application_id));
      this.sessionStorage.setItem('userIdForFetch',this.getUserId());
      const bannerheader: any = {
        'Application ID': res.data.data[0].p_surrender_application_number,
        'Application Type': 'Surrender',
        'Educator Name' : this.profile.bannerHeaderName,
        'Created Date' : this.commonService.getFormatedDate(res.data.data[0].p_created_date),
        'License Number': this.license.number,
      };
      const inputFormatForAppData = { bannerheader };
      this.sessionStorage.setItem('navigationData', JSON.stringify(inputFormatForAppData));
      this.router.navigate([`/pages/dynamic-routing/tab/${this.sessionStorage.getItem('surrenderActiveversionid')}`]);
      }
      })

  }
 get isExtendButtonEnabled(): boolean {
    return !!this.boolEnableExtend;
  }


 get extendButtonTooltip(): string {
    return this.isExtendButtonEnabled
      ? (this.lookupGeneric?.['G0051'] || '')
      : (this.lookupGeneric?.['G0062'] || '');
  }

  /**
   * Check if transaction is Credit or Refund type (no payment breakdown needed)
   */
  private isCreditOrRefundTransaction(rowData: any): boolean {
    const transactionType = String(rowData?.transactionType ?? rowData?.transaction_type ?? '').trim().toLowerCase();
    return transactionType === 'credit' || transactionType === 'refund';
  }

  /**
   * Build receipt data structure from transaction row and API breakdown items
   * EXACT SAME implementation as lookup-user-personal-tab
   */
  private buildTransactionReceiptData(rowData: any, breakdownItems: any[] = []): Record<string, any> {
    const raw = rowData?._raw ?? {};
    const currentDate = new Date();

    const getValueOrNA = (...values: any[]): string => {
      for (const val of values) {
        const str = String(val ?? '').trim();
        if (str) return str;
      }
      return 'N/A';
    };

    // Extract additional details from first breakdown item if available
    const firstItem = breakdownItems.length > 0 ? breakdownItems[0] : null;

    // Extract actual transaction date for all transaction types
    let actualTransactionDate: Date;

    // Try to extract the actual transaction date from the row
    if (rowData?.transaction_Date instanceof Date) {
      actualTransactionDate = rowData.transaction_Date;
    } else if (rowData?.receiptTransactionDate) {
      actualTransactionDate = new Date(rowData.receiptTransactionDate);
    } else if (rowData?.transactionDate instanceof Date) {
      actualTransactionDate = rowData.transactionDate;
    } else if (rowData?.transactionDate && typeof rowData.transactionDate === 'string') {
      actualTransactionDate = new Date(rowData.transactionDate);
    } else {
      actualTransactionDate = currentDate;
    }

    // Format transaction date with time
    const transactionDateFormatted = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }).format(actualTransactionDate);

    // For receipt date, use pre-formatted receiptDate from row if available, otherwise format the date
    let receiptDateFormatted: string;
    if (rowData?.receiptDate && typeof rowData.receiptDate === 'string' && rowData.receiptDate.trim()) {
      receiptDateFormatted = rowData.receiptDate.trim();
    } else {
      receiptDateFormatted = new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(actualTransactionDate);
    }

    return {
      applicantName: this.getUserFullName(),
      applicationId: getValueOrNA(firstItem?.application_number, rowData?.application_id, rowData?.applicationId, raw?.application_number, raw?.application_id),
      referenceNumber: getValueOrNA(rowData?.paymentTransactionId, raw?.payment_transaction_id, firstItem?.receipt_number),
      invoiceNumber: getValueOrNA(firstItem?.invoice_number, rowData?.invoice_number, raw?.invoice_number, rowData?.invoiceNumber),
      paymentMethod: firstItem?.payment_method || 'Card',
      transactionDate: transactionDateFormatted,
      paymentAmount: String(rowData?.amount ?? raw?.amount ?? '').trim(),
      transactionType: String(rowData?.transactionType ?? rowData?.transaction_type ?? raw?.transaction_type ?? '').trim(),
      receiptDate: receiptDateFormatted,
      breakdownItems: breakdownItems
    };
  }

  /**
   * Download transaction receipt
   * For Application Fee: Fetches breakdown items from PAYMENT_BREAKDOWN API
   * For Credit/Refund: Generates simple receipt without breakdown
   */
  downloadTransactionReceipt(rowData: any): void {
    if (!rowData) {
      this.alertService.info('Transaction data not available.');
      return;
    }

    const transactionType = String(rowData?.transactionType ?? rowData?.transaction_type ?? '').trim();

    // Check if this is Credit or Refund - no API call needed
    if (this.isCreditOrRefundTransaction(rowData)) {
      this.isGeneratingPDF = true;
      this.loaderService.show();

      // Generate simple receipt without breakdown
      const receiptData = this.buildTransactionReceiptData(rowData, []);
      void this.commonService.generateReceiptPDF(receiptData, 'download')
        .finally(() => {
          this.isGeneratingPDF = false;
          this.loaderService.hide();
        });
      return;
    }

    // Application Fee - fetch breakdown from API

    // Extract payment ID - prioritize payment_id (DB primary key) over paymentTransactionId (reference)
    const raw = rowData?._raw ?? {};
    const paymentTransactionId = rowData?.paymentId ?? rowData?.payment_id ??
                                  rowData?.paymentTransactionId ??
                                  raw?.payment_id ?? raw?.payment_transaction_id ?? raw?.payment_history_id;

    if (!paymentTransactionId) {
      this.alertService.info('Payment transaction ID not found.');
      return;
    }

    this.isGeneratingPDF = true;
    this.loaderService.show();

    // Fetch payment breakdown from API - USE CAMELCASE paymentTransactionId!

    this.httpService.post(API_ENDPOINTS.PAYMENT_BREAKDOWN, { paymentTransactionId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const breakdownItems = response?.data?.data || [];
          const receiptData = this.buildTransactionReceiptData(rowData, breakdownItems);

          void this.commonService.generateReceiptPDF(receiptData, 'download')
            .finally(() => {
              this.isGeneratingPDF = false;
              this.loaderService.hide();
            });
        },
        error: () => {
          // Fallback: generate receipt without breakdown
          const receiptData = this.buildTransactionReceiptData(rowData, []);
          void this.commonService.generateReceiptPDF(receiptData, 'download')
            .finally(() => {
              this.isGeneratingPDF = false;
              this.loaderService.hide();
            });
        }
      });
  }

  /**
   * View transaction receipt
   * For Application Fee: Fetches breakdown items from PAYMENT_BREAKDOWN API
   * For Credit/Refund: Generates simple receipt without breakdown
   */
  viewTransactionReceipt(rowData: any): void {
    if (!rowData) {
      this.alertService.info('Transaction data not available.');
      return;
    }

    const transactionType = String(rowData?.transactionType ?? rowData?.transaction_type ?? '').trim();

    // Check if this is Credit or Refund - no API call needed
    if (this.isCreditOrRefundTransaction(rowData)) {
      this.isGeneratingPDF = true;
      this.loaderService.show();

      // Generate simple receipt without breakdown
      const receiptData = this.buildTransactionReceiptData(rowData, []);
      this.commonService.generateReceiptPdfBlob(receiptData)
        .then((blob: Blob) => {
          if (this.originalBlobUrl) {
            URL.revokeObjectURL(this.originalBlobUrl);
          }

          this.originalBlobUrl = URL.createObjectURL(blob);
          this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.originalBlobUrl);
          this.modalService.open(this.pdfPreviewModal, { size: 'xl', centered: true });

          this.isGeneratingPDF = false;
          this.loaderService.hide();
        })
        .catch(() => {
          this.alertService.error('Failed to generate receipt. Please try again.');
          this.isGeneratingPDF = false;
          this.loaderService.hide();
        });
      return;
    }

    // Application Fee - fetch breakdown from API

    // Extract payment ID - prioritize payment_id (DB primary key) over paymentTransactionId (reference)
    const raw = rowData?._raw ?? {};
    const paymentTransactionId = rowData?.paymentId ?? rowData?.payment_id ??
                                  rowData?.paymentTransactionId ??
                                  raw?.payment_id ?? raw?.payment_transaction_id ?? raw?.payment_history_id;

    if (!paymentTransactionId) {
      this.alertService.info('Payment transaction ID not found.');
      return;
    }

    this.isGeneratingPDF = true;
    this.loaderService.show();

    // Fetch payment breakdown from API - USE CAMELCASE paymentTransactionId!

    this.httpService.post(API_ENDPOINTS.PAYMENT_BREAKDOWN, { paymentTransactionId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const breakdownItems = response?.data?.data || [];
          const receiptData = this.buildTransactionReceiptData(rowData, breakdownItems);

          // Generate PDF blob and display in modal
          this.commonService.generateReceiptPdfBlob(receiptData)
            .then((blob: Blob) => {
              // Clean up previous blob URL if exists
              if (this.originalBlobUrl) {
                URL.revokeObjectURL(this.originalBlobUrl);
              }

              // Create new blob URL and display in modal
              this.originalBlobUrl = URL.createObjectURL(blob);
              this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.originalBlobUrl);
              this.modalService.open(this.pdfPreviewModal, { size: 'xl', centered: true });

              this.isGeneratingPDF = false;
              this.loaderService.hide();
            })
            .catch(() => {
              this.alertService.error('Failed to generate receipt. Please try again.');
              this.isGeneratingPDF = false;
              this.loaderService.hide();
            });
        },
        error: () => {
          // Fallback: generate receipt without breakdown
          const receiptData = this.buildTransactionReceiptData(rowData, []);
          this.commonService.generateReceiptPdfBlob(receiptData)
            .then((blob: Blob) => {
              if (this.originalBlobUrl) {
                URL.revokeObjectURL(this.originalBlobUrl);
              }

              this.originalBlobUrl = URL.createObjectURL(blob);
              this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.originalBlobUrl);
              this.modalService.open(this.pdfPreviewModal, { size: 'xl', centered: true });

              this.isGeneratingPDF = false;
              this.loaderService.hide();
            })
            .catch(() => {
              this.alertService.error('Failed to generate receipt. Please try again.');
              this.isGeneratingPDF = false;
              this.loaderService.hide();
            });
        }
      });
  }

  isLicenseExtension(appType: string): boolean {
    if (!appType) return false;
    // Check both the key ('7') and the display value ('License Extension')
    return appType === '7' || appType === 'License Extension';
  }

  toggleLicenseKindColumnChooser(): void {
    this.showLicenseKindColumnChooser = !this.showLicenseKindColumnChooser;
  }

  closeLicenseKindColumnChooser(): void {
    this.showLicenseKindColumnChooser = false;
  }

  toggleLicenseKindColumn(columnKey: string): void {
    this.licenseKindVisibleColumns[columnKey] = !this.licenseKindVisibleColumns[columnKey];
    this.licenseKindDataGridConfig = this.licenseKindDataGridConfig.updateConfig({
      visibleColumns: { ...this.licenseKindVisibleColumns },
      _changeKey: Date.now()
    });
  }

  onLicenseKindExport(): void {
    const columns = this.licenseKindAllColumns.filter(col => this.licenseKindVisibleColumns[col.key]);
    if (columns.length === 0 || this.licenseKindGridRows.length === 0) return;

    const header = columns.map(col => col.label);
    const data = this.licenseKindGridRows.map(row => {
      return columns.map(col => {
        const v = (row as any)[col.key] ?? (row as any)[col.key.toLowerCase()] ?? '';
        if (v instanceof Date) {
          return this.formatDate(v);
        }
        return typeof v === 'object' ? JSON.stringify(v) : String(v);
      });
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');
    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
    data.forEach(r => { worksheet.addRow(r); });
    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });
    worksheet.columns.forEach(col => { (col as any).width = 30; });
    workbook.xlsx.writeBuffer().then(buffer => {
      FileSaver.saveAs(new Blob([buffer]), 'license-kinds.xlsx');
    });
  }

  onEndorsementExport(): void {
    const columns = this.licenseAllColumns.filter(col => this.licenseVisibleColumns[col.key]);
    if (columns.length === 0 || this.licenseGridRows.length === 0) return;

    const header = columns.map(col => col.label);
    const data = this.licenseGridRows.map(row => {
      return columns.map(col => {
        const v = (row as any)[col.key] ?? (row as any)[col.key.toLowerCase()] ?? '';
        if (v instanceof Date) {
          return this.formatDate(v);
        }
        return typeof v === 'object' ? JSON.stringify(v) : String(v);
      });
    });

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet 1');
    const headerRow = worksheet.addRow(header);
    headerRow.font = { bold: true };
    headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
    data.forEach(r => { worksheet.addRow(r); });
    worksheet.eachRow(row => {
      row.eachCell(cell => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
      });
    });
    worksheet.columns.forEach(col => { (col as any).width = 30; });
    workbook.xlsx.writeBuffer().then(buffer => {
      FileSaver.saveAs(new Blob([buffer]), 'endorsements.xlsx');
    });
  }

   parseEndorsementGrades(endorsementString: string): string[] {
    if (!endorsementString || typeof endorsementString !== 'string') {
      return [];
    }

    return endorsementString
      .split(',')
      .map((item: string) => {
        const trimmed = item.trim();
        // Match pattern: "Name (Grade)"
        const match = trimmed.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
        if (match) {
          const name = match[1].trim();
          const grade = match[2].trim();
          return `${name} – ${grade}`;
        }
        // If no match, return as-is
        return trimmed;
      })
      .filter((item: string) => item.length > 0);
  }

  /* Add Endrosement button enable logic*/
  private canAddEndorsement() {
    const today = new Date();
    const threeMonthsFromNow = new Date(today);
    threeMonthsFromNow.setMonth(today.getMonth() + 3);
    const isExpiringSoon = this.latestLicenseExpirydate ? (new Date(this.latestLicenseExpirydate) <= threeMonthsFromNow) : false;
    const applicationType = String(this.applicationData[0]?.application_type || '').trim();
    const isSubstitute = this.license.type === 'Substitute';
    const isAlternative = this.license.strLicenseKind === 'Alternative';
    console.log('this.endroseflag',this.endroseflag);
    console.log('isExpiringSoon',isExpiringSoon);
    this.isEnableEndoresment = this.endroseflag && !isExpiringSoon;
  }

  storeOldApplicationIdAndLoadEndorsement(): void {
    // Resolve numeric application_id from applicationData for the approved app.
    // this.license?.application_id is the application_number string (e.g. "A26-006901"),
    // not the integer id, so we look it up via applicationData which carries the numeric id.
    const approvedApp = this.applicationData?.find((app: any) =>
      (app.application_status || '').toLowerCase() === 'approved'
    );
    const oldAppId = approvedApp?.dnqapplicationId ?? approvedApp?.id ??
      this.sessionStorage.getItem('applicationID');
    if (oldAppId) {
      this.sessionStorage.setItem('oldapplicationID', String(oldAppId));
    }
    this.loadLicenseEndorsement();
  }

loadLicenseEndorsement(skipDraftCheck: boolean = false): void {
  if (this.commonService.getLegacyFlag()) {
      this.runLegacyUserLogic();
      return;
    }
    if (!skipDraftCheck) {
      // Check for existing submitted (non-closed) application (same logic as Start New Application)
      const closedCdStatuses = ['9', '11', '16', '41'];
      const closedStatuses = ['approved',
                              'denied',
                              'in progress, not submitted',
                              'automatic approved',
                              'intake pending + bg denied',
                              'deficiency pending + bg denied',
                              'analyst pending + bg denied',
                              'analyst denied + bg approved',
                              'analyst denied + bg denied',
                              'partially approved + bg approved',
                              'partially approved + bg denied',
                              'analyst approved + bg approved',
                              'analyst approved + bg denied',
                              'analyst approved'
                            ];
      const submittedApp = this.applicationData.find((app: any) => {
        if (app.bg_required === true) {
          const statusLower = (app.application_status || '').toLowerCase();
          return !closedStatuses.includes(statusLower);
        } else {
          const statusString = (app.cd_application_status || '').toString();
          return !closedCdStatuses.includes(statusString);
        }
      });

      if (submittedApp && !submittedApp?.is_archived) {
        this.openShowSubmittedModal();
        return;
      }

      // Check for existing draft application (same logic as Start New Application)
      const draftApp = this.applicationData.find(
        (app: any) => (app.application_status || '').toLowerCase() === 'in progress, not submitted'
      );

      if (draftApp) {
        this.isAddEndroseFlow = true;
        this.selectedDraftApplicationType = draftApp.application_type || '';
        this.draftApplication = draftApp;
        this.showDraftModal = true;
        return;
      }
    }

    this.loaderService.show();
    const user = JSON.parse(this.sessionStorage.getItem('user') || '{}');
    const userId = user?.id;

    if (!userId) {
      this.loaderService.hide();
      this.alertService.error('User information not found. Please login again.');
      return;
    }

    this.myAppService.getPerson(userId).subscribe({
      next: (personResponse) => {
        const personData = personResponse.data[0];
        if (!personData) {
          this.loaderService.hide();
          this.alertService.error('Person data not found. Please try again.');
          return;
        }

        this.sessionStorage.setObj('personData', personData);

        this.myAppService.setupEndroseeApplication(userId).subscribe({
          next: (response) => {
             if (!response?.data?.success) {
              this.loaderService.hide();
              this.alertService.error(response?.data?.message || 'Failed to create License Endrosement application.');
              return;
            }
            const newApplication = response.data.data;
            const newApplicationId = newApplication.application_id;
            console.log('[LICENSEENDROSEMENT] Application created successfully via SP:', newApplicationId);

            const appTypeValue = 'Add Endorsement';
            this.sessionStorage.setItem('applicationType', JSON.stringify(appTypeValue));
            this.sessionStorage.setItem('youthID', JSON.stringify(newApplicationId));
            this.sessionStorage.setItem('youthNumber', JSON.stringify(newApplication.application_number));
            this.sessionStorage.setItem('applicationID', JSON.stringify(newApplicationId));
            this.sessionStorage.setItem('gridAction', null);
            this.dataStoreService.setData('gridAction', '');
            this.sessionStorage.setItem('currApplicationType', JSON.stringify(appTypeValue));
            this.sessionStorage.setItem('applicationStatus', JSON.stringify('In Progress, Not Submitted'));

            const licensePath = newApplication.license_path;
            if (licensePath) {
              this.sessionStorage.setItem('license-path', licensePath.toString());
              console.log('[LICENSEENDROSE] Stored license-path:', licensePath);
            }

            const addBaseAppTypeKey = newApplication.add_base_application_type;
            if (addBaseAppTypeKey && this.applicationtypes?.length > 0) {
              const matchedType = this.applicationtypes.find(type => String(type.key) === String(addBaseAppTypeKey));
              const addBaseAppTypeValue = matchedType ? matchedType.value : addBaseAppTypeKey;
              this.sessionStorage.setItem('add_base_application_type', JSON.stringify(addBaseAppTypeValue));
              console.log('[LICENSE ENDROSE] Stored add_base_application_type:', addBaseAppTypeValue);
            }

            const suffixValue = this.getSuffixByKey(personData.cd_suffix);
            const educatorName = `${this.toProperCase(personData.first_name || '')} ${this.toProperCase(personData.last_name || '')}`.trim();

            const bannerheader: any = {
              'Application ID': newApplication.application_number,
              'Application Type': appTypeValue,
              'Educator Name': educatorName,
              'Created Date': this.getFormattedDate(newApplication.created_date)
            };

            if (licensePath && licensePath !== 'null') {
              const licensePathLabel = this.getLicensePathLabel(licensePath);
              bannerheader['License Path'] = licensePathLabel;
            }

            if (this.license?.number) {
              bannerheader['License Number'] = this.license.number;
            }

            const inputFormatForAppData = {
              bannerheader: bannerheader
            };

            this.sessionStorage.setObj('navigationData', inputFormatForAppData);
            this.sessionStorage.setObj('backToHome', '/pages/my-app');
            this.sessionStorage.setItem('backButtonText', 'Close');
            this.sessionStorage.setItem('backToGridPage', JSON.stringify({ name: '/my-app' }));
            this.sessionStorage.setItem('isFirstSave', 'false');
            this.fetchAndSetApplicationFee(licensePath || '3');

            this.loaderService.hide();
            const activeversionid = newApplication.activeversionid;
            this.router.navigate([`/pages/dynamic-routing/tab/${activeversionid}`]);
          },
          error: (error) => {
            this.loaderService.hide();
            console.error('[LICENSE ENDROSE] Error creating License Endrosement application:', error);
            this.alertService.error('Failed to create License Endrosement application. Please try again.');
          }
        });
      },
      error: (error) => {
        this.loaderService.hide();
        console.error('[LicenseEndrosement] Error getting person data:', error);
        this.alertService.error('Failed to get person data. Please try again.');
      }
    });
  }

private calculateLicenseStatus(gridLicenseRows: any[], gridLicenseKindRows: any[]): 'Active' | 'Inactive' {
    // Check if ALL endorsements are Inactive (displayed in the grid)
    const allEndorsementsInactive = Array.isArray(gridLicenseRows) && gridLicenseRows.length > 0
      ? gridLicenseRows.every((row: any) => (row?.endorsementStatus || '').toLowerCase() === 'inactive')
      : true;

    // Check if ALL license kinds are Inactive (displayed in the grid)
    const allLicenseKindsInactive = Array.isArray(gridLicenseKindRows) && gridLicenseKindRows.length > 0
      ? gridLicenseKindRows.every((row: any) => (row?.licenseKindStatus || '').toLowerCase() === 'inactive')
      : true;

    // License is Inactive ONLY if ALL items in both arrays are Inactive
    // Otherwise, if there are any Active records displayed, license is Active
    return (allEndorsementsInactive && allLicenseKindsInactive) ? 'Inactive' : 'Active';
  }

   private getDisplayEligibilityStatus(status: any): string {
    if (!status) {
      return '';
    }

    const normalizedValue = String(status).trim().toLowerCase();

    if (normalizedValue === 'ineligible') {
      return 'Not Eligible';
    }

    if (normalizedValue === 'eligible') {
      return 'Eligible';
    }
    return String(status);
  }

  private validateLicenseDateWithDB(onValidationSuccess: () => void): void {
    const userId = this.getUserId();

    if (!userId) {
      this.loaderService.hide();
      this.alertService.error('User ID is missing');
      return;
    }

    // Fetch ALL license records from backend using DASHBOARD_DATA endpoint
    this.httpService.post(API_ENDPOINTS.DASHBOARD_DATA, { userId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          console.log('[VALIDATION] Response from DASHBOARD_DATA:', response);

          // Response structure: response.data.data[0].Obj_License
          const dashboardData = response?.data?.data?.[0];
          const licenseData = dashboardData?.Obj_License;

          if (licenseData) {
            // Get all license records (same logic as mapDashboardData)
            const licenseRows = Array.isArray(licenseData)
              ? licenseData
              : [licenseData];

            console.log('[VALIDATION] All license records from DB:', licenseRows);

            // Apply SAME filtering logic as dashboard (find extendable OR first record)
            const backendLicense = licenseRows.find((row: any) => row?.boolIsExtend === true) || licenseRows[0] || {};

            if (backendLicense && backendLicense.dtExpiryDate) {
              // Normalize both dates for comparison
              const dbDate = this.normalizeDateForComparison(backendLicense.dtExpiryDate);
              const frontendDate = this.normalizeDateForComparison(this.license.expirationDate);

              console.log('[VALIDATION] DB Expiry Date:', dbDate);
              console.log('[VALIDATION] Frontend Expiry Date:', frontendDate);
              console.log('[VALIDATION] DB License Number:', backendLicense.strLicenseNumber);
              console.log('[VALIDATION] DB boolIsExtend:', backendLicense.boolIsExtend);

              // Compare dates
              if (dbDate === frontendDate) {
                console.log('[VALIDATION] ✅ Dates match - Proceeding with extension');
                onValidationSuccess();  // ← Extend the license
              } else {
                this.loaderService.hide();
                this.alertService.error(
                  `Updates made by staff member, Please refresh and try again.`
                );
              }
            } else {
              this.loaderService.hide();
              this.alertService.error('No valid license found in database');
            }
          } else {
            this.loaderService.hide();
            console.error('[VALIDATION] License data not found in response:', response);
            this.alertService.error('Unable to fetch license data from database. Please try again.');
          }
        },
        (error) => {
          this.loaderService.hide();
          this.alertService.error('Error validating license date');
          console.error('[VALIDATION ERROR]', error);
        }
      );
  }

  private normalizeDateForComparison(dateValue: any): string {
    if (!dateValue) return '';

    try {
      const parsed = moment(dateValue, ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601]);
      if (parsed.isValid()) {
        return parsed.format('MM/DD/YYYY');
      }
    } catch (e) {
      console.warn('Error normalizing date:', dateValue);
    }

    return String(dateValue || '').trim();
  }

  get surrenderButtonTooltip(): string {
    return this.lookupGeneric?.['G0068'] || 'Surrender License Kind or Endorsement';
  }

  private formatAmount(value: any): string {
    if (value == null || value === '') return '$0';
    const num = parseFloat(String(value).replace(/[$,]/g, ''));
    return Number.isFinite(num) ? '$' + Math.floor(num) : '$0';
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
